<template>

  <div class="d-flex">
    <div ref="tree"></div>
    <div class="actionButtons" ref="buttons"></div>
    <div class="datasetList" ref="buttonsList"></div>
    <mm-drawer v-model="isDrawerOpen" value :minimizable="false" :minimized="false" fixed :full="false"
      position="right">
      <div class="infoPanel">

        <div class="d-flex justify-end closeBtn">
          <mm-button @click="closeOverlay" objective="destructive" class="m-x-2 m-y-2" icon="close" size="small" />
        </div>
        <div class="card p-y-6">
          <div class="para p-x-6">
            <p class="customWidth">
              {{ itemId }}
            </p>
          </div>
        </div>

        <div v-if="dataShowInDrawer !== null">
          <div v-if="dataShowInDrawer.type == 'dataset'" class="card p-x-6 p-y-6">
            <div class="para m-y-2">
              <div class="heading">
                Name:
              </div>
              {{ dataShowInDrawer.properties.batches[0].name }}
            </div>
            <div class="para">
              <div class="heading">
                Rows:
              </div>
              {{ dataShowInDrawer.properties.batches[0].row_count }}
            </div>
          </div>
          <div v-if="dataShowInDrawer.type == 'dataview'" class="card p-x-6 p-y-6">
            <div class="para m-y-2">
              <div class="heading">
                Name:
              </div>
              {{ dataShowInDrawer.name }}
            </div>
            <div class="para">
              <div class="heading">
                Tasks:
              </div>
              {{ dataShowInDrawer.properties.no_of_tasks }}
            </div>
          </div>
          <div v-if="dataShowInDrawer.source || dataShowInDrawer.target" class="card p-x-6 p-y-6">
            <div class="para m-y-2">
              <div class="heading">
                Source:
              </div>
              <p class="customWidth">
                {{ dataShowInDrawer.source }}
              </p>
            </div>
            <div class="para">
              <div class="heading">
                target:
              </div>
              <p class="customWidth">
                {{ dataShowInDrawer.target }}
              </p>
            </div>
          </div>
        </div>

      </div>
    </mm-drawer>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue';
import * as d3 from 'd3';
// Import images from your assets folder.
import rootIcon from '@/assets/root-icon.png';
import leafIcon from '@/assets/leaf-icon.png';
import collapse from '@/assets/collapse.png';
import expand from '@/assets/expand.png';
import fileUploadIcon from '@/assets/fileUploadIcon.png'


export default defineComponent({
  name: 'TreeChart',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const tree = ref(null);
    const isDrawerOpen = ref(false);
    let dataShowInDrawer = ref({});
    let itemId = ref('');
    let svg;         // Outer SVG.
    let container;   // Inner group holding tree elements.
    let root;
    let treeDataLayout;
    let treemap;
    let selectedDatasetIds = new Set();
    let clickedDatasetIds = new Set();

    const dataCopy = JSON.parse(JSON.stringify(props.data));
    let graphData = {
    "datasets": [
        {
            "id": "dataset_179849",
            "name": "July Vendor Data.xlsx_Sheet1 3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1565693,
                        "row_count": 42199
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_179849",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_185340",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30047",
            "name": "FirstHalfSept2020GroupClicks.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 254532,
                        "row_count": 2488
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_30047",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_31848",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30048",
            "name": "Firsthalfseptember2020individualclicks.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 254533,
                        "row_count": 1360
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_30048",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_31849",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30049",
            "name": "2020-09-16 - EB - September - MidMonth Engagement.xlsx_Email_Click_Prospects__2020_07_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 254534,
                        "row_count": 23871
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_30049",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_31850",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30463",
            "name": "2020-10-01 - EB - September - End Month Engagement.xlsx_Email_Click_Prospects__2020_07_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 266840,
                        "row_count": 31140
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_30463",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32191",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_31036",
            "name": "1H Oct 2020 Vendor Data.xlsx_Email_Click_Prospects__2020_07_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 280039,
                        "row_count": 28844
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_31036",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32765",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_200630",
            "name": "Coaching EST Adjustment Reference 11-26-2024.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1795427,
                        "row_count": 93926
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_200630",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_204721",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_31624",
            "name": "MonthlyReports_EDU_Count_WatchVideos - October 2020",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 298839,
                        "row_count": 1467
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1540",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_33367",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_31625",
            "name": "MonthlyReports_EB_Count_WatchVideos - October 2020",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 298841,
                        "row_count": 592
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1541",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_33369",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_31626",
            "name": "MonthlyReports_BH_Count_WatchVideos - October 2020",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 298843,
                        "row_count": 34
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1542",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_33371",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_33406",
            "name": "BH December 2020 Video Views",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 371543,
                        "row_count": 93
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1784",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_35296",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_33660",
            "name": "1H Jan 2021 Vendor Data 2021-01-18 - EB - January - MM Engagement.xlsx_Email_Click_Prospects__2020_07_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 391168,
                        "row_count": 21802
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_33660",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_35629",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_196182",
            "name": "membersv3_8th aug-Updated.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1750808,
                        "row_count": 989539
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_196182",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_200384",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_75379",
            "name": "WhilMemberCreation",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1750810,
                        "row_count": 524718
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_200225",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_200384",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_80146",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35105",
            "name": "report1615916352439.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 447419,
                        "row_count": 5270
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_35105",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_37139",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_185444",
            "name": "August 2024 Individual Texts.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1631734,
                        "row_count": 103752
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_185444",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_190757",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_179850",
            "name": "July 2024 Individual Text.xlsx_sent_messages_62b7da17bc83000_c 2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1565694,
                        "row_count": 146125
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_179850",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_185341",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_197130",
            "name": "Optum clients confidence master",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1758804,
                        "row_count": 2609
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_197130",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_201300",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35953",
            "name": "2H April 2021 Vendor Data 2021-05-03 - EB - April - EOM Engagement.xlsx_Sheet1 (2)",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 481538,
                        "row_count": 28264
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_35953",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_38154",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35954",
            "name": "GroupTextMessages_SecondHalf_April2021.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 481541,
                        "row_count": 452
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_35954",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_38155",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_36108",
            "name": "EB April 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 486042,
                        "row_count": 693
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2177",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_38304",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_56491",
            "name": "RC Asset Product Code Mapping 2022-10-19.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1287447,
                        "row_count": 38
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_56491",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_60824",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_138845",
            "name": "November Text 3 - 11.21.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1197764,
                        "row_count": 104
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_138845",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_145173",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_138846",
            "name": "November Group Text 4 - 11.27.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1197762,
                        "row_count": 20
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_138846",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_145171",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_36384",
            "name": "1H May 2021 Vendor Data 2021-05-19 - EB - May - MM Engagement.xlsx_Sheet3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 498046,
                        "row_count": 56103
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_36384",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_38578",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_138844",
            "name": "November Group Text 2 - 11.14.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1197763,
                        "row_count": 31
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_138844",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_145172",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_138847",
            "name": "November Group Text 1 - 11.13.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1197765,
                        "row_count": 189
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_138847",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_145174",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_138849",
            "name": "November Vendor Data.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1197766,
                        "row_count": 68586
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_138849",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_145175",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_164982",
            "name": "Neurodiversity_Assessment",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1931854,
                        "row_count": 39573
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_5428",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_181687",
                        "name": "PostOrg",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_181685",
                        "name": "PostBehavReg",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_181690",
                        "name": "PostTimeMang",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_181686",
                        "name": "PostNeuroKnow",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_181689",
                        "name": "PostPlanMang",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_170912",
                        "name": "PreBehavReg",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_172610",
                        "name": "PreOrg",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_172612",
                        "name": "PreTimeMang",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_172608",
                        "name": "PreNeuroKnow",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_172611",
                        "name": "PrePlanMang",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_181472",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_139399",
            "name": "Keyval",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1203450,
                        "row_count": 1
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_139399",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_145734",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_217795",
            "name": "February Vendor Data.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1933657,
                        "row_count": null
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_217795",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_221538",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_36797",
            "name": "EDU May 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 523440,
                        "row_count": 1522
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2298",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_39028",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_36963",
            "name": "1H June 2021 Vendor Data 2021-06-16 - EB - June - MM Engagement.xlsx_Sheet3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 536185,
                        "row_count": 43710
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_36963",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_39177",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_66986",
            "name": "UserActivityLog",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994600,
                        "row_count": 73780865
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4103",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_71711",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_37597",
            "name": "2H June 2021 Vendor Data 2021-07-06 - EB - June - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 562502,
                        "row_count": 24286
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_37597",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_39816",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_37598",
            "name": "2021-07-01 - 2ndhalf-Group June clicks.xlsx_Secondhalfjunegroupclicks",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 562505,
                        "row_count": 215
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_37598",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_39817",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_37629",
            "name": "EB June 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 563703,
                        "row_count": 647
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2396",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_39854",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_138848",
            "name": "November Texting Reports - Individual.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1197767,
                        "row_count": 32367
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_138848",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_145176",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_191993",
            "name": "OptumClients Confidence",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1704183,
                        "row_count": 2219
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_191993",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_196361",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_38262",
            "name": "BH July 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 595389,
                        "row_count": 90
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2513",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_40523",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_223373",
            "name": "March Vendor Data.xlsx_Sheet3 2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994575,
                        "row_count": null
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_223373",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_226916",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_157063",
            "name": "CountryToRegion Key.xlsx_Key",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1369276,
                        "row_count": 289
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_157063",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_163046",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_215215",
            "name": "Login - DO NOT REFRESH",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1919938,
                        "row_count": 53350016
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_215215",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_218958",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_39077",
            "name": "SecondHalfAugust2021IndividualTexts.xlsx_SecondHalfAugust2021IndividualT",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 633378,
                        "row_count": 1252
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_39077",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_41426",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_39692",
            "name": "Prticipant Texting Data - Group FIRST HALF - Sept 2021.xlsx_270253199_detailed_click_stats_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 665582,
                        "row_count": 290
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_39692",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_42317",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_223372",
            "name": "March Vendor Data.xlsx_Sheet3",
            "type": "dataset",
            "properties": {
                "batches": [],
                "inbound_connections": [
                    {
                        "id": "file_upload_223372",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataset_40897",
            "name": "2H November 2021 Vendor Data 2021-12-01 - EB - November - EOM Engagement.xlsx_NEW",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 683086,
                        "row_count": 121283
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_40897",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_43709",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_185448",
            "name": "August Vendor Data.xlsx_Sheet1 3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1631743,
                        "row_count": 59606
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_185448",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_190761",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41109",
            "name": "BH 11-2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 688131,
                        "row_count": 91
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2787",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_43945",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41110",
            "name": "EDU 11-2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 688132,
                        "row_count": 1727
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2788",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_43946",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_196034",
            "name": "Member-June.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1749465,
                        "row_count": 762663
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_196034",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_200225",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62354",
            "name": "Login",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994595,
                        "row_count": 54793129
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4033",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_169701",
                        "name": "Device QA",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_155432",
                        "name": "By Organization",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_155441",
                        "name": "By Organization Monthly",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_66951",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_152990",
                        "name": "By Platform/Device",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_83065",
                        "name": "QA",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62520",
            "name": "event_mapping.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1887504,
                        "row_count": 82
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_62520",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_67145",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_42873",
            "name": "2022-02-24-Feb 28th Webinar Reminder - Group Text.xlsx_2022-02-24-Feb 28th Webinar Rem",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 724435,
                        "row_count": 915
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_42873",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_46029",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_42874",
            "name": "2022-02-15-Feb 16th Webinar Reminder - Group Text.xlsx_2022-02-15-Feb 16th Webinar Rem",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 724436,
                        "row_count": 915
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_42874",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_46030",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_212332",
            "name": "January Vendor Data.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1892638,
                        "row_count": null
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_212332",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_216137",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_130471",
            "name": "SF_Accounts_viaAPI_Combined",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1467948,
                        "row_count": 859
                    },
                    {
                        "id": 1991996,
                        "row_count": 886
                    },
                    {
                        "id": 1449391,
                        "row_count": 859
                    },
                    {
                        "id": 1163755,
                        "row_count": 843
                    },
                    {
                        "id": 1531177,
                        "row_count": 861
                    },
                    {
                        "id": 1975641,
                        "row_count": 886
                    },
                    {
                        "id": 1470732,
                        "row_count": 859
                    },
                    {
                        "id": 1349772,
                        "row_count": 858
                    },
                    {
                        "id": 1208333,
                        "row_count": 849
                    },
                    {
                        "id": 1392666,
                        "row_count": 859
                    },
                    {
                        "id": 1745358,
                        "row_count": 873
                    },
                    {
                        "id": 1467776,
                        "row_count": 859
                    },
                    {
                        "id": 1183587,
                        "row_count": 844
                    },
                    {
                        "id": 1703156,
                        "row_count": 868
                    },
                    {
                        "id": 1559576,
                        "row_count": 863
                    },
                    {
                        "id": 1545965,
                        "row_count": 861
                    },
                    {
                        "id": 1315789,
                        "row_count": 857
                    },
                    {
                        "id": 1914476,
                        "row_count": 883
                    },
                    {
                        "id": 1281171,
                        "row_count": 856
                    },
                    {
                        "id": 1692776,
                        "row_count": 866
                    },
                    {
                        "id": 1892668,
                        "row_count": 883
                    },
                    {
                        "id": 1326356,
                        "row_count": 857
                    },
                    {
                        "id": 1336820,
                        "row_count": 858
                    },
                    {
                        "id": 1959259,
                        "row_count": 885
                    },
                    {
                        "id": 1216975,
                        "row_count": 849
                    },
                    {
                        "id": 1392560,
                        "row_count": 859
                    },
                    {
                        "id": 1994635,
                        "row_count": 886
                    },
                    {
                        "id": 1199588,
                        "row_count": 845
                    },
                    {
                        "id": 1383425,
                        "row_count": 858
                    },
                    {
                        "id": 1199589,
                        "row_count": 845
                    },
                    {
                        "id": 1545836,
                        "row_count": 861
                    },
                    {
                        "id": 1291361,
                        "row_count": 856
                    },
                    {
                        "id": 1158299,
                        "row_count": 843
                    },
                    {
                        "id": 1991994,
                        "row_count": 886
                    },
                    {
                        "id": 1237198,
                        "row_count": 851
                    },
                    {
                        "id": 1559482,
                        "row_count": 863
                    },
                    {
                        "id": 1449434,
                        "row_count": 859
                    },
                    {
                        "id": 1281169,
                        "row_count": 856
                    },
                    {
                        "id": 1631779,
                        "row_count": 864
                    },
                    {
                        "id": 1975638,
                        "row_count": 886
                    },
                    {
                        "id": 1862923,
                        "row_count": 882
                    },
                    {
                        "id": 1326358,
                        "row_count": 857
                    },
                    {
                        "id": 1257642,
                        "row_count": 854
                    },
                    {
                        "id": 1780286,
                        "row_count": 873
                    },
                    {
                        "id": 1191692,
                        "row_count": 844
                    },
                    {
                        "id": 1642208,
                        "row_count": 864
                    },
                    {
                        "id": 1565831,
                        "row_count": 863
                    },
                    {
                        "id": 1402586,
                        "row_count": 859
                    },
                    {
                        "id": 1158302,
                        "row_count": 843
                    },
                    {
                        "id": 1235433,
                        "row_count": 851
                    },
                    {
                        "id": 1933701,
                        "row_count": 883
                    },
                    {
                        "id": 1208335,
                        "row_count": 849
                    },
                    {
                        "id": 1163753,
                        "row_count": 843
                    },
                    {
                        "id": 1717004,
                        "row_count": 870
                    },
                    {
                        "id": 1339866,
                        "row_count": 858
                    },
                    {
                        "id": 1792511,
                        "row_count": 874
                    },
                    {
                        "id": 1246356,
                        "row_count": 854
                    },
                    {
                        "id": 1341765,
                        "row_count": 858
                    },
                    {
                        "id": 1506276,
                        "row_count": 860
                    },
                    {
                        "id": 1301695,
                        "row_count": 856
                    },
                    {
                        "id": 1830162,
                        "row_count": 882
                    },
                    {
                        "id": 1287574,
                        "row_count": 856
                    },
                    {
                        "id": 1566300,
                        "row_count": 863
                    },
                    {
                        "id": 1530905,
                        "row_count": 861
                    },
                    {
                        "id": 1545413,
                        "row_count": 861
                    },
                    {
                        "id": 1291359,
                        "row_count": 856
                    },
                    {
                        "id": 1143092,
                        "row_count": 843
                    },
                    {
                        "id": 1658292,
                        "row_count": 866
                    },
                    {
                        "id": 1803087,
                        "row_count": 877
                    },
                    {
                        "id": 1257644,
                        "row_count": 854
                    },
                    {
                        "id": 1301693,
                        "row_count": 856
                    },
                    {
                        "id": 1923794,
                        "row_count": 883
                    },
                    {
                        "id": 1752700,
                        "row_count": 873
                    },
                    {
                        "id": 1235431,
                        "row_count": 851
                    },
                    {
                        "id": 1947675,
                        "row_count": 884
                    },
                    {
                        "id": 1731037,
                        "row_count": 871
                    },
                    {
                        "id": 1947676,
                        "row_count": 884
                    },
                    {
                        "id": 1153583,
                        "row_count": 843
                    },
                    {
                        "id": 1599473,
                        "row_count": 864
                    },
                    {
                        "id": 1516956,
                        "row_count": 861
                    },
                    {
                        "id": 1191691,
                        "row_count": 844
                    },
                    {
                        "id": 1226702,
                        "row_count": 851
                    },
                    {
                        "id": 1821513,
                        "row_count": 880
                    },
                    {
                        "id": 1384391,
                        "row_count": 858
                    },
                    {
                        "id": 1269227,
                        "row_count": 855
                    },
                    {
                        "id": 1174463,
                        "row_count": 844
                    },
                    {
                        "id": 1372094,
                        "row_count": 858
                    },
                    {
                        "id": 1226706,
                        "row_count": 851
                    },
                    {
                        "id": 1246354,
                        "row_count": 854
                    },
                    {
                        "id": 1845921,
                        "row_count": 882
                    },
                    {
                        "id": 1269229,
                        "row_count": 855
                    },
                    {
                        "id": 1902357,
                        "row_count": 883
                    },
                    {
                        "id": 1415191,
                        "row_count": 860
                    },
                    {
                        "id": 1158076,
                        "row_count": 843
                    },
                    {
                        "id": 1153585,
                        "row_count": 843
                    },
                    {
                        "id": 1565782,
                        "row_count": 863
                    },
                    {
                        "id": 1174462,
                        "row_count": 844
                    },
                    {
                        "id": 1565721,
                        "row_count": 863
                    },
                    {
                        "id": 1336819,
                        "row_count": 858
                    },
                    {
                        "id": 1959254,
                        "row_count": 885
                    },
                    {
                        "id": 1183588,
                        "row_count": 844
                    },
                    {
                        "id": 1585773,
                        "row_count": 864
                    },
                    {
                        "id": 1436861,
                        "row_count": 859
                    },
                    {
                        "id": 1135048,
                        "row_count": 842
                    },
                    {
                        "id": 1237196,
                        "row_count": 851
                    },
                    {
                        "id": 1425514,
                        "row_count": 860
                    },
                    {
                        "id": 1994637,
                        "row_count": 886
                    },
                    {
                        "id": 1158074,
                        "row_count": 843
                    },
                    {
                        "id": 1144420,
                        "row_count": 843
                    },
                    {
                        "id": 1216973,
                        "row_count": 849
                    },
                    {
                        "id": 1315785,
                        "row_count": 857
                    },
                    {
                        "id": 1287573,
                        "row_count": 856
                    },
                    {
                        "id": 1875413,
                        "row_count": 882
                    },
                    {
                        "id": 1886721,
                        "row_count": 882
                    },
                    {
                        "id": 1614518,
                        "row_count": 864
                    },
                    {
                        "id": 1460182,
                        "row_count": 859
                    },
                    {
                        "id": 1935153,
                        "row_count": 883
                    },
                    {
                        "id": 1496107,
                        "row_count": 860
                    },
                    {
                        "id": 1475985,
                        "row_count": 859
                    },
                    {
                        "id": 1486016,
                        "row_count": 860
                    },
                    {
                        "id": 1149117,
                        "row_count": 843
                    },
                    {
                        "id": 1676560,
                        "row_count": 866
                    },
                    {
                        "id": 1360495,
                        "row_count": 858
                    },
                    {
                        "id": 1431024,
                        "row_count": 859
                    },
                    {
                        "id": 1132796,
                        "row_count": 841
                    },
                    {
                        "id": 1814561,
                        "row_count": 877
                    },
                    {
                        "id": 1767837,
                        "row_count": 873
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_135887",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_137216",
                        "name": "to_be_deleted_after_date_bug_is_resolved",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_136770",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_77415",
            "name": "Case Rate List.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1948696,
                        "row_count": 24
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_77415",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_82198",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_43796",
            "name": "2022-03-22_March Second Half_Group Text 2.xlsx_293683422_detailed_click_stats_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 747395,
                        "row_count": 45
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_43796",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_47089",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_206679",
            "name": "2024-Jan-Individual Texts.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1847917,
                        "row_count": 43183
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_206679",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_210524",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_206762",
            "name": "April 2024 - Group Text1.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1851543,
                        "row_count": 652
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_206762",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_210580",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_16481",
            "name": "Group EZText",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1097140,
                        "row_count": 217
                    },
                    {
                        "id": 828644,
                        "row_count": 37
                    },
                    {
                        "id": 1075560,
                        "row_count": 102
                    },
                    {
                        "id": 254576,
                        "row_count": 2488
                    },
                    {
                        "id": 831805,
                        "row_count": 6842
                    },
                    {
                        "id": 892043,
                        "row_count": 181
                    },
                    {
                        "id": 809151,
                        "row_count": 5
                    },
                    {
                        "id": 696163,
                        "row_count": 463
                    },
                    {
                        "id": 1199886,
                        "row_count": 20
                    },
                    {
                        "id": 872820,
                        "row_count": 187
                    },
                    {
                        "id": 1158019,
                        "row_count": 88
                    },
                    {
                        "id": 1336396,
                        "row_count": 19
                    },
                    {
                        "id": 724461,
                        "row_count": 915
                    },
                    {
                        "id": 608980,
                        "row_count": 474
                    },
                    {
                        "id": 846828,
                        "row_count": 4
                    },
                    {
                        "id": 1237155,
                        "row_count": 239
                    },
                    {
                        "id": 747452,
                        "row_count": 258
                    },
                    {
                        "id": 1158028,
                        "row_count": 115
                    },
                    {
                        "id": 831806,
                        "row_count": 1306
                    },
                    {
                        "id": 776248,
                        "row_count": 3
                    },
                    {
                        "id": 766633,
                        "row_count": 172
                    },
                    {
                        "id": 784310,
                        "row_count": 14
                    },
                    {
                        "id": 1055106,
                        "row_count": 6
                    },
                    {
                        "id": 809150,
                        "row_count": 6
                    },
                    {
                        "id": 1007536,
                        "row_count": 97
                    },
                    {
                        "id": 298803,
                        "row_count": 330
                    },
                    {
                        "id": 1287465,
                        "row_count": 7
                    },
                    {
                        "id": 1158014,
                        "row_count": 49
                    },
                    {
                        "id": 828655,
                        "row_count": 128
                    },
                    {
                        "id": 435173,
                        "row_count": 478
                    },
                    {
                        "id": 926432,
                        "row_count": 450
                    },
                    {
                        "id": 792227,
                        "row_count": 12
                    },
                    {
                        "id": 747454,
                        "row_count": 45
                    },
                    {
                        "id": 1430920,
                        "row_count": 652
                    },
                    {
                        "id": 708843,
                        "row_count": 282
                    },
                    {
                        "id": 481551,
                        "row_count": 452
                    },
                    {
                        "id": 1237148,
                        "row_count": 202
                    },
                    {
                        "id": 724444,
                        "row_count": 543
                    },
                    {
                        "id": 831792,
                        "row_count": 1809
                    },
                    {
                        "id": 1055102,
                        "row_count": 144
                    },
                    {
                        "id": 1383376,
                        "row_count": 56
                    },
                    {
                        "id": 747458,
                        "row_count": 146
                    },
                    {
                        "id": 792228,
                        "row_count": 38
                    },
                    {
                        "id": 978945,
                        "row_count": 193
                    },
                    {
                        "id": 926437,
                        "row_count": 2
                    },
                    {
                        "id": 1123414,
                        "row_count": 178
                    },
                    {
                        "id": 410691,
                        "row_count": 480
                    },
                    {
                        "id": 724445,
                        "row_count": 495
                    },
                    {
                        "id": 978949,
                        "row_count": 124
                    },
                    {
                        "id": 1097133,
                        "row_count": 128
                    },
                    {
                        "id": 1158005,
                        "row_count": 54
                    },
                    {
                        "id": 1336406,
                        "row_count": 547
                    },
                    {
                        "id": 809085,
                        "row_count": 15
                    },
                    {
                        "id": 776254,
                        "row_count": 275
                    },
                    {
                        "id": 784320,
                        "row_count": 264
                    },
                    {
                        "id": 978948,
                        "row_count": 147
                    },
                    {
                        "id": 926426,
                        "row_count": 172
                    },
                    {
                        "id": 724448,
                        "row_count": 915
                    },
                    {
                        "id": 828666,
                        "row_count": 40
                    },
                    {
                        "id": 784322,
                        "row_count": 264
                    },
                    {
                        "id": 593293,
                        "row_count": 486
                    },
                    {
                        "id": 776265,
                        "row_count": 2
                    },
                    {
                        "id": 683117,
                        "row_count": 691
                    },
                    {
                        "id": 376122,
                        "row_count": 322
                    },
                    {
                        "id": 1383406,
                        "row_count": 456
                    },
                    {
                        "id": 665581,
                        "row_count": 470
                    },
                    {
                        "id": 846850,
                        "row_count": 388
                    },
                    {
                        "id": 831817,
                        "row_count": 1996
                    },
                    {
                        "id": 1158024,
                        "row_count": 3
                    },
                    {
                        "id": 784325,
                        "row_count": 310
                    },
                    {
                        "id": 674933,
                        "row_count": 600
                    },
                    {
                        "id": 1123411,
                        "row_count": 270
                    },
                    {
                        "id": 1055105,
                        "row_count": 216
                    },
                    {
                        "id": 392232,
                        "row_count": 723
                    },
                    {
                        "id": 1199876,
                        "row_count": 31
                    },
                    {
                        "id": 1287462,
                        "row_count": 358
                    },
                    {
                        "id": 747456,
                        "row_count": 104
                    },
                    {
                        "id": 747441,
                        "row_count": 659
                    },
                    {
                        "id": 280049,
                        "row_count": 2117
                    },
                    {
                        "id": 266842,
                        "row_count": 1240
                    },
                    {
                        "id": 1075545,
                        "row_count": 104
                    },
                    {
                        "id": 1237139,
                        "row_count": 187
                    },
                    {
                        "id": 724447,
                        "row_count": 7
                    },
                    {
                        "id": 160065,
                        "row_count": 625
                    },
                    {
                        "id": 828641,
                        "row_count": 13
                    },
                    {
                        "id": 1036813,
                        "row_count": 179
                    },
                    {
                        "id": 1158034,
                        "row_count": 25
                    },
                    {
                        "id": 872817,
                        "row_count": 201
                    },
                    {
                        "id": 846827,
                        "row_count": 214
                    },
                    {
                        "id": 784312,
                        "row_count": 22
                    },
                    {
                        "id": 1158009,
                        "row_count": 147
                    },
                    {
                        "id": 831797,
                        "row_count": 1844
                    },
                    {
                        "id": 460803,
                        "row_count": 104
                    },
                    {
                        "id": 1055107,
                        "row_count": 126
                    },
                    {
                        "id": 1383372,
                        "row_count": 19
                    },
                    {
                        "id": 1075536,
                        "row_count": 124
                    },
                    {
                        "id": 809080,
                        "row_count": 141
                    },
                    {
                        "id": 1287467,
                        "row_count": 13
                    },
                    {
                        "id": 952349,
                        "row_count": 65
                    },
                    {
                        "id": 1383408,
                        "row_count": 696
                    },
                    {
                        "id": 846839,
                        "row_count": 12
                    },
                    {
                        "id": 1097137,
                        "row_count": 61
                    },
                    {
                        "id": 1336403,
                        "row_count": 20
                    },
                    {
                        "id": 536199,
                        "row_count": 954
                    },
                    {
                        "id": 1097131,
                        "row_count": 18
                    },
                    {
                        "id": 792359,
                        "row_count": 21
                    },
                    {
                        "id": 1199881,
                        "row_count": 104
                    },
                    {
                        "id": 846856,
                        "row_count": 22
                    },
                    {
                        "id": 766636,
                        "row_count": 17
                    },
                    {
                        "id": 228549,
                        "row_count": 2032
                    },
                    {
                        "id": 926422,
                        "row_count": 137
                    },
                    {
                        "id": 160060,
                        "row_count": 1349
                    },
                    {
                        "id": 577578,
                        "row_count": 502
                    },
                    {
                        "id": 776250,
                        "row_count": 2
                    },
                    {
                        "id": 1237141,
                        "row_count": 19
                    },
                    {
                        "id": 926436,
                        "row_count": 74
                    },
                    {
                        "id": 1036815,
                        "row_count": 109
                    },
                    {
                        "id": 1036816,
                        "row_count": 1
                    },
                    {
                        "id": 562509,
                        "row_count": 215
                    },
                    {
                        "id": 809131,
                        "row_count": 164
                    },
                    {
                        "id": 1336393,
                        "row_count": 856
                    },
                    {
                        "id": 1199870,
                        "row_count": 189
                    },
                    {
                        "id": 376178,
                        "row_count": 2954
                    },
                    {
                        "id": 665584,
                        "row_count": 290
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_16481",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_20780",
                        "name": "Unmatched",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67108",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67109",
                        "name": "Phone Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_56650",
                        "name": "test",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62657",
            "name": "Child_Diagnosis_AreaOfConcern_Report",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994672,
                        "row_count": 242431
                    },
                    {
                        "id": 1994667,
                        "row_count": 35485
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_67283",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67300",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_67301",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_44650",
            "name": "2H April 2022 Vendor Data - EB - EOM Engagement - 4-26.xlsx_Sheet2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 765839,
                        "row_count": 182324
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_44650",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48074",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_44689",
            "name": "2022-04-20_Group Text_Amazon Engagement Push.xlsx_2022-04-20_Amazon Engagement Pu",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 766275,
                        "row_count": 17
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_44689",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48120",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_217796",
            "name": "February Individual Texts.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1933658,
                        "row_count": 100000
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_217796",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_221539",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_85870",
            "name": "Completed_Series",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994598,
                        "row_count": 7202832
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4333",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_90700",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62491",
            "name": "Asset_LaunchpadOnlyV3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994718,
                        "row_count": 470
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_67252",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_67119",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_142229",
                        "name": "View 2",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_215222",
            "name": "UserActivityLog - DO NOT REFRESH",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1920009,
                        "row_count": 70020236
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_215222",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_218977",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_130469",
            "name": "SF_Assets_viaAPI_Combined",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1599480,
                        "row_count": 2810
                    },
                    {
                        "id": 1216976,
                        "row_count": 1769
                    },
                    {
                        "id": 1814570,
                        "row_count": 2964
                    },
                    {
                        "id": 1257643,
                        "row_count": 1792
                    },
                    {
                        "id": 1486397,
                        "row_count": 2777
                    },
                    {
                        "id": 1425515,
                        "row_count": 1836
                    },
                    {
                        "id": 1341733,
                        "row_count": 2694
                    },
                    {
                        "id": 1531178,
                        "row_count": 1698
                    },
                    {
                        "id": 1703154,
                        "row_count": 1950
                    },
                    {
                        "id": 1566299,
                        "row_count": 794
                    },
                    {
                        "id": 1475992,
                        "row_count": 2770
                    },
                    {
                        "id": 1132793,
                        "row_count": 2454
                    },
                    {
                        "id": 1486015,
                        "row_count": 1877
                    },
                    {
                        "id": 1163787,
                        "row_count": 2458
                    },
                    {
                        "id": 1153584,
                        "row_count": 1636
                    },
                    {
                        "id": 1235446,
                        "row_count": 2645
                    },
                    {
                        "id": 1199585,
                        "row_count": 758
                    },
                    {
                        "id": 1208364,
                        "row_count": 2611
                    },
                    {
                        "id": 1545592,
                        "row_count": 791
                    },
                    {
                        "id": 1349776,
                        "row_count": 2697
                    },
                    {
                        "id": 1436879,
                        "row_count": 2728
                    },
                    {
                        "id": 1372123,
                        "row_count": 2699
                    },
                    {
                        "id": 1217010,
                        "row_count": 2619
                    },
                    {
                        "id": 1269230,
                        "row_count": 1793
                    },
                    {
                        "id": 1470723,
                        "row_count": 1681
                    },
                    {
                        "id": 1467952,
                        "row_count": 2753
                    },
                    {
                        "id": 1191693,
                        "row_count": 1657
                    },
                    {
                        "id": 1384392,
                        "row_count": 2702
                    },
                    {
                        "id": 1135050,
                        "row_count": 1635
                    },
                    {
                        "id": 1336808,
                        "row_count": 767
                    },
                    {
                        "id": 1315825,
                        "row_count": 2684
                    },
                    {
                        "id": 1470735,
                        "row_count": 2766
                    },
                    {
                        "id": 1402587,
                        "row_count": 1835
                    },
                    {
                        "id": 1933820,
                        "row_count": 3063
                    },
                    {
                        "id": 1803090,
                        "row_count": 2946
                    },
                    {
                        "id": 1994630,
                        "row_count": 856
                    },
                    {
                        "id": 1467456,
                        "row_count": 1676
                    },
                    {
                        "id": 1174465,
                        "row_count": 1649
                    },
                    {
                        "id": 1153581,
                        "row_count": 743
                    },
                    {
                        "id": 1217008,
                        "row_count": 2619
                    },
                    {
                        "id": 1516955,
                        "row_count": 2788
                    },
                    {
                        "id": 1449437,
                        "row_count": 777
                    },
                    {
                        "id": 1599477,
                        "row_count": 1709
                    },
                    {
                        "id": 1875414,
                        "row_count": 845
                    },
                    {
                        "id": 1780285,
                        "row_count": 821
                    },
                    {
                        "id": 1287578,
                        "row_count": 1637
                    },
                    {
                        "id": 1676571,
                        "row_count": 2833
                    },
                    {
                        "id": 1425528,
                        "row_count": 2725
                    },
                    {
                        "id": 1281172,
                        "row_count": 1793
                    },
                    {
                        "id": 1183592,
                        "row_count": 1656
                    },
                    {
                        "id": 1199592,
                        "row_count": 1672
                    },
                    {
                        "id": 1914486,
                        "row_count": 3056
                    },
                    {
                        "id": 1291362,
                        "row_count": 1793
                    },
                    {
                        "id": 1257668,
                        "row_count": 2655
                    },
                    {
                        "id": 1460067,
                        "row_count": 2742
                    },
                    {
                        "id": 1545838,
                        "row_count": 1697
                    },
                    {
                        "id": 1923795,
                        "row_count": 2073
                    },
                    {
                        "id": 1991995,
                        "row_count": 1849
                    },
                    {
                        "id": 1383621,
                        "row_count": 769
                    },
                    {
                        "id": 1392826,
                        "row_count": 2708
                    },
                    {
                        "id": 1565722,
                        "row_count": 2800
                    },
                    {
                        "id": 1208336,
                        "row_count": 1765
                    },
                    {
                        "id": 1745351,
                        "row_count": 819
                    },
                    {
                        "id": 1449444,
                        "row_count": 2742
                    },
                    {
                        "id": 1767829,
                        "row_count": 821
                    },
                    {
                        "id": 1516948,
                        "row_count": 790
                    },
                    {
                        "id": 1731035,
                        "row_count": 815
                    },
                    {
                        "id": 1415204,
                        "row_count": 2724
                    },
                    {
                        "id": 1992134,
                        "row_count": 3079
                    },
                    {
                        "id": 1449441,
                        "row_count": 1848
                    },
                    {
                        "id": 1703173,
                        "row_count": 2875
                    },
                    {
                        "id": 1326375,
                        "row_count": 2692
                    },
                    {
                        "id": 1237194,
                        "row_count": 1624
                    },
                    {
                        "id": 1565783,
                        "row_count": 1702
                    },
                    {
                        "id": 1460075,
                        "row_count": 2742
                    },
                    {
                        "id": 1845940,
                        "row_count": 3017
                    },
                    {
                        "id": 1402604,
                        "row_count": 2722
                    },
                    {
                        "id": 1565729,
                        "row_count": 794
                    },
                    {
                        "id": 1496115,
                        "row_count": 2777
                    },
                    {
                        "id": 1545970,
                        "row_count": 2792
                    },
                    {
                        "id": 1163757,
                        "row_count": 1638
                    },
                    {
                        "id": 1545966,
                        "row_count": 1697
                    },
                    {
                        "id": 1174466,
                        "row_count": 1649
                    },
                    {
                        "id": 1717008,
                        "row_count": 2889
                    },
                    {
                        "id": 1392575,
                        "row_count": 2702
                    },
                    {
                        "id": 1191690,
                        "row_count": 1657
                    },
                    {
                        "id": 1676559,
                        "row_count": 801
                    },
                    {
                        "id": 1614504,
                        "row_count": 796
                    },
                    {
                        "id": 1237242,
                        "row_count": 2645
                    },
                    {
                        "id": 1467945,
                        "row_count": 779
                    },
                    {
                        "id": 1745359,
                        "row_count": 2903
                    },
                    {
                        "id": 1174486,
                        "row_count": 2476
                    },
                    {
                        "id": 1467770,
                        "row_count": 779
                    },
                    {
                        "id": 1372095,
                        "row_count": 1819
                    },
                    {
                        "id": 1642201,
                        "row_count": 801
                    },
                    {
                        "id": 1559575,
                        "row_count": 1703
                    },
                    {
                        "id": 1158077,
                        "row_count": 2455
                    },
                    {
                        "id": 1933704,
                        "row_count": 1839
                    },
                    {
                        "id": 1614516,
                        "row_count": 2816
                    },
                    {
                        "id": 1886730,
                        "row_count": 3034
                    },
                    {
                        "id": 1902360,
                        "row_count": 849
                    },
                    {
                        "id": 1360497,
                        "row_count": 1819
                    },
                    {
                        "id": 1545419,
                        "row_count": 2792
                    },
                    {
                        "id": 1269251,
                        "row_count": 2661
                    },
                    {
                        "id": 1158083,
                        "row_count": 743
                    },
                    {
                        "id": 1301725,
                        "row_count": 2675
                    },
                    {
                        "id": 1208332,
                        "row_count": 1765
                    },
                    {
                        "id": 1531171,
                        "row_count": 792
                    },
                    {
                        "id": 1994711,
                        "row_count": 3083
                    },
                    {
                        "id": 1923790,
                        "row_count": 852
                    },
                    {
                        "id": 1506281,
                        "row_count": 2787
                    },
                    {
                        "id": 1692782,
                        "row_count": 2857
                    },
                    {
                        "id": 1792525,
                        "row_count": 2944
                    },
                    {
                        "id": 1226707,
                        "row_count": 1769
                    },
                    {
                        "id": 1545847,
                        "row_count": 791
                    },
                    {
                        "id": 1291383,
                        "row_count": 2661
                    },
                    {
                        "id": 1559478,
                        "row_count": 795
                    },
                    {
                        "id": 1144422,
                        "row_count": 1636
                    },
                    {
                        "id": 1281194,
                        "row_count": 2661
                    },
                    {
                        "id": 1959427,
                        "row_count": 3066
                    },
                    {
                        "id": 1565726,
                        "row_count": 2799
                    },
                    {
                        "id": 1559568,
                        "row_count": 795
                    },
                    {
                        "id": 1460235,
                        "row_count": 2742
                    },
                    {
                        "id": 1862929,
                        "row_count": 3026
                    },
                    {
                        "id": 1530910,
                        "row_count": 2789
                    },
                    {
                        "id": 1780291,
                        "row_count": 2926
                    },
                    {
                        "id": 1208366,
                        "row_count": 2611
                    },
                    {
                        "id": 1947697,
                        "row_count": 3063
                    },
                    {
                        "id": 1559486,
                        "row_count": 1892
                    },
                    {
                        "id": 1199621,
                        "row_count": 2508
                    },
                    {
                        "id": 1226722,
                        "row_count": 2619
                    },
                    {
                        "id": 1436864,
                        "row_count": 1839
                    },
                    {
                        "id": 1360519,
                        "row_count": 2699
                    },
                    {
                        "id": 1559473,
                        "row_count": 2794
                    },
                    {
                        "id": 1566307,
                        "row_count": 2800
                    },
                    {
                        "id": 1875438,
                        "row_count": 3028
                    },
                    {
                        "id": 1821523,
                        "row_count": 2974
                    },
                    {
                        "id": 1994645,
                        "row_count": 1849
                    },
                    {
                        "id": 1301696,
                        "row_count": 1802
                    },
                    {
                        "id": 1315788,
                        "row_count": 1808
                    },
                    {
                        "id": 1767838,
                        "row_count": 2914
                    },
                    {
                        "id": 1341637,
                        "row_count": 2694
                    },
                    {
                        "id": 1135047,
                        "row_count": 743
                    },
                    {
                        "id": 1892672,
                        "row_count": 3044
                    },
                    {
                        "id": 1326357,
                        "row_count": 1813
                    },
                    {
                        "id": 1752704,
                        "row_count": 2911
                    },
                    {
                        "id": 1731042,
                        "row_count": 2889
                    },
                    {
                        "id": 1208334,
                        "row_count": 1765
                    },
                    {
                        "id": 1585774,
                        "row_count": 2811
                    },
                    {
                        "id": 1199590,
                        "row_count": 1672
                    },
                    {
                        "id": 1975642,
                        "row_count": 3073
                    },
                    {
                        "id": 1559580,
                        "row_count": 2800
                    },
                    {
                        "id": 1803081,
                        "row_count": 821
                    },
                    {
                        "id": 1449390,
                        "row_count": 2739
                    },
                    {
                        "id": 1246357,
                        "row_count": 1792
                    },
                    {
                        "id": 1516931,
                        "row_count": 2788
                    },
                    {
                        "id": 1144454,
                        "row_count": 2455
                    },
                    {
                        "id": 1449386,
                        "row_count": 2733
                    },
                    {
                        "id": 1226703,
                        "row_count": 761
                    },
                    {
                        "id": 1183617,
                        "row_count": 2486
                    },
                    {
                        "id": 1199587,
                        "row_count": 1672
                    },
                    {
                        "id": 1415192,
                        "row_count": 1836
                    },
                    {
                        "id": 1959260,
                        "row_count": 1840
                    },
                    {
                        "id": 1902380,
                        "row_count": 3055
                    },
                    {
                        "id": 1565832,
                        "row_count": 2798
                    },
                    {
                        "id": 1703149,
                        "row_count": 812
                    },
                    {
                        "id": 1191724,
                        "row_count": 2490
                    },
                    {
                        "id": 1183586,
                        "row_count": 751
                    },
                    {
                        "id": 1545841,
                        "row_count": 2792
                    },
                    {
                        "id": 1631801,
                        "row_count": 2822
                    },
                    {
                        "id": 1460163,
                        "row_count": 777
                    },
                    {
                        "id": 1383483,
                        "row_count": 2701
                    },
                    {
                        "id": 1336521,
                        "row_count": 2705
                    },
                    {
                        "id": 1923802,
                        "row_count": 3059
                    },
                    {
                        "id": 1658291,
                        "row_count": 801
                    },
                    {
                        "id": 1216978,
                        "row_count": 1769
                    },
                    {
                        "id": 1431038,
                        "row_count": 2728
                    },
                    {
                        "id": 1565788,
                        "row_count": 1890
                    },
                    {
                        "id": 1467842,
                        "row_count": 1676
                    },
                    {
                        "id": 1658305,
                        "row_count": 2834
                    },
                    {
                        "id": 1585761,
                        "row_count": 1896
                    },
                    {
                        "id": 1531184,
                        "row_count": 2791
                    },
                    {
                        "id": 1392827,
                        "row_count": 2708
                    },
                    {
                        "id": 1717000,
                        "row_count": 815
                    },
                    {
                        "id": 1246371,
                        "row_count": 2655
                    },
                    {
                        "id": 1599471,
                        "row_count": 796
                    },
                    {
                        "id": 1199624,
                        "row_count": 2508
                    },
                    {
                        "id": 1631787,
                        "row_count": 1714
                    },
                    {
                        "id": 1153624,
                        "row_count": 2455
                    },
                    {
                        "id": 1158308,
                        "row_count": 2455
                    },
                    {
                        "id": 1830180,
                        "row_count": 2992
                    },
                    {
                        "id": 1642209,
                        "row_count": 2831
                    },
                    {
                        "id": 1383486,
                        "row_count": 2701
                    },
                    {
                        "id": 1392618,
                        "row_count": 775
                    },
                    {
                        "id": 1631780,
                        "row_count": 798
                    },
                    {
                        "id": 1886723,
                        "row_count": 2047
                    },
                    {
                        "id": 1516950,
                        "row_count": 1883
                    },
                    {
                        "id": 1460167,
                        "row_count": 1848
                    },
                    {
                        "id": 1959244,
                        "row_count": 853
                    },
                    {
                        "id": 1208338,
                        "row_count": 1765
                    },
                    {
                        "id": 1235432,
                        "row_count": 1785
                    },
                    {
                        "id": 1947677,
                        "row_count": 2076
                    },
                    {
                        "id": 1191723,
                        "row_count": 2490
                    },
                    {
                        "id": 1467773,
                        "row_count": 1676
                    },
                    {
                        "id": 1135085,
                        "row_count": 2454
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_135886",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_136898",
                        "name": "to_be_deleted_after_date_bug_is_resolved",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_136768",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62368",
            "name": "SF Asset Data",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1301726,
                        "row_count": 2675
                    },
                    {
                        "id": 1226723,
                        "row_count": 2619
                    },
                    {
                        "id": 1559479,
                        "row_count": 795
                    },
                    {
                        "id": 1402590,
                        "row_count": 1835
                    },
                    {
                        "id": 1545848,
                        "row_count": 791
                    },
                    {
                        "id": 1326377,
                        "row_count": 2692
                    },
                    {
                        "id": 1531181,
                        "row_count": 1698
                    },
                    {
                        "id": 1074639,
                        "row_count": 2457
                    },
                    {
                        "id": 1467845,
                        "row_count": 1676
                    },
                    {
                        "id": 1287580,
                        "row_count": 1637
                    },
                    {
                        "id": 1158079,
                        "row_count": 2455
                    },
                    {
                        "id": 1208369,
                        "row_count": 2611
                    },
                    {
                        "id": 1163759,
                        "row_count": 1638
                    },
                    {
                        "id": 1237243,
                        "row_count": 2645
                    },
                    {
                        "id": 1994714,
                        "row_count": 3083
                    },
                    {
                        "id": 1191694,
                        "row_count": 1657
                    },
                    {
                        "id": 1845950,
                        "row_count": 3017
                    },
                    {
                        "id": 1496117,
                        "row_count": 2777
                    },
                    {
                        "id": 1291384,
                        "row_count": 2661
                    },
                    {
                        "id": 1360503,
                        "row_count": 1819
                    },
                    {
                        "id": 1144455,
                        "row_count": 2455
                    },
                    {
                        "id": 1599481,
                        "row_count": 2810
                    },
                    {
                        "id": 1470736,
                        "row_count": 2766
                    },
                    {
                        "id": 1994652,
                        "row_count": 1849
                    },
                    {
                        "id": 1237195,
                        "row_count": 1624
                    },
                    {
                        "id": 1246359,
                        "row_count": 1792
                    },
                    {
                        "id": 1559570,
                        "row_count": 795
                    },
                    {
                        "id": 978914,
                        "row_count": 2225
                    },
                    {
                        "id": 1135053,
                        "row_count": 1635
                    },
                    {
                        "id": 1372124,
                        "row_count": 2699
                    },
                    {
                        "id": 1516936,
                        "row_count": 2788
                    },
                    {
                        "id": 1803094,
                        "row_count": 2946
                    },
                    {
                        "id": 1257646,
                        "row_count": 1792
                    },
                    {
                        "id": 1217011,
                        "row_count": 2619
                    },
                    {
                        "id": 1959429,
                        "row_count": 3066
                    },
                    {
                        "id": 1431041,
                        "row_count": 2728
                    },
                    {
                        "id": 1559474,
                        "row_count": 2794
                    },
                    {
                        "id": 1425530,
                        "row_count": 2725
                    },
                    {
                        "id": 1301699,
                        "row_count": 1802
                    },
                    {
                        "id": 1923806,
                        "row_count": 3059
                    },
                    {
                        "id": 1144424,
                        "row_count": 1636
                    },
                    {
                        "id": 1281196,
                        "row_count": 2661
                    },
                    {
                        "id": 1460068,
                        "row_count": 2742
                    },
                    {
                        "id": 1174488,
                        "row_count": 2476
                    },
                    {
                        "id": 957651,
                        "row_count": 2195
                    },
                    {
                        "id": 1792528,
                        "row_count": 2944
                    },
                    {
                        "id": 1315828,
                        "row_count": 2684
                    },
                    {
                        "id": 1892676,
                        "row_count": 3044
                    },
                    {
                        "id": 1384394,
                        "row_count": 2702
                    },
                    {
                        "id": 1745364,
                        "row_count": 2903
                    },
                    {
                        "id": 1631807,
                        "row_count": 2822
                    },
                    {
                        "id": 1341734,
                        "row_count": 2694
                    },
                    {
                        "id": 1565731,
                        "row_count": 794
                    },
                    {
                        "id": 1191725,
                        "row_count": 2490
                    },
                    {
                        "id": 1042785,
                        "row_count": 2411
                    },
                    {
                        "id": 1158084,
                        "row_count": 743
                    },
                    {
                        "id": 1183618,
                        "row_count": 2486
                    },
                    {
                        "id": 1821527,
                        "row_count": 2974
                    },
                    {
                        "id": 1886734,
                        "row_count": 3034
                    },
                    {
                        "id": 1449392,
                        "row_count": 2739
                    },
                    {
                        "id": 1565790,
                        "row_count": 1890
                    },
                    {
                        "id": 1559489,
                        "row_count": 1892
                    },
                    {
                        "id": 1055093,
                        "row_count": 2429
                    },
                    {
                        "id": 1336809,
                        "row_count": 767
                    },
                    {
                        "id": 1559582,
                        "row_count": 2800
                    },
                    {
                        "id": 1281174,
                        "row_count": 1793
                    },
                    {
                        "id": 961476,
                        "row_count": 2200
                    },
                    {
                        "id": 1959267,
                        "row_count": 1840
                    },
                    {
                        "id": 1269252,
                        "row_count": 2661
                    },
                    {
                        "id": 1830181,
                        "row_count": 2992
                    },
                    {
                        "id": 1183590,
                        "row_count": 751
                    },
                    {
                        "id": 1467458,
                        "row_count": 1676
                    },
                    {
                        "id": 1545420,
                        "row_count": 2792
                    },
                    {
                        "id": 1336522,
                        "row_count": 2705
                    },
                    {
                        "id": 1383624,
                        "row_count": 769
                    },
                    {
                        "id": 1425517,
                        "row_count": 1836
                    },
                    {
                        "id": 1153626,
                        "row_count": 2455
                    },
                    {
                        "id": 1780295,
                        "row_count": 2926
                    },
                    {
                        "id": 1402605,
                        "row_count": 2722
                    },
                    {
                        "id": 1269232,
                        "row_count": 1793
                    },
                    {
                        "id": 1486020,
                        "row_count": 1877
                    },
                    {
                        "id": 1703157,
                        "row_count": 1950
                    },
                    {
                        "id": 1183594,
                        "row_count": 1656
                    },
                    {
                        "id": 1676575,
                        "row_count": 2833
                    },
                    {
                        "id": 1475993,
                        "row_count": 2770
                    },
                    {
                        "id": 1291364,
                        "row_count": 1793
                    },
                    {
                        "id": 1153589,
                        "row_count": 1636
                    },
                    {
                        "id": 1992135,
                        "row_count": 3079
                    },
                    {
                        "id": 1631782,
                        "row_count": 798
                    },
                    {
                        "id": 1449445,
                        "row_count": 2742
                    },
                    {
                        "id": 1383487,
                        "row_count": 2701
                    },
                    {
                        "id": 1133633,
                        "row_count": 2454
                    },
                    {
                        "id": 1235448,
                        "row_count": 2645
                    },
                    {
                        "id": 1992136,
                        "row_count": 3079
                    },
                    {
                        "id": 1991999,
                        "row_count": 1849
                    },
                    {
                        "id": 1631788,
                        "row_count": 1714
                    },
                    {
                        "id": 1565727,
                        "row_count": 2799
                    },
                    {
                        "id": 1007559,
                        "row_count": 2349
                    },
                    {
                        "id": 951380,
                        "row_count": 2186
                    },
                    {
                        "id": 1349777,
                        "row_count": 2697
                    },
                    {
                        "id": 1692785,
                        "row_count": 2857
                    },
                    {
                        "id": 1460078,
                        "row_count": 2742
                    },
                    {
                        "id": 1585784,
                        "row_count": 2811
                    },
                    {
                        "id": 1199594,
                        "row_count": 1672
                    },
                    {
                        "id": 919145,
                        "row_count": 2111
                    },
                    {
                        "id": 1975646,
                        "row_count": 3073
                    },
                    {
                        "id": 1752707,
                        "row_count": 2911
                    },
                    {
                        "id": 1415206,
                        "row_count": 2724
                    },
                    {
                        "id": 1506282,
                        "row_count": 2787
                    },
                    {
                        "id": 1565834,
                        "row_count": 2798
                    },
                    {
                        "id": 1153586,
                        "row_count": 743
                    },
                    {
                        "id": 1767841,
                        "row_count": 2914
                    },
                    {
                        "id": 1392825,
                        "row_count": 2702
                    },
                    {
                        "id": 1614507,
                        "row_count": 796
                    },
                    {
                        "id": 1467775,
                        "row_count": 1676
                    },
                    {
                        "id": 1235435,
                        "row_count": 1785
                    },
                    {
                        "id": 1158310,
                        "row_count": 2455
                    },
                    {
                        "id": 1226709,
                        "row_count": 1769
                    },
                    {
                        "id": 1460236,
                        "row_count": 2742
                    },
                    {
                        "id": 1994715,
                        "row_count": 3083
                    },
                    {
                        "id": 1902384,
                        "row_count": 3055
                    },
                    {
                        "id": 1516957,
                        "row_count": 2788
                    },
                    {
                        "id": 1992000,
                        "row_count": 1849
                    },
                    {
                        "id": 1341640,
                        "row_count": 2694
                    },
                    {
                        "id": 1174467,
                        "row_count": 1649
                    },
                    {
                        "id": 1559578,
                        "row_count": 1703
                    },
                    {
                        "id": 1658308,
                        "row_count": 2834
                    },
                    {
                        "id": 1703179,
                        "row_count": 2875
                    },
                    {
                        "id": 1216979,
                        "row_count": 1769
                    },
                    {
                        "id": 1460187,
                        "row_count": 1848
                    },
                    {
                        "id": 1862930,
                        "row_count": 3026
                    },
                    {
                        "id": 1135052,
                        "row_count": 743
                    },
                    {
                        "id": 1914491,
                        "row_count": 3056
                    },
                    {
                        "id": 1875440,
                        "row_count": 3028
                    },
                    {
                        "id": 1372097,
                        "row_count": 1819
                    },
                    {
                        "id": 1246372,
                        "row_count": 2655
                    },
                    {
                        "id": 1545842,
                        "row_count": 2792
                    },
                    {
                        "id": 1415194,
                        "row_count": 1836
                    },
                    {
                        "id": 1531185,
                        "row_count": 2791
                    },
                    {
                        "id": 1036573,
                        "row_count": 2392
                    },
                    {
                        "id": 1392828,
                        "row_count": 2708
                    },
                    {
                        "id": 1257670,
                        "row_count": 2655
                    },
                    {
                        "id": 1121115,
                        "row_count": 2516
                    },
                    {
                        "id": 1545971,
                        "row_count": 2792
                    },
                    {
                        "id": 1545593,
                        "row_count": 791
                    },
                    {
                        "id": 1814576,
                        "row_count": 2964
                    },
                    {
                        "id": 1642218,
                        "row_count": 2831
                    },
                    {
                        "id": 1994650,
                        "row_count": 1849
                    },
                    {
                        "id": 1436865,
                        "row_count": 1839
                    },
                    {
                        "id": 1467953,
                        "row_count": 2753
                    },
                    {
                        "id": 1933706,
                        "row_count": 1839
                    },
                    {
                        "id": 1614520,
                        "row_count": 2816
                    },
                    {
                        "id": 1326361,
                        "row_count": 1813
                    },
                    {
                        "id": 1717020,
                        "row_count": 2889
                    },
                    {
                        "id": 1199626,
                        "row_count": 2508
                    },
                    {
                        "id": 1360521,
                        "row_count": 2699
                    },
                    {
                        "id": 1135086,
                        "row_count": 2454
                    },
                    {
                        "id": 1097107,
                        "row_count": 2491
                    },
                    {
                        "id": 1208339,
                        "row_count": 1765
                    },
                    {
                        "id": 1174470,
                        "row_count": 1649
                    },
                    {
                        "id": 1315791,
                        "row_count": 1808
                    },
                    {
                        "id": 1933821,
                        "row_count": 3063
                    },
                    {
                        "id": 1436881,
                        "row_count": 2728
                    },
                    {
                        "id": 1947680,
                        "row_count": 2076
                    },
                    {
                        "id": 1731059,
                        "row_count": 2889
                    },
                    {
                        "id": 1566309,
                        "row_count": 2800
                    },
                    {
                        "id": 1163788,
                        "row_count": 2458
                    },
                    {
                        "id": 1486398,
                        "row_count": 2777
                    },
                    {
                        "id": 1975644,
                        "row_count": 3073
                    },
                    {
                        "id": 1530913,
                        "row_count": 2789
                    },
                    {
                        "id": 1947698,
                        "row_count": 3063
                    },
                    {
                        "id": 1191696,
                        "row_count": 1657
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_136768",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_67252",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_140730",
                        "name": "View 2",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_68968",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_78022",
            "name": "Solution Purchased",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994719,
                        "row_count": 3083
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_67252",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_115004",
                        "name": "InactiveAssets",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_82802",
                        "name": "ActiveAssets",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45900",
            "name": "2H June 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 784061,
                        "row_count": 222345
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45900",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_49723",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_217548",
            "name": "TrainingHistory - DO NOT REFRESH",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1931292,
                        "row_count": 65877084
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_217548",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_221298",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_221295",
                        "name": "ForCompletedSessions",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_217552",
            "name": "CompletedSessions  - DO NOT REFRESH",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1931321,
                        "row_count": 68687157
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_217552",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_221307",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_176321",
            "name": "Emotional and Behav Reg MASTER",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994749,
                        "row_count": 470
                    },
                    {
                        "id": 1994766,
                        "row_count": 7755
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_170912",
                        "name": "PreBehavReg",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_181685",
                        "name": "PostBehavReg",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_181909",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_176324",
            "name": "Organization MASTER",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994752,
                        "row_count": 282
                    },
                    {
                        "id": 1994765,
                        "row_count": 4635
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_172610",
                        "name": "PreOrg",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_181687",
                        "name": "PostOrg",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_181912",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_154175",
            "name": "Confidence Master",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994775,
                        "row_count": 101292
                    },
                    {
                        "id": 1994770,
                        "row_count": 4365
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_160222",
                        "name": "conf pre test",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_160225",
                        "name": "conf post test",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_160232",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_206658",
                        "name": "Optumclients_Confidence",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_176326",
            "name": "Time Management MASTER",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994751,
                        "row_count": 372
                    },
                    {
                        "id": 1994767,
                        "row_count": 6316
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_172612",
                        "name": "PreTimeMang",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_181690",
                        "name": "PostTimeMang",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_181914",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_154154",
            "name": "Stress Master",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994746,
                        "row_count": 4602
                    },
                    {
                        "id": 1994759,
                        "row_count": 104064
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_146058",
                        "name": "stress post test",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_160195",
                        "name": "stress pre test",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_196099",
                        "name": "OptumClients Stress1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_221412",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_206290",
                        "name": "OptumClients_Stress_view 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_160683",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_176322",
            "name": "Neurodiversity Knowledge MASTER",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994771,
                        "row_count": 9490
                    },
                    {
                        "id": 1994753,
                        "row_count": 470
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_172608",
                        "name": "PreNeuroKnow",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_181686",
                        "name": "PostNeuroKnow",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_181910",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_176325",
            "name": "Plan Management MASTER",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994762,
                        "row_count": 558
                    },
                    {
                        "id": 1994772,
                        "row_count": 9474
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_172611",
                        "name": "PrePlanMang",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_181689",
                        "name": "PostPlanMang",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_181913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_87042",
            "name": "CompletedSessions",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994594,
                        "row_count": 70200452
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4337",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_91913",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_202108",
            "name": "Braze_ExternalID",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994602,
                        "row_count": 1673210
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_6152",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_206059",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_63988",
            "name": "SF Asset_Filtered",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994720,
                        "row_count": 567
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_67252",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_68667",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_66969",
            "name": "TrainingHistory",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994604,
                        "row_count": 67696630
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4102",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_82782",
                        "name": "ForCompletedSessions",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_71696",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62346",
            "name": "Child_Profile_V3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994664,
                        "row_count": 254350
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4028",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_67190",
                        "name": "Account_Child_Count",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_131171",
                        "name": "View 2",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_131039",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67249",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62367",
            "name": "SF Account Data",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1199593,
                        "row_count": 845
                    },
                    {
                        "id": 957649,
                        "row_count": 16499
                    },
                    {
                        "id": 1208337,
                        "row_count": 849
                    },
                    {
                        "id": 1703159,
                        "row_count": 868
                    },
                    {
                        "id": 1975643,
                        "row_count": 886
                    },
                    {
                        "id": 1153588,
                        "row_count": 843
                    },
                    {
                        "id": 1036572,
                        "row_count": 16015
                    },
                    {
                        "id": 1470752,
                        "row_count": 859
                    },
                    {
                        "id": 1269231,
                        "row_count": 855
                    },
                    {
                        "id": 969085,
                        "row_count": 16502
                    },
                    {
                        "id": 1803092,
                        "row_count": 877
                    },
                    {
                        "id": 1486018,
                        "row_count": 860
                    },
                    {
                        "id": 1339868,
                        "row_count": 858
                    },
                    {
                        "id": 1074638,
                        "row_count": 16016
                    },
                    {
                        "id": 1545968,
                        "row_count": 861
                    },
                    {
                        "id": 1862928,
                        "row_count": 882
                    },
                    {
                        "id": 1559484,
                        "row_count": 863
                    },
                    {
                        "id": 1614521,
                        "row_count": 864
                    },
                    {
                        "id": 1531180,
                        "row_count": 861
                    },
                    {
                        "id": 1585782,
                        "row_count": 864
                    },
                    {
                        "id": 1676567,
                        "row_count": 866
                    },
                    {
                        "id": 1226708,
                        "row_count": 851
                    },
                    {
                        "id": 1392668,
                        "row_count": 859
                    },
                    {
                        "id": 1143093,
                        "row_count": 843
                    },
                    {
                        "id": 1436863,
                        "row_count": 859
                    },
                    {
                        "id": 978913,
                        "row_count": 16503
                    },
                    {
                        "id": 1315790,
                        "row_count": 857
                    },
                    {
                        "id": 1183593,
                        "row_count": 844
                    },
                    {
                        "id": 1070960,
                        "row_count": 16022
                    },
                    {
                        "id": 1892691,
                        "row_count": 883
                    },
                    {
                        "id": 1246358,
                        "row_count": 854
                    },
                    {
                        "id": 1642217,
                        "row_count": 864
                    },
                    {
                        "id": 1994643,
                        "row_count": 886
                    },
                    {
                        "id": 1467777,
                        "row_count": 859
                    },
                    {
                        "id": 1235434,
                        "row_count": 851
                    },
                    {
                        "id": 1923807,
                        "row_count": 883
                    },
                    {
                        "id": 1658295,
                        "row_count": 866
                    },
                    {
                        "id": 1383509,
                        "row_count": 858
                    },
                    {
                        "id": 1959262,
                        "row_count": 885
                    },
                    {
                        "id": 1135051,
                        "row_count": 842
                    },
                    {
                        "id": 1933707,
                        "row_count": 883
                    },
                    {
                        "id": 1341766,
                        "row_count": 858
                    },
                    {
                        "id": 1121114,
                        "row_count": 16046
                    },
                    {
                        "id": 1431026,
                        "row_count": 859
                    },
                    {
                        "id": 1902365,
                        "row_count": 883
                    },
                    {
                        "id": 1055092,
                        "row_count": 16003
                    },
                    {
                        "id": 1845939,
                        "row_count": 882
                    },
                    {
                        "id": 1402589,
                        "row_count": 859
                    },
                    {
                        "id": 1042784,
                        "row_count": 15986
                    },
                    {
                        "id": 961474,
                        "row_count": 16497
                    },
                    {
                        "id": 1792518,
                        "row_count": 874
                    },
                    {
                        "id": 1631821,
                        "row_count": 864
                    },
                    {
                        "id": 1174468,
                        "row_count": 844
                    },
                    {
                        "id": 1933705,
                        "row_count": 883
                    },
                    {
                        "id": 1830176,
                        "row_count": 882
                    },
                    {
                        "id": 1191695,
                        "row_count": 844
                    },
                    {
                        "id": 1158305,
                        "row_count": 843
                    },
                    {
                        "id": 1291363,
                        "row_count": 856
                    },
                    {
                        "id": 1326359,
                        "row_count": 857
                    },
                    {
                        "id": 1144423,
                        "row_count": 843
                    },
                    {
                        "id": 1149122,
                        "row_count": 843
                    },
                    {
                        "id": 1545839,
                        "row_count": 861
                    },
                    {
                        "id": 1449393,
                        "row_count": 859
                    },
                    {
                        "id": 1384393,
                        "row_count": 858
                    },
                    {
                        "id": 1475990,
                        "row_count": 859
                    },
                    {
                        "id": 1599474,
                        "row_count": 864
                    },
                    {
                        "id": 1339873,
                        "row_count": 858
                    },
                    {
                        "id": 1007558,
                        "row_count": 16526
                    },
                    {
                        "id": 1425516,
                        "row_count": 860
                    },
                    {
                        "id": 1216977,
                        "row_count": 849
                    },
                    {
                        "id": 1902370,
                        "row_count": 883
                    },
                    {
                        "id": 1923800,
                        "row_count": 883
                    },
                    {
                        "id": 928222,
                        "row_count": 16413
                    },
                    {
                        "id": 1163758,
                        "row_count": 843
                    },
                    {
                        "id": 1559697,
                        "row_count": 863
                    },
                    {
                        "id": 1565833,
                        "row_count": 863
                    },
                    {
                        "id": 1875425,
                        "row_count": 882
                    },
                    {
                        "id": 1814585,
                        "row_count": 877
                    },
                    {
                        "id": 1133632,
                        "row_count": 841
                    },
                    {
                        "id": 1056102,
                        "row_count": 16003
                    },
                    {
                        "id": 1237203,
                        "row_count": 851
                    },
                    {
                        "id": 1991998,
                        "row_count": 886
                    },
                    {
                        "id": 1731040,
                        "row_count": 871
                    },
                    {
                        "id": 1360498,
                        "row_count": 858
                    },
                    {
                        "id": 1372096,
                        "row_count": 858
                    },
                    {
                        "id": 1460254,
                        "row_count": 859
                    },
                    {
                        "id": 1415193,
                        "row_count": 860
                    },
                    {
                        "id": 1767839,
                        "row_count": 873
                    },
                    {
                        "id": 1287633,
                        "row_count": 856
                    },
                    {
                        "id": 1516958,
                        "row_count": 861
                    },
                    {
                        "id": 1566302,
                        "row_count": 863
                    },
                    {
                        "id": 1339874,
                        "row_count": 858
                    },
                    {
                        "id": 1097106,
                        "row_count": 16022
                    },
                    {
                        "id": 1692780,
                        "row_count": 866
                    },
                    {
                        "id": 1565725,
                        "row_count": 863
                    },
                    {
                        "id": 1257645,
                        "row_count": 854
                    },
                    {
                        "id": 1565785,
                        "row_count": 863
                    },
                    {
                        "id": 1935154,
                        "row_count": 883
                    },
                    {
                        "id": 1717009,
                        "row_count": 870
                    },
                    {
                        "id": 951379,
                        "row_count": 16445
                    },
                    {
                        "id": 1301697,
                        "row_count": 856
                    },
                    {
                        "id": 1914495,
                        "row_count": 883
                    },
                    {
                        "id": 1467951,
                        "row_count": 859
                    },
                    {
                        "id": 1531021,
                        "row_count": 861
                    },
                    {
                        "id": 1158078,
                        "row_count": 843
                    },
                    {
                        "id": 1745362,
                        "row_count": 873
                    },
                    {
                        "id": 1545477,
                        "row_count": 861
                    },
                    {
                        "id": 1149121,
                        "row_count": 843
                    },
                    {
                        "id": 1886724,
                        "row_count": 882
                    },
                    {
                        "id": 1752705,
                        "row_count": 873
                    },
                    {
                        "id": 1780287,
                        "row_count": 873
                    },
                    {
                        "id": 1821522,
                        "row_count": 880
                    },
                    {
                        "id": 1149118,
                        "row_count": 843
                    },
                    {
                        "id": 1392569,
                        "row_count": 859
                    },
                    {
                        "id": 1886732,
                        "row_count": 882
                    },
                    {
                        "id": 1914505,
                        "row_count": 883
                    },
                    {
                        "id": 1449436,
                        "row_count": 859
                    },
                    {
                        "id": 1892677,
                        "row_count": 883
                    },
                    {
                        "id": 1349783,
                        "row_count": 858
                    },
                    {
                        "id": 1281173,
                        "row_count": 856
                    },
                    {
                        "id": 1336821,
                        "row_count": 858
                    },
                    {
                        "id": 1496349,
                        "row_count": 860
                    },
                    {
                        "id": 1506338,
                        "row_count": 860
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_136770",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_91803",
                        "name": "main_temp",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62492",
            "name": "Asset_VP+ALC_V3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994717,
                        "row_count": 285
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_67252",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_67118",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62249",
            "name": "MasterV3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994824,
                        "row_count": 14760141
                    },
                    {
                        "id": 1994818,
                        "row_count": 56539
                    },
                    {
                        "id": 1994809,
                        "row_count": 39777
                    },
                    {
                        "id": 1750831,
                        "row_count": 32395
                    },
                    {
                        "id": 1994702,
                        "row_count": 1453673
                    },
                    {
                        "id": 1994649,
                        "row_count": 807197
                    },
                    {
                        "id": 1994691,
                        "row_count": 101305
                    },
                    {
                        "id": 1994834,
                        "row_count": 6226840
                    },
                    {
                        "id": 1940708,
                        "row_count": 33418284
                    },
                    {
                        "id": 1994661,
                        "row_count": 7651
                    },
                    {
                        "id": 1994822,
                        "row_count": 2332
                    },
                    {
                        "id": 1994816,
                        "row_count": 2069734
                    },
                    {
                        "id": 1994698,
                        "row_count": 88798
                    },
                    {
                        "id": 1994755,
                        "row_count": 4492
                    },
                    {
                        "id": 1994623,
                        "row_count": 40
                    },
                    {
                        "id": 1677413,
                        "row_count": 188612
                    },
                    {
                        "id": 1994841,
                        "row_count": 10818373
                    },
                    {
                        "id": 1994815,
                        "row_count": 2616
                    },
                    {
                        "id": 1994797,
                        "row_count": 246
                    },
                    {
                        "id": 1994632,
                        "row_count": 721
                    },
                    {
                        "id": 1994807,
                        "row_count": 754
                    },
                    {
                        "id": 1923724,
                        "row_count": 4312665
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_66951",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_66958",
                        "name": "Coaching Completed - to Master",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_66960",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_66970",
                        "name": "Coaching Scheduled - to Master",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67102",
                        "name": "Phone Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67103",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67108",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67109",
                        "name": "Phone Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67110",
                        "name": "Email Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67111",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67122",
                        "name": "Email Name Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_71696",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_71711",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_80146",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_102084",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_153512",
                        "name": "Additional Lives Discussed",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_155843",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_175390",
                        "name": "RegistrationMain",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_184303",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_218958",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_218977",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_221298",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_227071",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_203606",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_68906",
            "name": "Case Rate Activity",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994889,
                        "row_count": 27942
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_203606",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_227071",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_73615",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_50533",
            "name": "2H August 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 809024,
                        "row_count": 130088
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_50533",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_54643",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_50940",
            "name": "Whil Client Data Source 07-July 2022",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 810648,
                        "row_count": 12
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_50940",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_55112",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_206916",
            "name": "AccentureMembers 2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994748,
                        "row_count": 14750
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_53980",
            "name": "2H September 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 828585,
                        "row_count": 52499
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_53980",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_58225",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_53991",
            "name": "2022-09-12-Group Text.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 828634,
                        "row_count": 40
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_53991",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_58241",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62263",
            "name": "2022-Dec-First Half-Individual Text Report sw.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 891941,
                        "row_count": 1479
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_62263",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66853",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62264",
            "name": "2022-Dec-Second Half-Individual Text Report sw.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 891942,
                        "row_count": 10
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_62264",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66852",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_50230",
            "name": "MembersV2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1755302,
                        "row_count": 170231
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_56649",
                        "name": "WHIL_ONLY",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_54320",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_52162",
            "name": "MembersV2 Export View",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1755303,
                        "row_count": 170231
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_54320",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_56384",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_65897",
                        "name": "EB_Member",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_50679",
            "name": "Whil_Rethink_Duplicates_ForReview",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1755305,
                        "row_count": 0
                    },
                    {
                        "id": 1755304,
                        "row_count": 0
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_54320",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_56649",
                        "name": "WHIL_ONLY",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_54819",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_75378",
            "name": "WhilUserCreations_TeamAdminID",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 951600,
                        "row_count": 121
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_75378",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_80145",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_78286",
            "name": "Training_History_temp",
            "type": "dataset",
            "properties": {
                "batches": [],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4279",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataset_169559",
            "name": "DiscussionGroups_Registration",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994589,
                        "row_count": 795
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_5556",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_182696",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_175390",
                        "name": "RegistrationMain",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_151184",
            "name": "TaggedKeywords",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994609,
                        "row_count": 4565
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_5098",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_157236",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62357",
            "name": "Coaching",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994605,
                        "row_count": 102609
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4034",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66970",
                        "name": "Coaching Scheduled - to Master",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_66958",
                        "name": "Coaching Completed - to Master",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_153512",
                        "name": "Additional Lives Discussed",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_83076",
                        "name": "QA",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_160541",
                        "name": "Completed - QA",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_140638",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_155454",
                        "name": "NDTopics",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_175676",
            "name": "ABTest_Recommender",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1642216,
                        "row_count": 5235
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_5794",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_181309",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62351",
            "name": "CompanyV3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994593,
                        "row_count": 1709607
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4031",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66949",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67181",
                        "name": "View 2",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_166984",
            "name": "UserSearch",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994700,
                        "row_count": 42610
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_5482",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_172866",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62347",
            "name": "Diagnosis_V3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994633,
                        "row_count": 35535
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4029",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_168006",
                        "name": "Austism",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_168142",
                        "name": "LessNoDiagnosis",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67283",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_168010",
                        "name": "ADHD",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_110084",
            "name": "AvgTimeToScheduleConsultation",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994683,
                        "row_count": 98550
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4418",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_183099",
                        "name": "WaitTimeByMonth",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_183093",
                        "name": "WaitTimeByWeek",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_165400",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_172866",
            "name": "MemberYearCaseRate",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994891,
                        "row_count": 1585
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_203606",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_227071",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_207346",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_178576",
                        "name": "RD",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_164848",
            "name": "AccentureOnly",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994888,
                        "row_count": 127881
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_203606",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_227071",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_199921",
                        "name": "FiscalYear",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_199925",
                        "name": "Cumulative",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_170776",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_16484",
            "name": "EZTexting Individual",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 683106,
                        "row_count": 867
                    },
                    {
                        "id": 298801,
                        "row_count": 2397
                    },
                    {
                        "id": 460802,
                        "row_count": 1637
                    },
                    {
                        "id": 1430925,
                        "row_count": 75171
                    },
                    {
                        "id": 708844,
                        "row_count": 459
                    },
                    {
                        "id": 1097141,
                        "row_count": 25514
                    },
                    {
                        "id": 846824,
                        "row_count": 1435
                    },
                    {
                        "id": 1055108,
                        "row_count": 7712
                    },
                    {
                        "id": 608977,
                        "row_count": 1154
                    },
                    {
                        "id": 832355,
                        "row_count": 855
                    },
                    {
                        "id": 784307,
                        "row_count": 984
                    },
                    {
                        "id": 792225,
                        "row_count": 669
                    },
                    {
                        "id": 784309,
                        "row_count": 880
                    },
                    {
                        "id": 872829,
                        "row_count": 738
                    },
                    {
                        "id": 536190,
                        "row_count": 1036
                    },
                    {
                        "id": 1074649,
                        "row_count": 6603
                    },
                    {
                        "id": 633379,
                        "row_count": 1252
                    },
                    {
                        "id": 724441,
                        "row_count": 1312
                    },
                    {
                        "id": 766628,
                        "row_count": 1026
                    },
                    {
                        "id": 747420,
                        "row_count": 1066
                    },
                    {
                        "id": 809083,
                        "row_count": 736
                    },
                    {
                        "id": 952351,
                        "row_count": 480
                    },
                    {
                        "id": 471228,
                        "row_count": 1623
                    },
                    {
                        "id": 435171,
                        "row_count": 1633
                    },
                    {
                        "id": 872826,
                        "row_count": 868
                    },
                    {
                        "id": 832358,
                        "row_count": 1544
                    },
                    {
                        "id": 776251,
                        "row_count": 879
                    },
                    {
                        "id": 1007537,
                        "row_count": 355
                    },
                    {
                        "id": 892038,
                        "row_count": 1479
                    },
                    {
                        "id": 228548,
                        "row_count": 2483
                    },
                    {
                        "id": 372448,
                        "row_count": 925
                    },
                    {
                        "id": 766631,
                        "row_count": 874
                    },
                    {
                        "id": 832356,
                        "row_count": 886
                    },
                    {
                        "id": 1933661,
                        "row_count": 100000
                    },
                    {
                        "id": 1336407,
                        "row_count": 47200
                    },
                    {
                        "id": 708845,
                        "row_count": 806
                    },
                    {
                        "id": 1847918,
                        "row_count": 43183
                    },
                    {
                        "id": 670789,
                        "row_count": 1550
                    },
                    {
                        "id": 1565697,
                        "row_count": 146125
                    },
                    {
                        "id": 254578,
                        "row_count": 1360
                    },
                    {
                        "id": 1470676,
                        "row_count": 22126
                    },
                    {
                        "id": 747451,
                        "row_count": 1046
                    },
                    {
                        "id": 1383373,
                        "row_count": 49551
                    },
                    {
                        "id": 696182,
                        "row_count": 990
                    },
                    {
                        "id": 280048,
                        "row_count": 1558
                    },
                    {
                        "id": 392138,
                        "row_count": 964
                    },
                    {
                        "id": 1123418,
                        "row_count": 627
                    },
                    {
                        "id": 926406,
                        "row_count": 740
                    },
                    {
                        "id": 266843,
                        "row_count": 1579
                    },
                    {
                        "id": 926409,
                        "row_count": 2686
                    },
                    {
                        "id": 410690,
                        "row_count": 929
                    },
                    {
                        "id": 562512,
                        "row_count": 978
                    },
                    {
                        "id": 776247,
                        "row_count": 898
                    },
                    {
                        "id": 683102,
                        "row_count": 1192
                    },
                    {
                        "id": 1631746,
                        "row_count": 103752
                    },
                    {
                        "id": 160062,
                        "row_count": 965
                    },
                    {
                        "id": 515883,
                        "row_count": 2383
                    },
                    {
                        "id": 809079,
                        "row_count": 683
                    },
                    {
                        "id": 448187,
                        "row_count": 2725
                    },
                    {
                        "id": 674931,
                        "row_count": 1148
                    },
                    {
                        "id": 952379,
                        "row_count": 461
                    },
                    {
                        "id": 577577,
                        "row_count": 842
                    },
                    {
                        "id": 1506226,
                        "row_count": 59917
                    },
                    {
                        "id": 665624,
                        "row_count": 2576
                    },
                    {
                        "id": 832359,
                        "row_count": 1660
                    },
                    {
                        "id": 828639,
                        "row_count": 566
                    },
                    {
                        "id": 593289,
                        "row_count": 992
                    },
                    {
                        "id": 828636,
                        "row_count": 577
                    },
                    {
                        "id": 1237160,
                        "row_count": 21586
                    },
                    {
                        "id": 481550,
                        "row_count": 1128
                    },
                    {
                        "id": 696172,
                        "row_count": 583
                    },
                    {
                        "id": 1199891,
                        "row_count": 32367
                    },
                    {
                        "id": 1692712,
                        "row_count": 83967
                    },
                    {
                        "id": 350681,
                        "row_count": 1478
                    },
                    {
                        "id": 978935,
                        "row_count": 698
                    },
                    {
                        "id": 1158047,
                        "row_count": 27306
                    },
                    {
                        "id": 160063,
                        "row_count": 6493
                    },
                    {
                        "id": 832357,
                        "row_count": 839
                    },
                    {
                        "id": 426751,
                        "row_count": 1454
                    },
                    {
                        "id": 160061,
                        "row_count": 1168
                    },
                    {
                        "id": 1036579,
                        "row_count": 4335
                    },
                    {
                        "id": 792361,
                        "row_count": 595
                    },
                    {
                        "id": 978938,
                        "row_count": 366
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_16484",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_67102",
                        "name": "Phone Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67103",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_20826",
                        "name": "Unmatched",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_178780",
            "name": "DiscussionGroups_Attendance",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994587,
                        "row_count": 210
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_5822",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_195367",
                        "name": "View 2",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_184303",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_148158",
            "name": "brazemammoth",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994588,
                        "row_count": 2871058
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4900",
                        "name": "databricks",
                        "type": "databricks",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_162488",
                        "name": "SoftBounce",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_155843",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_154263",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_142513",
            "name": "AccountAttributes",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994592,
                        "row_count": 40360
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4803",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_148859",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_164989",
            "name": "Utilization_for_Mammoth",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994599,
                        "row_count": 160
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_5429",
                        "name": "salesforcecdata",
                        "type": "salesforcecdata",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_170919",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_162210",
            "name": "UserFeedback",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994597,
                        "row_count": 68966
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_5369",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_168067",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_129485",
            "name": "SF_AssetsViaAPI_QZ",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994709,
                        "row_count": 1234
                    },
                    {
                        "id": 1994626,
                        "row_count": 856
                    },
                    {
                        "id": 1994641,
                        "row_count": 993
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4639",
                        "name": "salesforcecdata",
                        "type": "salesforcecdata",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_135885",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_135888",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_135886",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_169565",
            "name": "TherapistPortalBenefitReferral",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994613,
                        "row_count": 51545
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_5558",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_175396",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_175633",
            "name": "UserOnboadingSelections",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994612,
                        "row_count": 73981
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_5789",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_181273",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_166863",
            "name": "EsteeLauderCaseRate",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994890,
                        "row_count": 98700
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_203606",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_227071",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_172745",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_129481",
            "name": "SF_Accounts_viaAPI",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994627,
                        "row_count": 886
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4636",
                        "name": "salesforcecdata",
                        "type": "salesforcecdata",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_135887",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_97216",
            "name": "Content_Pulled",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1007092,
                        "row_count": 205874
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_97216",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_102084",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_122983",
            "name": "Parenting_Assessment",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1931853,
                        "row_count": 216430
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4540",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_146058",
                        "name": "stress post test",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_160195",
                        "name": "stress pre test",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_160225",
                        "name": "conf post test",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_160222",
                        "name": "conf pre test",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_128794",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_221388",
                        "name": "View 2",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62359",
            "name": "Text",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994603,
                        "row_count": 17529
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4036",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66960",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_16647",
            "name": "SP_Platform_Members",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 898657,
                        "row_count": 170276
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1161",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21843",
                        "name": "Source",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_66983",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_32199",
                        "name": "PROBABLY DELETE - New Export View",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_32644",
                        "name": "New Members Export View",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_33439",
                        "name": "Testing Group and Aggregate",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_17116",
            "name": "SP_EB_Company",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 898661,
                        "row_count": 86934
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1179",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_18913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19144",
            "name": "Domain_Ref_Table",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 193697,
                        "row_count": 282
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19144",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_20912",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19169",
            "name": "Vend_2H_June_cleaned.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 193773,
                        "row_count": 17649
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19169",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_20930",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19171",
            "name": "Vend_1H_June.xlsx_Email_Delivered_Prospects____Be",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 193782,
                        "row_count": 24086
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19171",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_20932",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19173",
            "name": "Grp_2H_June.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 193789,
                        "row_count": 1809
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19173",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_20933",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19174",
            "name": "Ind_1H_June.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 193790,
                        "row_count": 855
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19174",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_20934",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19176",
            "name": "Ind_2H_June.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 193792,
                        "row_count": 886
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19176",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_20936",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19347",
            "name": "EZTexting Group RAW 2H MAY GroupTextClicks2HMay2020.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 194522,
                        "row_count": 1349
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19347",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21116",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19348",
            "name": "EZTexting Group RAW 1H MAY Group Text Click Template 05-15-2020.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 194523,
                        "row_count": 625
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19348",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21117",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19349",
            "name": "Grp_1H_June_v2.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 194525,
                        "row_count": 1844
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19349",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21118",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19362",
            "name": "Client_Reference_old",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 266173,
                        "row_count": 222
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19362",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21133",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19392",
            "name": "EB_Count_WatchVideos_06-01-2020_07-01-2020",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 194763,
                        "row_count": 426
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1275",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21161",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19394",
            "name": "EDU_Count_WatchVideos_06-01-2020'_07-01-2020",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 194766,
                        "row_count": 1186
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1276",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21163",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19395",
            "name": "BH_Count_WatchVideos_06-01-2020_07-01-2020",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 194767,
                        "row_count": 34
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1277",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21164",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19396",
            "name": "EZTexting Individual RAW 1H MAY Clicks5_15_2020.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 194770,
                        "row_count": 965
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19396",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21165",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19397",
            "name": "EZTexting Individual RAW 2H MAY IndividualClicks2HMay2020.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 194771,
                        "row_count": 1168
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19397",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21166",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19398",
            "name": "EZTexting Individual RAW JAN-APR sent_messages_1588791961.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 194772,
                        "row_count": 6493
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19398",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21167",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19399",
            "name": "VENDOR RAW 1H APR 2020-04-17 - EB Engagement - April - Clinical Combinedv2.xlsx_2020-04-17 - EB Engagement - Ap",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 194773,
                        "row_count": 47655
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19399",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21168",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19400",
            "name": "VENDOR PREPPED FULL FEB 2020-03-03 - Benefits - February Clinical Data Combined.xlsx_Email_Click_Prospects__Benefits",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 194774,
                        "row_count": 63440
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19400",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21169",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19501",
            "name": "Content Video Name Mapping",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 350804,
                        "row_count": 1073
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19501",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21276",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19712",
            "name": "EZTexting Group PREPPED JAN-APR EZtexting Group Clicks 2020 Jan-Apr 05-01-2020.xlsx_EZtexting_Clicks_1_2_2020",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 195934,
                        "row_count": 6842
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19712",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21491",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19714",
            "name": "VENDOR RAW 1H APR 2020-04-17 - EB Engagement - April - Clinical Combinedv2.xlsx_2020-04-17 - EB Engagement - Ap 2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 195938,
                        "row_count": 47655
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19714",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21493",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19718",
            "name": "VENDOR RAW  2H APR 2020-05-01 - EB - April Clinical Data Combined.xlsx_Email_Open_Prospects____2020_04",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 195967,
                        "row_count": 31326
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19718",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21497",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_19728",
            "name": "VENDOR RAW FULL MARCH 2020-03-31 - Benefits - Engagement - Combined Clinical for March.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 195984,
                        "row_count": 101252
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_19728",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21507",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_21081",
            "name": "JulyFirstHalf2020IndividualTextClick.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 200293,
                        "row_count": 839
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_21081",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_22893",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_21082",
            "name": "JulyFirstHalfGroupTexts.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 200295,
                        "row_count": 1306
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_21082",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_22894",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_21084",
            "name": "JulyFirstHalf - Mid Month Engagement.xlsx_Email_Click_Prospects__2020_07_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 200297,
                        "row_count": 21556
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_21084",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_22896",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_23941",
            "name": "2H July 2020 EZ Text Group.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 216254,
                        "row_count": 2954
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_23941",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_25764",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_23942",
            "name": "2H July 2020 EZ Text Individual.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 216255,
                        "row_count": 1544
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_23942",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_25765",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_23947",
            "name": "2020-08-03 - EB - July - End of Month Engagement.xlsx_Email_Click_Prospects__2020_07_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 216274,
                        "row_count": 39352
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_23947",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_25770",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_24060",
            "name": "MonthlyReports_EB_Count_WatchVideos_July",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 216897,
                        "row_count": 751
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1335",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_25875",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_24090",
            "name": "MonthlyReports_BH_Count_WatchVideos_July",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 217051,
                        "row_count": 38
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1337",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_25904",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_24092",
            "name": "MonthlyReports_EDU_Count_WatchVideos_July",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 217054,
                        "row_count": 1171
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1338",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_25906",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_28365",
            "name": "Crosstab",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 261023,
                        "row_count": 701
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_28365",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_30207",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_28518",
            "name": "2020-09-01 - EB - August - EOM Engagement.xlsx_Email_Click_Prospects__2020_07_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 241945,
                        "row_count": 46664
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_28518",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_30357",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_28520",
            "name": "August 2nd half individual clicks.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 241948,
                        "row_count": 1660
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_28520",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_30359",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_28521",
            "name": "SecondHalfAugust2020GroupTextClicks.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 241949,
                        "row_count": 1996
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_28521",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_30360",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_28676",
            "name": "MonthlyReports_EB_Count_WatchVideos_08-01-2020_09-01-2020",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 242820,
                        "row_count": 630
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1362",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_30512",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_28677",
            "name": "MonthlyReports_EDU_Count_WatchVideos_08-01-2020_09-01-2020",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 242822,
                        "row_count": 1294
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1363",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_30514",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_28679",
            "name": "MonthlyReports_BH_Count_WatchVideos_08-01-2020_09-01-2020",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 242825,
                        "row_count": 34
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1364",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_30515",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30260",
            "name": "MonthlyReports_EB_Child_Profile",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 891325,
                        "row_count": 79236
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1411",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32053",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30261",
            "name": "MonthlyReports_EB_Diagnosis",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 891323,
                        "row_count": 22941
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1412",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32054",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30262",
            "name": "MonthlyReports_EB_Areas_of_Concern",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 891322,
                        "row_count": 97206
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1413",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32055",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30461",
            "name": "GroupTextsSecondHalfSept2020.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 266837,
                        "row_count": 1240
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_30461",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32189",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30462",
            "name": "IndividualTextsSecondHalfSept2020.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 266838,
                        "row_count": 1579
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_30462",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32190",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30468",
            "name": "MonthlyReports_EDU_Count_WatchVideos_09-01-2020_10-01-2020",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 266893,
                        "row_count": 1442
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1430",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32203",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30469",
            "name": "MonthlyReports_EB_Count_WatchVideos_09-01-2020_10-01-2020",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 266894,
                        "row_count": 535
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1431",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32204",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30470",
            "name": "MonthlyReports_BH_Count_WatchVideos_09-01-2020_10-01-2020",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 266896,
                        "row_count": 34
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1432",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32205",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30755",
            "name": "Client Data Source - New Version",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 897309,
                        "row_count": 16384
                    },
                    {
                        "id": 279055,
                        "row_count": 1
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_30755",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32400",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_32579",
                        "name": "Client List Export View",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_66871",
                        "name": "temp - deleteme",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_64487",
                        "name": "FT",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_30927",
            "name": "Manual Client List Additions for Upload to Mammoth as Separate Batch 10-15-2020.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 279052,
                        "row_count": 1
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_30927",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32647",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_31035",
            "name": "1H Oct 2020 Individual Texts.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 280037,
                        "row_count": 1558
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_31035",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32764",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_31037",
            "name": "1H Oct 2020 Group Texts.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 280044,
                        "row_count": 2117
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_31037",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32766",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_31619",
            "name": "Second half oct 2020 individual clicks.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 298800,
                        "row_count": 2397
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_31619",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_33361",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_31620",
            "name": "Second half oct 2020 group clicks.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 298799,
                        "row_count": 330
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_31620",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_33360",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_31631",
            "name": "2020-11-02 - EB - October - EOM Engagement.xlsx_Email_Click_Prospects__2020_07_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 298893,
                        "row_count": 49413
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_31631",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_33377",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_32097",
            "name": "1H November 2020 Vendor Data.xlsx_Email_Click_Prospects__2020_07_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 313837,
                        "row_count": 24894
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_32097",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_33859",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_32721",
            "name": "November BH Video Views",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 332951,
                        "row_count": 39
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1703",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_34459",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_32722",
            "name": "November EB Video Views",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 332959,
                        "row_count": 574
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1704",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_34460",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_32768",
            "name": "November EDU Video Views - Rerun",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 334160,
                        "row_count": 1443
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1710",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_34493",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_32807",
            "name": "2H Nov 2020 Vendor Data.xlsx_Email_Click_Prospects__2020_07_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 335611,
                        "row_count": 51350
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_32807",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_34526",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_33147",
            "name": "1H Dec 2020 Vendor Data.xlsx_Email_Click_Prospects__2020_07_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 350606,
                        "row_count": 51261
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_33147",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_34893",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_33152",
            "name": "FristHalfDecemberIndividualClicks.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 350678,
                        "row_count": 1478
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_33152",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_34897",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_33407",
            "name": "EDU December 2020 Video Views",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 371546,
                        "row_count": 1461
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1785",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_35297",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_33408",
            "name": "EB December 2020 Video Views",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 371549,
                        "row_count": 569
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1786",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_35298",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_33425",
            "name": "2H Dec 2020 Vendor Data.xlsx_Email_Click_Prospects__2020_07_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 372440,
                        "row_count": 47453
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_33425",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_35322",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_33426",
            "name": "2H Dec 2020 Group Clicks.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 372445,
                        "row_count": 322
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_33426",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_35323",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_33427",
            "name": "2H Dec 2020 Individual Clicks.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 372446,
                        "row_count": 925
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_33427",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_35324",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_34272",
            "name": "BH Jan 21",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 417265,
                        "row_count": 91
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1950",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_36276",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_34273",
            "name": "EDU Jan 21",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 417267,
                        "row_count": 1602
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1951",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_36277",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_34274",
            "name": "EB Jan 21",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 417270,
                        "row_count": 676
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_1952",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_36278",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_34808",
            "name": "2ndHalfFebGroupTextClicks.xlsx_2ndHalfFebGroupTextClicks",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 435159,
                        "row_count": 478
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_34808",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_36842",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_34809",
            "name": "SecondHalfFebIndividualClicks.xlsx_SecondHalfFebIndividualClicks",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 435161,
                        "row_count": 1633
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_34809",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_36843",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_34842",
            "name": "BH Feb 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 436037,
                        "row_count": 91
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2026",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_36879",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_34843",
            "name": "EDU Feb 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 436041,
                        "row_count": 1647
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2027",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_36880",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_34844",
            "name": "EB Feb 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 436042,
                        "row_count": 640
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2028",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_36881",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_34845",
            "name": "BH Feb 2021 - Updated End Date",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 436046,
                        "row_count": 91
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2029",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_36882",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_34896",
            "name": "2H Feb 2021 Vendor Data 2021-03-01 - EB - February - EOM Engagement Additional Webinars.xlsx_Email_Click_Prospects__2020_07_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 437480,
                        "row_count": 38315
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_34896",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_36943",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35104",
            "name": "Current Client List.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 447331,
                        "row_count": 5270
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_35104",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_37138",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35142",
            "name": "1H March 2021 Vendor Data 2021-03-16 - EB - March - MM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 448141,
                        "row_count": 30877
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_35142",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_37176",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35143",
            "name": "EZTexting_individualtexts_FIRSTHALF_March 21.xlsx_EZTexting_individualtexts_FIRST",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 448185,
                        "row_count": 2725
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_35143",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_37177",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35357",
            "name": "2H March 2021 Vendor Data 2021-03-31 - EB - March - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 460791,
                        "row_count": 62763
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_35357",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_37485",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35358",
            "name": "2H March 2021 Group Text Data 2021-03-31 - EB - March - EOM Engagement.xlsx_GroupMessages_SECONDHALF_March2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 460796,
                        "row_count": 104
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_35358",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_37486",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35359",
            "name": "2H March 2021 Individual Text Data 2021-03-31 - EB - March - EOM Engagement.xlsx_IndividualMessages_SECONDHALF_M",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 460797,
                        "row_count": 1637
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_35359",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_37487",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35360",
            "name": "BH March 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 460924,
                        "row_count": 90
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2100",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_37488",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35361",
            "name": "EDU March 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 460925,
                        "row_count": 1522
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2101",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_37489",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35362",
            "name": "EB March 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 460926,
                        "row_count": 740
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2102",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_37490",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35579",
            "name": "1H April 2021 Vendor Data 2021-04-19 - EB - April - MM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 471209,
                        "row_count": 62261
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_35579",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_37759",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35580",
            "name": "IndividualTextMessage_FirstHalf_April2021.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 471227,
                        "row_count": 1623
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_35580",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_37760",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_35955",
            "name": "IndividualMessages_SecondHalf_April2021.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 481544,
                        "row_count": 1128
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_35955",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_38156",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_36106",
            "name": "BH April 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 486033,
                        "row_count": 90
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2175",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_38302",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_36107",
            "name": "EDU April 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 486038,
                        "row_count": 1515
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2176",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_38303",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_36753",
            "name": "2H May 2021 Vendor Data 2021-06-03 - EB - May - EOM Engagement.xlsx_Sheet2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 515878,
                        "row_count": 27408
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_36753",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_38956",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_36754",
            "name": "May2021IndividualClicks.xlsx_May2021IndividualClicks",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 515879,
                        "row_count": 2383
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_36754",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_38957",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_36798",
            "name": "BH May 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 523444,
                        "row_count": 91
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2299",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_39029",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_36799",
            "name": "EB May 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 523446,
                        "row_count": 666
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2300",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_39030",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_36964",
            "name": "June2021-MM-INDIVIDUAL.xlsx_June2021-MM-INDIVIDUAL",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 536188,
                        "row_count": 1036
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_36964",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_39178",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_36965",
            "name": "JUNE2021 - FirstHalfJuneGroupTextClicks.xlsx_FirstHalfJuneGroupTextClicks",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 536195,
                        "row_count": 954
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_36965",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_39179",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_37599",
            "name": "2021-07-01 - 2ndhalf-individualclicks.xlsx_Second halfjuneindividual click",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 562506,
                        "row_count": 978
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_37599",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_39818",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_37627",
            "name": "BH June 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 563701,
                        "row_count": 91
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2394",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_39852",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_37628",
            "name": "EDU June 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 563702,
                        "row_count": 1395
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2395",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_39853",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_37866",
            "name": "1H July 2021 Vendor Data 2021-07-16 - EB - July - MM Engagement.xlsx_Sheet3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 577569,
                        "row_count": 60195
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_37866",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_40113",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_37867",
            "name": "FirstHalfJulyGroup.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 577573,
                        "row_count": 502
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_37867",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_40115",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_37868",
            "name": "FirstHalfJulyIndividual.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 577571,
                        "row_count": 842
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_37868",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_40114",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_38217",
            "name": "2021-07-31 - Individual sent_messages_1628004708.xlsx_sent_messages_1628004708",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 593267,
                        "row_count": 992
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_38217",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_40479",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_38218",
            "name": "2021-07-31 - Second half July Group Clicks.xlsx_Second half July Group Clicks",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 593266,
                        "row_count": 486
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_38218",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_40478",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_38219",
            "name": "2H July 2021 Vendor Data 2021-07-31 - EB - July - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 593271,
                        "row_count": 57737
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_38219",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_40480",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_38263",
            "name": "EDU July 21",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 595390,
                        "row_count": 1181
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2514",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_40524",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_38264",
            "name": "EB July 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 595391,
                        "row_count": 610
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2515",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_40525",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_129483",
            "name": "SF_AssetsViaAPI_AG",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994708,
                        "row_count": 1234
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4637",
                        "name": "salesforcecdata",
                        "type": "salesforcecdata",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_135885",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_38603",
            "name": "2021-08 - First half august clicks group.xlsx_First half august clicks group",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 608973,
                        "row_count": 474
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_38603",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_40895",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_38604",
            "name": "2021-08 - Firsthalfaugustinvidualclicks.xlsx_Firsthalfaugustinvidualclicks",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 608972,
                        "row_count": 1154
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_38604",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_40894",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_38605",
            "name": "1H August 2021 Vendor Data 2021-08-16 - EB - August - MM Engagement.xlsx_Sheet2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 608974,
                        "row_count": 29286
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_38605",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_40896",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_39064",
            "name": "2H August 2021 Vendor Data 2021-09-06 - EB - August - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 632239,
                        "row_count": 64853
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_39064",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_41404",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_39190",
            "name": "BH August 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 638625,
                        "row_count": 90
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2615",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_41536",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_39191",
            "name": "EDU August 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 638634,
                        "row_count": 1593
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2616",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_41537",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_39192",
            "name": "EB August 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 638642,
                        "row_count": 725
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2617",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_41538",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_39325",
            "name": "1H September 2021 Vendor Data 2021-09-16 - EB - September - MM Engagement.xlsx_New",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 647582,
                        "row_count": 27296
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_39325",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_41726",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_129484",
            "name": "SF_AssetsviaAPI_HP",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994631,
                        "row_count": 993
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4638",
                        "name": "salesforcecdata",
                        "type": "salesforcecdata",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_135888",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_39688",
            "name": "Participant Texting Data - Group - SECOND HALF - Sept 2021.xlsx_272348550_detailed_click_stats_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 665571,
                        "row_count": 470
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_39688",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_42314",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_39690",
            "name": "2H September 2021 Vendor Data 2021-10-05 - EB - September - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 665573,
                        "row_count": 68864
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_39690",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_42316",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_39695",
            "name": "Sept2021IndividualTexts-fullmonth.xlsx_Sept2021IndividualTexts",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 665621,
                        "row_count": 2576
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_39695",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_42329",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_39743",
            "name": "BH September 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 665994,
                        "row_count": 90
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2682",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_42398",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_39744",
            "name": "EDU September 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 665995,
                        "row_count": 1727
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2683",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_42399",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_39745",
            "name": "EB September 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 665998,
                        "row_count": 681
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2684",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_42400",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_40099",
            "name": "Oct 2021 - FIRST HALF - Individual Texting Data.xlsx_sent_messages_1634331531",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 670786,
                        "row_count": 1550
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_40099",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_42713",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_40100",
            "name": "1H October 2021 Vendor Data 2021-10-15 - EB - October - MM Engagement.xlsx_Sheet2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 670787,
                        "row_count": 83983
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_40100",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_42714",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_40456",
            "name": "2H October 2021 Vendor Data 2021-11-01 - EB - October - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 674917,
                        "row_count": 37240
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_40456",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_43187",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_40457",
            "name": "Oct 2021 - SECOND HALF - Individual Texting Data.xlsx_sent_messages_1635797330",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 674921,
                        "row_count": 1148
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_40457",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_43188",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_40458",
            "name": "Oct 2021 - SECOND HALF - Group Texting Data.xlsx_276035477_detailed_click_stats_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 674923,
                        "row_count": 600
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_40458",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_43189",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_40505",
            "name": "BH October 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 676296,
                        "row_count": 90
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2743",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_43239",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_40506",
            "name": "EDU October 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 676297,
                        "row_count": 1717
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2744",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_43240",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_40507",
            "name": "EB October 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 676298,
                        "row_count": 702
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2745",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_43241",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_40898",
            "name": "2021-NOV-SECOND HALF - Group Text Data.xlsx_2021-NOV-SECOND HALF - Group Te",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 683088,
                        "row_count": 691
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_40898",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_43710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_40899",
            "name": "2021-NOV-SECOND HALF - Individual Texting Report.xlsx_2021-NOV-SECOND HALF - Individu",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 683091,
                        "row_count": 867
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_40899",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_43711",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_40900",
            "name": "2021 - NOV - FIRST HALF - Individual Texting Report.xlsx_2021 - NOV - FIRST HALF - Indiv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 683096,
                        "row_count": 1192
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_40900",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_43712",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41111",
            "name": "EB 11-2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 688133,
                        "row_count": 660
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2789",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_43947",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41332",
            "name": "2H December 2021 Vendor Data 2021-01-01 - EB - December - EOM Engagement.xlsx_NEW1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 696149,
                        "row_count": 98810
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_41332",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_44225",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41333",
            "name": "Copy of 2021 - DEC - FIRST HALF - Group Texting Report.xlsx_2021 - DEC - FIRST HALF - Group",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 696153,
                        "row_count": 463
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_41333",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_44226",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41334",
            "name": "Copy of 2021 - DEC - FIRST HALF - Individual Texting Report.xlsx_2021 - DEC - FIRST HALF - Indiv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 696154,
                        "row_count": 990
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_41334",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_44227",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41335",
            "name": "Copy of 2021 - DEC - Second Half - Individual Texting Report.xlsx_2021 - DEC - Second Half - Indi",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 696155,
                        "row_count": 583
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_41335",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_44228",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41351",
            "name": "BH December 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 696642,
                        "row_count": 90
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2804",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_44248",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41352",
            "name": "EB December 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 696643,
                        "row_count": 536
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2805",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_44249",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41353",
            "name": "EDU December 2021",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 696644,
                        "row_count": 1686
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2806",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_44250",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41964",
            "name": "2H January 2021 Vendor Data 2021-02-01 - EB - January- EOM Engagement.xlsx_NEW",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 708829,
                        "row_count": 164712
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_41964",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_45033",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41967",
            "name": "2022 - JAN - FIRST HALF - Group Texting Report.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 708832,
                        "row_count": 282
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_41967",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_45034",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41968",
            "name": "2022 - JAN - SECOND HALF - Individual Texting Report.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 708836,
                        "row_count": 806
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_41968",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_45035",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_41969",
            "name": "2022 - JAN - FIRST HALF - Individual Texting Report.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 708837,
                        "row_count": 459
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_41969",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_45036",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_42121",
            "name": "BH 2022 Jan",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 711998,
                        "row_count": 91
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2894",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_45249",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_42122",
            "name": "EDU 2022 Jan",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 712002,
                        "row_count": 1804
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2895",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_45250",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_42124",
            "name": "EB JAn 2022 - 2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 712003,
                        "row_count": 638
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2897",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_45251",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_42866",
            "name": "2H February 2022 Vendor Data - EB - February - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 724423,
                        "row_count": 163459
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_42866",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_46025",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_42868",
            "name": "2022-Feb-Full Report-Individual Texts (002).xlsx_2022-Feb-Full Report-Individual",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 724426,
                        "row_count": 1312
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_42868",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_46026",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_42870",
            "name": "2022-02-01-Feb Webinars-Group Text.xlsx_2022-02-01-Feb Webinars-Group T",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 724439,
                        "row_count": 543
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_42870",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_46032",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_42871",
            "name": "2022-02-10-DEI Resources Group Text.xlsx_2022-02-10-DEI Resources Group ",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 724438,
                        "row_count": 495
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_42871",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_46031",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_42872",
            "name": "2022-02-15-DEI Resources Send 2 - Group Text.xlsx_2022-02-15-DEI Resources Send 2",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 724434,
                        "row_count": 7
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_42872",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_46028",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_43078",
            "name": "BH February 2022",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 729530,
                        "row_count": 90
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2950",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_46259",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_43079",
            "name": "EDU February 2022",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 729531,
                        "row_count": 1793
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2951",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_46260",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_43080",
            "name": "EB February 2022",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 729533,
                        "row_count": 668
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_2952",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_46261",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_43792",
            "name": "2H March 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 747386,
                        "row_count": 177053
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_43792",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_47086",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_43793",
            "name": "2022-March-First Half-Individual Texting Report.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 747389,
                        "row_count": 1066
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_43793",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_47087",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_43794",
            "name": "2022-March-First Half-Group Text.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 747393,
                        "row_count": 659
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_43794",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_47088",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_43795",
            "name": "2022-03-16_March Second Half_Group Text 1.xlsx_292961500_detailed_click_stats_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 747394,
                        "row_count": 258
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_43795",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_47090",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_43797",
            "name": "2022-03-22_March Second Half_Group Text 3.xlsx_293683085_detailed_click_stats_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 747396,
                        "row_count": 104
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_43797",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_47091",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_43798",
            "name": "2022_March Second Half_Individual Texts.xlsx_sent_messages_1649217345",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 747397,
                        "row_count": 1046
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_43798",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_47092",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_43802",
            "name": "2022-03-30-March Second Half_Group Text 4.xlsx_294777018_detailed_click_stats_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 747401,
                        "row_count": 146
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_43802",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_47093",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_44651",
            "name": "2022-April-FIRST HALF-Group Text.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 765840,
                        "row_count": 172
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_44651",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48075",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_44652",
            "name": "2022-April-FIRST HALF-Individual Texts.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 765841,
                        "row_count": 1026
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_44652",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48076",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_44690",
            "name": "2022-April-SECOND HALF-Individual Texting Report.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 766276,
                        "row_count": 874
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_44690",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48121",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_44892",
            "name": "BH March 22",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 768885,
                        "row_count": 90
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3257",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48357",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_44893",
            "name": "EB March 22",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 768887,
                        "row_count": 735
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3258",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48358",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_44894",
            "name": "EDU March 22",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 768888,
                        "row_count": 1791
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3259",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48359",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_44895",
            "name": "BH April 22",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 768891,
                        "row_count": 90
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3260",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48360",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_44896",
            "name": "EB April 22",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 768892,
                        "row_count": 648
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3261",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48361",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_44897",
            "name": "EDU April 22",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 768894,
                        "row_count": 1747
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3262",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48362",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45268",
            "name": "2H May 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 776237,
                        "row_count": 170450
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45268",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48843",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45269",
            "name": "2022_May_FIRST HALF_Individual Texting Report.xlsx_2022_May_FIRST HALF_Individual ",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 776238,
                        "row_count": 898
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45269",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48845",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45270",
            "name": "2022-May-Second Half-Individual Text Report.xlsx_2022-May-Second Half-Individual",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 776239,
                        "row_count": 879
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45270",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48844",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45271",
            "name": "2022-05-26-WM Engagement Push-Group Text.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 776240,
                        "row_count": 3
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45271",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48846",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45272",
            "name": "2022-05-17-Migration Wave 1 Follow Up- Group Text.xlsx_2022-05-17-Benefits-Users-Migra",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 776241,
                        "row_count": 2
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45272",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48847",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45273",
            "name": "2022_May_FIRST HALF_Group Texting Report_Mental Health Awareness.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 776242,
                        "row_count": 275
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45273",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48848",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45274",
            "name": "2022_May_FIRST HALF_Group Texting Report_Wave 1 Migration.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 776243,
                        "row_count": 2
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45274",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_48849",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45392",
            "name": "BH May 2022",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 777740,
                        "row_count": 90
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3407",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_49079",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45393",
            "name": "EDU May 2022",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 777741,
                        "row_count": 1781
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3408",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_49080",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45394",
            "name": "EB May 2022",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 777742,
                        "row_count": 671
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3409",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_49081",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45904",
            "name": "2022_June_First Half_Group Text_June Employee Wellbeing Webinar Reminder.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 784299,
                        "row_count": 310
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45904",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_49729",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45905",
            "name": "2022_June_First Half_Group Text_June Employee Wellbeing 1.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 784303,
                        "row_count": 264
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45905",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_49733",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45906",
            "name": "2022_June_First Half_Group Text_June Employee Wellbeing 2.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 784304,
                        "row_count": 264
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45906",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_49734",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45907",
            "name": "2022_June_First Half_Group Text_Migration Wave 2.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 784305,
                        "row_count": 22
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45907",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_49735",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45908",
            "name": "June 2022_Second Half_Group Text .xlsx_305107451_detailed_click_stats_",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 784300,
                        "row_count": 14
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45908",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_49730",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45909",
            "name": "Copy of June 2022_Second Half_Individual Texts.xlsx_sent_messages_1657203461",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 784301,
                        "row_count": 880
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45909",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_49731",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_45910",
            "name": "2022_June_First Half_Individual Texting Report.xlsx_2022_June_First Half_Individual",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 784302,
                        "row_count": 984
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_45910",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_49732",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_46044",
            "name": "whil_members_20220705.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 786219,
                        "row_count": 9370
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_46044",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_49876",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_46277",
            "name": "BH June 2022",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 788978,
                        "row_count": 91
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3481",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_50123",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_46278",
            "name": "EDU June 2022",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 788979,
                        "row_count": 1501
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3482",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_50124",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_46279",
            "name": "EB June 2022",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 788980,
                        "row_count": 564
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3483",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_50125",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_46461",
            "name": "2H July 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 792219,
                        "row_count": 256837
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_46461",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_50341",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_46463",
            "name": "2022 July-First Half-7.11 Group Text.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 792221,
                        "row_count": 12
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_46463",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_50342",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_46464",
            "name": "2022 July-First Half-7.7 Group Text.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 792222,
                        "row_count": 38
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_46464",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_50343",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_46465",
            "name": "2022 July-First Half-Individual Text Report.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 792223,
                        "row_count": 669
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_46465",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_50344",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_46471",
            "name": "Copy of 2022-July-Second Half-Individual Texts.xlsx_2022-July-Second Half-Individua",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 792352,
                        "row_count": 595
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_46471",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_50356",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_46472",
            "name": "2022-July-Second Half-Group Text-7.25 Migration.xlsx_2022-July-Second Half-Group Tex",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 792353,
                        "row_count": 21
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_46472",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_50357",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_48213",
            "name": "BH July 2022",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 797897,
                        "row_count": 90
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3525",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_52142",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_48215",
            "name": "EB July 2022",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 797901,
                        "row_count": 562
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3526",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_52144",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_48218",
            "name": "EDU July 2022",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 797907,
                        "row_count": 1139
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3527",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_52147",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_50539",
            "name": "August 2022_Second Half_Group Text.xlsx_August 2022_Second Half_Group T",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 809072,
                        "row_count": 5
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_50539",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_54649",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_50540",
            "name": "Copy of August 2022_Second Half_Individual Texts.xlsx_August 2022_Second Half_Individ",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 809073,
                        "row_count": 736
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_50540",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_54650",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_50541",
            "name": "2022-Aug-First Half Group Text Report-8.4.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 809075,
                        "row_count": 6
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_50541",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_54652",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_50542",
            "name": "2022-Aug-First Half Group Text Report-8.5.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 809078,
                        "row_count": 164
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_50542",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_54655",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_50543",
            "name": "2022-Aug-First Half Group Text Report-8.9.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 809077,
                        "row_count": 15
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_50543",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_54654",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_50544",
            "name": "2022-Aug-First Half Group Text Report-8.10.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 809076,
                        "row_count": 141
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_50544",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_54653",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_50545",
            "name": "2022-Aug-First Half-Individual Texting Report.xlsx_2022-Aug-First Half-Individual ",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 809074,
                        "row_count": 683
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_50545",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_54651",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_16491",
            "name": "VENDOR RAW",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 765842,
                        "row_count": 182324
                    },
                    {
                        "id": 471210,
                        "row_count": 62261
                    },
                    {
                        "id": 460799,
                        "row_count": 62763
                    },
                    {
                        "id": 170847,
                        "row_count": 46531
                    },
                    {
                        "id": 1007535,
                        "row_count": 58910
                    },
                    {
                        "id": 1845857,
                        "row_count": 45162
                    },
                    {
                        "id": 298896,
                        "row_count": 49413
                    },
                    {
                        "id": 391085,
                        "row_count": 21802
                    },
                    {
                        "id": 448146,
                        "row_count": 30877
                    },
                    {
                        "id": 632243,
                        "row_count": 64853
                    },
                    {
                        "id": 335614,
                        "row_count": 51350
                    },
                    {
                        "id": 1430919,
                        "row_count": 50539
                    },
                    {
                        "id": 832400,
                        "row_count": 21556
                    },
                    {
                        "id": 1565696,
                        "row_count": 42199
                    },
                    {
                        "id": 674928,
                        "row_count": 37240
                    },
                    {
                        "id": 1803716,
                        "row_count": 53925
                    },
                    {
                        "id": 647583,
                        "row_count": 27296
                    },
                    {
                        "id": 846823,
                        "row_count": 74516
                    },
                    {
                        "id": 160109,
                        "row_count": 31326
                    },
                    {
                        "id": 515880,
                        "row_count": 27408
                    },
                    {
                        "id": 481549,
                        "row_count": 28264
                    },
                    {
                        "id": 536189,
                        "row_count": 43710
                    },
                    {
                        "id": 872816,
                        "row_count": 52575
                    },
                    {
                        "id": 1336394,
                        "row_count": 52864
                    },
                    {
                        "id": 1097114,
                        "row_count": 72015
                    },
                    {
                        "id": 1803736,
                        "row_count": 71673
                    },
                    {
                        "id": 160107,
                        "row_count": 54992
                    },
                    {
                        "id": 792224,
                        "row_count": 256837
                    },
                    {
                        "id": 1383374,
                        "row_count": 48831
                    },
                    {
                        "id": 168792,
                        "row_count": 63440
                    },
                    {
                        "id": 266847,
                        "row_count": 31140
                    },
                    {
                        "id": 696160,
                        "row_count": 98810
                    },
                    {
                        "id": 828635,
                        "row_count": 52499
                    },
                    {
                        "id": 832402,
                        "row_count": 46664
                    },
                    {
                        "id": 1470675,
                        "row_count": 50696
                    },
                    {
                        "id": 350607,
                        "row_count": 51261
                    },
                    {
                        "id": 892199,
                        "row_count": 51166
                    },
                    {
                        "id": 437483,
                        "row_count": 38315
                    },
                    {
                        "id": 1074646,
                        "row_count": 66196
                    },
                    {
                        "id": 1631745,
                        "row_count": 59606
                    },
                    {
                        "id": 1199869,
                        "row_count": 68586
                    },
                    {
                        "id": 926417,
                        "row_count": 65341
                    },
                    {
                        "id": 1286692,
                        "row_count": 93285
                    },
                    {
                        "id": 832398,
                        "row_count": 24086
                    },
                    {
                        "id": 280047,
                        "row_count": 28844
                    },
                    {
                        "id": 1123408,
                        "row_count": 100504
                    },
                    {
                        "id": 1949410,
                        "row_count": 50571
                    },
                    {
                        "id": 498048,
                        "row_count": 56103
                    },
                    {
                        "id": 562508,
                        "row_count": 24286
                    },
                    {
                        "id": 1036812,
                        "row_count": 106621
                    },
                    {
                        "id": 832399,
                        "row_count": 47655
                    },
                    {
                        "id": 1892640,
                        "row_count": 57393
                    },
                    {
                        "id": 228583,
                        "row_count": 25906
                    },
                    {
                        "id": 1692709,
                        "row_count": 59482
                    },
                    {
                        "id": 1506225,
                        "row_count": 42073
                    },
                    {
                        "id": 372442,
                        "row_count": 47453
                    },
                    {
                        "id": 776246,
                        "row_count": 170450
                    },
                    {
                        "id": 160111,
                        "row_count": 18535
                    },
                    {
                        "id": 160104,
                        "row_count": 101252
                    },
                    {
                        "id": 724440,
                        "row_count": 163459
                    },
                    {
                        "id": 410685,
                        "row_count": 37721
                    },
                    {
                        "id": 784072,
                        "row_count": 222345
                    },
                    {
                        "id": 577576,
                        "row_count": 60195
                    },
                    {
                        "id": 608976,
                        "row_count": 29286
                    },
                    {
                        "id": 1158003,
                        "row_count": 72929
                    },
                    {
                        "id": 747408,
                        "row_count": 177053
                    },
                    {
                        "id": 426750,
                        "row_count": 55292
                    },
                    {
                        "id": 593294,
                        "row_count": 57737
                    },
                    {
                        "id": 832395,
                        "row_count": 17649
                    },
                    {
                        "id": 1237137,
                        "row_count": 89816
                    },
                    {
                        "id": 832401,
                        "row_count": 39352
                    },
                    {
                        "id": 708850,
                        "row_count": 164712
                    },
                    {
                        "id": 313839,
                        "row_count": 24894
                    },
                    {
                        "id": 1994576,
                        "row_count": 55034
                    },
                    {
                        "id": 1055100,
                        "row_count": 57102
                    },
                    {
                        "id": 809071,
                        "row_count": 130088
                    },
                    {
                        "id": 670788,
                        "row_count": 83983
                    },
                    {
                        "id": 978952,
                        "row_count": 44904
                    },
                    {
                        "id": 254575,
                        "row_count": 23871
                    },
                    {
                        "id": 665575,
                        "row_count": 68864
                    },
                    {
                        "id": 683087,
                        "row_count": 121283
                    },
                    {
                        "id": 952348,
                        "row_count": 50397
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_16491",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_21630",
                        "name": "Source",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_20910",
                        "name": "Company Match",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67110",
                        "name": "Email Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67111",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67122",
                        "name": "Email Name Match V3",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_86343",
                        "name": "KenEmailMatchV3",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_50949",
            "name": "Whil Company Account Additions 07-July 2022.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 810685,
                        "row_count": 12
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_50949",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_55121",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_53992",
            "name": "2022-09-14-Group Text.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 828629,
                        "row_count": 128
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_53992",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_58236",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_53993",
            "name": "2022-09-21-Group Text Report.xlsx_2022-09-21-Group Text Report",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 828630,
                        "row_count": 37
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_53993",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_58237",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_53994",
            "name": "2022-09-26-Group Text Report.xlsx_2022-09-26-Group Text Report",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 828631,
                        "row_count": 13
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_53994",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_58238",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_53995",
            "name": "2022-Sept-Second Half-Individual Text Report.xlsx_Individual Texts",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 828632,
                        "row_count": 566
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_53995",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_58239",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_53996",
            "name": "2022-Sept-First Half-Individual Text Report.xlsx_2022-Sept-First Half-Individual",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 828633,
                        "row_count": 577
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_53996",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_58240",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62353",
            "name": "MembersV3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994590,
                        "row_count": 1963353
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4032",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_165214",
                        "name": "Test",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_224839",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67053",
                        "name": "QA",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_162666",
                        "name": "EmployeesOnly",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_56574",
            "name": "RC Platform and Migration Reference.xlsx_Platform and Migration",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 848796,
                        "row_count": 16321
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_56574",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_60905",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_56885",
            "name": "fact_training_csv.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 844116,
                        "row_count": 724450
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_56885",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_61419",
                        "name": "FT",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_66981",
                        "name": "View 2",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_61259",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_57408",
            "name": "2H October 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 846815,
                        "row_count": 74516
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_57408",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_61797",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_57410",
            "name": "Oct 2022-Group Text-10.4.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 846821,
                        "row_count": 22
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_57410",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_61802",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_57411",
            "name": "Oct 2022-Group Text-10.10.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 846820,
                        "row_count": 388
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_57411",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_61801",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_57412",
            "name": "Oct 2022-Group Text-10.12.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 846819,
                        "row_count": 12
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_57412",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_61800",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_57413",
            "name": "Oct 2022-Group Text-10.24.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 846816,
                        "row_count": 4
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_57413",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_61798",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_57414",
            "name": "Oct 2022 - Group Text - Executive Function Launch - 10.27.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 846817,
                        "row_count": 214
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_57414",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_61799",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_57415",
            "name": "Oct 2022 - Individual Texts sw.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 846822,
                        "row_count": 1435
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_57415",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_61803",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_61435",
            "name": "2H November 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 872811,
                        "row_count": 52575
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_61435",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_65914",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_61436",
            "name": "2022-NOV-First Half-Group Text.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 872813,
                        "row_count": 187
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_61436",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_65916",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_61437",
            "name": "2022-NOV_Second Half-Group Texting Report.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 872812,
                        "row_count": 201
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_61437",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_65915",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_61438",
            "name": "2022-NOV-Second Half-Individual Text Report SW.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 872814,
                        "row_count": 738
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_61438",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_65917",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_61439",
            "name": "2022-NOV-First Half-Individual Texting Report SW.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 872815,
                        "row_count": 868
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_61439",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_65918",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_61933",
            "name": "Child Profile_old",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 878945,
                        "row_count": 78466
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3919",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66434",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62084",
            "name": "Areas_of_Concern_old",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 884185,
                        "row_count": 95360
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3953",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66622",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62085",
            "name": "Diagnosis_old",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 884187,
                        "row_count": 22720
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_3954",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66623",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62265",
            "name": "2022-Dec-First Half-Group Text Report.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 891943,
                        "row_count": 181
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_62265",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66854",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62266",
            "name": "rc_diagnosis_20230103.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 891945,
                        "row_count": 15683
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_62266",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66855",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62268",
            "name": "2H December 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 892033,
                        "row_count": 51166
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_62268",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66856",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62270",
            "name": "2H December 2022 Vendor Data - EB - EOM Engagement2.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 892145,
                        "row_count": 51166
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_62270",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66858",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_62348",
            "name": "Areas_Of_Concern_V3",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1994636,
                        "row_count": 280945
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4030",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_67300",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_105741",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_68496",
            "name": "2023-Jan-Second Half-Individual Texts.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 926444,
                        "row_count": 740
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_68496",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_73210",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_68497",
            "name": "2023-Jan-Second Half-Group Text 3.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 926443,
                        "row_count": 2
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_68497",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_73209",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_68498",
            "name": "2023-Jan-Second Half-Group Text 2.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 926445,
                        "row_count": 74
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_68498",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_73211",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_68499",
            "name": "2023-Jan - Second Half - Group Text 1.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 926446,
                        "row_count": 137
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_68499",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_73212",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_68500",
            "name": "2023-Jan-First Half-Individual Text Report.csv",
            "type": "dataset",
            "properties": {
                "batches": [],
                "inbound_connections": [
                    {
                        "id": "file_upload_68500",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataset_68501",
            "name": "2023-Jan-First Half-Group Text 1.csv",
            "type": "dataset",
            "properties": {
                "batches": [],
                "inbound_connections": [
                    {
                        "id": "file_upload_68501",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataset_68502",
            "name": "2023-Jan-First Half-Group Text 2.csv",
            "type": "dataset",
            "properties": {
                "batches": [],
                "inbound_connections": [
                    {
                        "id": "file_upload_68502",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataset_68503",
            "name": "2H January 2023 Vendor Data - EB - EOM Engagement2.xlsx_New",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 926447,
                        "row_count": 65341
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_68503",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_73213",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_68821",
            "name": "Launchpad List",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 991082,
                        "row_count": 4
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_68821",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_73530",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_75786",
            "name": "2023-Feb-First Half-Individual Texting Report.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 952341,
                        "row_count": 480
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_75786",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_80557",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_75787",
            "name": "2023-Feb-Second Half-Individual Texting Report.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 952340,
                        "row_count": 461
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_75787",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_80556",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_75788",
            "name": "2023-Feb-First Half-Group Text.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 952342,
                        "row_count": 65
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_75788",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_80558",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_75789",
            "name": "2H February 2023 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 952343,
                        "row_count": 50397
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_75789",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_80559",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_75883",
            "name": "Members_new",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 962516,
                        "row_count": 1416878
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "datasource_config_4244",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_81820",
                        "name": "Ken QA",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_82838",
                        "name": "Ken QA2",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_80654",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_81821",
                        "name": "View 4",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_77400",
            "name": "Population Served Quantity Override List.xlsx_Sheet1",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 956988,
                        "row_count": 1
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_77400",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_82183",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_80435",
            "name": "DS1.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 965433,
                        "row_count": 3
                    },
                    {
                        "id": 965427,
                        "row_count": 3
                    },
                    {
                        "id": 965424,
                        "row_count": 3
                    },
                    {
                        "id": 965435,
                        "row_count": 3
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "dataview_85240",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_85237",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_80439",
            "name": "DS1_ec.csv",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 965432,
                        "row_count": 3
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_80439",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_85240",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataset_110981",
            "name": "Utilization page 2 copy",
            "type": "dataset",
            "properties": {
                "batches": [
                    {
                        "id": 1043777,
                        "row_count": 1465851
                    }
                ],
                "inbound_connections": [
                    {
                        "id": "file_upload_110981",
                        "name": "file upload",
                        "type": "file_upload",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_116056",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "primary"
                    }
                ]
            }
        }
    ],
    "dataviews": [
        {
            "id": "dataview_20780",
            "name": "Unmatched",
            "type": "dataview",
            "properties": {
                "datasource_id": 16481,
                "no_of_tasks": 11,
                "inbound_connections": [
                    {
                        "id": "dataset_16481",
                        "name": "Group EZText",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_67108",
            "name": "Name Match V3",
            "type": "dataview",
            "properties": {
                "datasource_id": 16481,
                "no_of_tasks": 20,
                "inbound_connections": [
                    {
                        "id": "dataset_16481",
                        "name": "Group EZText",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_67109",
            "name": "Phone Match V3",
            "type": "dataview",
            "properties": {
                "datasource_id": 16481,
                "no_of_tasks": 14,
                "inbound_connections": [
                    {
                        "id": "dataset_16481",
                        "name": "Group EZText",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_56650",
            "name": "test",
            "type": "dataview",
            "properties": {
                "datasource_id": 16481,
                "no_of_tasks": 5,
                "inbound_connections": [
                    {
                        "id": "dataset_16481",
                        "name": "Group EZText",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_56649",
                        "name": "WHIL_ONLY",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_56649",
                        "name": "WHIL_ONLY",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_56649",
                        "name": "WHIL_ONLY",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_67102",
            "name": "Phone Match V3",
            "type": "dataview",
            "properties": {
                "datasource_id": 16484,
                "no_of_tasks": 18,
                "inbound_connections": [
                    {
                        "id": "dataset_16484",
                        "name": "EZTexting Individual",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_67103",
            "name": "Name Match V3",
            "type": "dataview",
            "properties": {
                "datasource_id": 16484,
                "no_of_tasks": 23,
                "inbound_connections": [
                    {
                        "id": "dataset_16484",
                        "name": "EZTexting Individual",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_20826",
            "name": "Unmatched",
            "type": "dataview",
            "properties": {
                "datasource_id": 16484,
                "no_of_tasks": 15,
                "inbound_connections": [
                    {
                        "id": "dataset_16484",
                        "name": "EZTexting Individual",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21630",
            "name": "Source",
            "type": "dataview",
            "properties": {
                "datasource_id": 16491,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_16491",
                        "name": "VENDOR RAW",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_20910",
            "name": "Company Match",
            "type": "dataview",
            "properties": {
                "datasource_id": 16491,
                "no_of_tasks": 26,
                "inbound_connections": [
                    {
                        "id": "dataset_16491",
                        "name": "VENDOR RAW",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_20912",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_67110",
            "name": "Email Match V3",
            "type": "dataview",
            "properties": {
                "datasource_id": 16491,
                "no_of_tasks": 15,
                "inbound_connections": [
                    {
                        "id": "dataset_16491",
                        "name": "VENDOR RAW",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_67111",
            "name": "Name Match V3",
            "type": "dataview",
            "properties": {
                "datasource_id": 16491,
                "no_of_tasks": 22,
                "inbound_connections": [
                    {
                        "id": "dataset_16491",
                        "name": "VENDOR RAW",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_67122",
            "name": "Email Name Match V3",
            "type": "dataview",
            "properties": {
                "datasource_id": 16491,
                "no_of_tasks": 27,
                "inbound_connections": [
                    {
                        "id": "dataset_16491",
                        "name": "VENDOR RAW",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_86343",
            "name": "KenEmailMatchV3",
            "type": "dataview",
            "properties": {
                "datasource_id": 16491,
                "no_of_tasks": 17,
                "inbound_connections": [
                    {
                        "id": "dataset_16491",
                        "name": "VENDOR RAW",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21843",
            "name": "Source",
            "type": "dataview",
            "properties": {
                "datasource_id": 16647,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_16647",
                        "name": "SP_Platform_Members",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_66983",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 16647,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_16647",
                        "name": "SP_Platform_Members",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32199",
            "name": "PROBABLY DELETE - New Export View",
            "type": "dataview",
            "properties": {
                "datasource_id": 16647,
                "no_of_tasks": 14,
                "inbound_connections": [
                    {
                        "id": "dataset_16647",
                        "name": "SP_Platform_Members",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_18913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32082",
            "name": "New Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 16647,
                "no_of_tasks": 18,
                "inbound_connections": [
                    {
                        "id": "dataset_16647",
                        "name": "SP_Platform_Members",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_18913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_18913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_50230",
                        "name": "MembersV2",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_20780",
                        "name": "Unmatched",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_20780",
                        "name": "Unmatched",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_20780",
                        "name": "Unmatched",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_20826",
                        "name": "Unmatched",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_20826",
                        "name": "Unmatched",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_20826",
                        "name": "Unmatched",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_20910",
                        "name": "Company Match",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_20910",
                        "name": "Company Match",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_20910",
                        "name": "Company Match",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_20910",
                        "name": "Company Match",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_20910",
                        "name": "Company Match",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_32644",
            "name": "New Members Export View",
            "type": "dataview",
            "properties": {
                "datasource_id": 16647,
                "no_of_tasks": 25,
                "inbound_connections": [
                    {
                        "id": "dataset_16647",
                        "name": "SP_Platform_Members",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_18913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_18913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_33439",
            "name": "Testing Group and Aggregate",
            "type": "dataview",
            "properties": {
                "datasource_id": 16647,
                "no_of_tasks": 26,
                "inbound_connections": [
                    {
                        "id": "dataset_16647",
                        "name": "SP_Platform_Members",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_18913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_18913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_18913",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 17116,
                "no_of_tasks": 3,
                "inbound_connections": [
                    {
                        "id": "dataset_17116",
                        "name": "SP_EB_Company",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_32579",
                        "name": "Client List Export View",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32053",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32054",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32055",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32082",
                        "name": "New Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32199",
                        "name": "PROBABLY DELETE - New Export View",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32644",
                        "name": "New Members Export View",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32644",
                        "name": "New Members Export View",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_33439",
                        "name": "Testing Group and Aggregate",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_33439",
                        "name": "Testing Group and Aggregate",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_64487",
                        "name": "FT",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_20912",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19144,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19144",
                        "name": "Domain_Ref_Table",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_20910",
                        "name": "Company Match",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_20930",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19169,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19169",
                        "name": "Vend_2H_June_cleaned.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_20932",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19171,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19171",
                        "name": "Vend_1H_June.xlsx_Email_Delivered_Prospects____Be",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_20933",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19173,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19173",
                        "name": "Grp_2H_June.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_20934",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19174,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19174",
                        "name": "Ind_1H_June.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_20936",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19176,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19176",
                        "name": "Ind_2H_June.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21116",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19347,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19347",
                        "name": "EZTexting Group RAW 2H MAY GroupTextClicks2HMay2020.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21117",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19348,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19348",
                        "name": "EZTexting Group RAW 1H MAY Group Text Click Template 05-15-2020.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21118",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19349,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19349",
                        "name": "Grp_1H_June_v2.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21133",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19362,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19362",
                        "name": "Client_Reference_old",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21161",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19392,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19392",
                        "name": "EB_Count_WatchVideos_06-01-2020_07-01-2020",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21163",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19394,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19394",
                        "name": "EDU_Count_WatchVideos_06-01-2020'_07-01-2020",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21164",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19395,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19395",
                        "name": "BH_Count_WatchVideos_06-01-2020_07-01-2020",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21165",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19396,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19396",
                        "name": "EZTexting Individual RAW 1H MAY Clicks5_15_2020.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21166",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19397,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19397",
                        "name": "EZTexting Individual RAW 2H MAY IndividualClicks2HMay2020.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21167",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19398,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19398",
                        "name": "EZTexting Individual RAW JAN-APR sent_messages_1588791961.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21168",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19399,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19399",
                        "name": "VENDOR RAW 1H APR 2020-04-17 - EB Engagement - April - Clinical Combinedv2.xlsx_2020-04-17 - EB Engagement - Ap",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21169",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19400,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19400",
                        "name": "VENDOR PREPPED FULL FEB 2020-03-03 - Benefits - February Clinical Data Combined.xlsx_Email_Click_Prospects__Benefits",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21276",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19501,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_19501",
                        "name": "Content Video Name Mapping",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_102084",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_21491",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19712,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19712",
                        "name": "EZTexting Group PREPPED JAN-APR EZtexting Group Clicks 2020 Jan-Apr 05-01-2020.xlsx_EZtexting_Clicks_1_2_2020",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21493",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19714,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19714",
                        "name": "VENDOR RAW 1H APR 2020-04-17 - EB Engagement - April - Clinical Combinedv2.xlsx_2020-04-17 - EB Engagement - Ap 2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21497",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19718,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19718",
                        "name": "VENDOR RAW  2H APR 2020-05-01 - EB - April Clinical Data Combined.xlsx_Email_Open_Prospects____2020_04",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_21507",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 19728,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_19728",
                        "name": "VENDOR RAW FULL MARCH 2020-03-31 - Benefits - Engagement - Combined Clinical for March.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_22893",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 21081,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_21081",
                        "name": "JulyFirstHalf2020IndividualTextClick.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_22894",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 21082,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_21082",
                        "name": "JulyFirstHalfGroupTexts.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_22896",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 21084,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_21084",
                        "name": "JulyFirstHalf - Mid Month Engagement.xlsx_Email_Click_Prospects__2020_07_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_25764",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 23941,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_23941",
                        "name": "2H July 2020 EZ Text Group.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_25765",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 23942,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_23942",
                        "name": "2H July 2020 EZ Text Individual.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_25770",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 23947,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_23947",
                        "name": "2020-08-03 - EB - July - End of Month Engagement.xlsx_Email_Click_Prospects__2020_07_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_25875",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 24060,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_24060",
                        "name": "MonthlyReports_EB_Count_WatchVideos_July",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_25904",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 24090,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_24090",
                        "name": "MonthlyReports_BH_Count_WatchVideos_July",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_25906",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 24092,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_24092",
                        "name": "MonthlyReports_EDU_Count_WatchVideos_July",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_30207",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 28365,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_28365",
                        "name": "Crosstab",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_30357",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 28518,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_28518",
                        "name": "2020-09-01 - EB - August - EOM Engagement.xlsx_Email_Click_Prospects__2020_07_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_30359",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 28520,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_28520",
                        "name": "August 2nd half individual clicks.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_30360",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 28521,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_28521",
                        "name": "SecondHalfAugust2020GroupTextClicks.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_30512",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 28676,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_28676",
                        "name": "MonthlyReports_EB_Count_WatchVideos_08-01-2020_09-01-2020",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_30514",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 28677,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_28677",
                        "name": "MonthlyReports_EDU_Count_WatchVideos_08-01-2020_09-01-2020",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_30515",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 28679,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_28679",
                        "name": "MonthlyReports_BH_Count_WatchVideos_08-01-2020_09-01-2020",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_31848",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30047,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_30047",
                        "name": "FirstHalfSept2020GroupClicks.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_31849",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30048,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_30048",
                        "name": "Firsthalfseptember2020individualclicks.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_31850",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30049,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_30049",
                        "name": "2020-09-16 - EB - September - MidMonth Engagement.xlsx_Email_Click_Prospects__2020_07_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32053",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30260,
                "no_of_tasks": 14,
                "inbound_connections": [
                    {
                        "id": "dataset_30260",
                        "name": "MonthlyReports_EB_Child_Profile",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_18913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32579",
                        "name": "Client List Export View",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_32054",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32055",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_32054",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30261,
                "no_of_tasks": 8,
                "inbound_connections": [
                    {
                        "id": "dataset_30261",
                        "name": "MonthlyReports_EB_Diagnosis",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_32053",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_18913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32579",
                        "name": "Client List Export View",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32055",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30262,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_30262",
                        "name": "MonthlyReports_EB_Areas_of_Concern",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_32053",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_18913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32579",
                        "name": "Client List Export View",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32189",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30461,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_30461",
                        "name": "GroupTextsSecondHalfSept2020.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32190",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30462,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_30462",
                        "name": "IndividualTextsSecondHalfSept2020.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32191",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30463,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_30463",
                        "name": "2020-10-01 - EB - September - End Month Engagement.xlsx_Email_Click_Prospects__2020_07_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32203",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30468,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_30468",
                        "name": "MonthlyReports_EDU_Count_WatchVideos_09-01-2020_10-01-2020",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32204",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30469,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_30469",
                        "name": "MonthlyReports_EB_Count_WatchVideos_09-01-2020_10-01-2020",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32205",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30470,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_30470",
                        "name": "MonthlyReports_BH_Count_WatchVideos_09-01-2020_10-01-2020",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32400",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30755,
                "no_of_tasks": 3,
                "inbound_connections": [
                    {
                        "id": "dataset_30755",
                        "name": "Client Data Source - New Version",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32579",
            "name": "Client List Export View",
            "type": "dataview",
            "properties": {
                "datasource_id": 30755,
                "no_of_tasks": 7,
                "inbound_connections": [
                    {
                        "id": "dataset_30755",
                        "name": "Client Data Source - New Version",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_18913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32053",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32054",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_32055",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_66871",
            "name": "temp - deleteme",
            "type": "dataview",
            "properties": {
                "datasource_id": 30755,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_30755",
                        "name": "Client Data Source - New Version",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_64487",
            "name": "FT",
            "type": "dataview",
            "properties": {
                "datasource_id": 30755,
                "no_of_tasks": 7,
                "inbound_connections": [
                    {
                        "id": "dataset_30755",
                        "name": "Client Data Source - New Version",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_18913",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "mssql_12419",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_65897",
                        "name": "EB_Member",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_32647",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 30927,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_30927",
                        "name": "Manual Client List Additions for Upload to Mammoth as Separate Batch 10-15-2020.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32764",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 31035,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_31035",
                        "name": "1H Oct 2020 Individual Texts.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32765",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 31036,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_31036",
                        "name": "1H Oct 2020 Vendor Data.xlsx_Email_Click_Prospects__2020_07_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_32766",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 31037,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_31037",
                        "name": "1H Oct 2020 Group Texts.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_33361",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 31619,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_31619",
                        "name": "Second half oct 2020 individual clicks.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_33360",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 31620,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_31620",
                        "name": "Second half oct 2020 group clicks.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_33367",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 31624,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_31624",
                        "name": "MonthlyReports_EDU_Count_WatchVideos - October 2020",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_33369",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 31625,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_31625",
                        "name": "MonthlyReports_EB_Count_WatchVideos - October 2020",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_33371",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 31626,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_31626",
                        "name": "MonthlyReports_BH_Count_WatchVideos - October 2020",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_33377",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 31631,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_31631",
                        "name": "2020-11-02 - EB - October - EOM Engagement.xlsx_Email_Click_Prospects__2020_07_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_33859",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 32097,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_32097",
                        "name": "1H November 2020 Vendor Data.xlsx_Email_Click_Prospects__2020_07_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_34459",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 32721,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_32721",
                        "name": "November BH Video Views",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_34460",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 32722,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_32722",
                        "name": "November EB Video Views",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_34493",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 32768,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_32768",
                        "name": "November EDU Video Views - Rerun",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_34526",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 32807,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_32807",
                        "name": "2H Nov 2020 Vendor Data.xlsx_Email_Click_Prospects__2020_07_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_34893",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 33147,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_33147",
                        "name": "1H Dec 2020 Vendor Data.xlsx_Email_Click_Prospects__2020_07_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_34897",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 33152,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_33152",
                        "name": "FristHalfDecemberIndividualClicks.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_35296",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 33406,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_33406",
                        "name": "BH December 2020 Video Views",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_35297",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 33407,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_33407",
                        "name": "EDU December 2020 Video Views",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_35298",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 33408,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_33408",
                        "name": "EB December 2020 Video Views",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_35322",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 33425,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_33425",
                        "name": "2H Dec 2020 Vendor Data.xlsx_Email_Click_Prospects__2020_07_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_35323",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 33426,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_33426",
                        "name": "2H Dec 2020 Group Clicks.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_35324",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 33427,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_33427",
                        "name": "2H Dec 2020 Individual Clicks.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_35629",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 33660,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_33660",
                        "name": "1H Jan 2021 Vendor Data 2021-01-18 - EB - January - MM Engagement.xlsx_Email_Click_Prospects__2020_07_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_36276",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 34272,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_34272",
                        "name": "BH Jan 21",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_36277",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 34273,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_34273",
                        "name": "EDU Jan 21",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_36278",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 34274,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_34274",
                        "name": "EB Jan 21",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_36842",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 34808,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_34808",
                        "name": "2ndHalfFebGroupTextClicks.xlsx_2ndHalfFebGroupTextClicks",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_36843",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 34809,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_34809",
                        "name": "SecondHalfFebIndividualClicks.xlsx_SecondHalfFebIndividualClicks",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_36879",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 34842,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_34842",
                        "name": "BH Feb 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_36880",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 34843,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_34843",
                        "name": "EDU Feb 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_36881",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 34844,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_34844",
                        "name": "EB Feb 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_36882",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 34845,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_34845",
                        "name": "BH Feb 2021 - Updated End Date",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_36943",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 34896,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_34896",
                        "name": "2H Feb 2021 Vendor Data 2021-03-01 - EB - February - EOM Engagement Additional Webinars.xlsx_Email_Click_Prospects__2020_07_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_37138",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35104,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35104",
                        "name": "Current Client List.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_37139",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35105,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35105",
                        "name": "report1615916352439.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_37176",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35142,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35142",
                        "name": "1H March 2021 Vendor Data 2021-03-16 - EB - March - MM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_37177",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35143,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35143",
                        "name": "EZTexting_individualtexts_FIRSTHALF_March 21.xlsx_EZTexting_individualtexts_FIRST",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_37485",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35357,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35357",
                        "name": "2H March 2021 Vendor Data 2021-03-31 - EB - March - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_37486",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35358,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35358",
                        "name": "2H March 2021 Group Text Data 2021-03-31 - EB - March - EOM Engagement.xlsx_GroupMessages_SECONDHALF_March2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_37487",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35359,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35359",
                        "name": "2H March 2021 Individual Text Data 2021-03-31 - EB - March - EOM Engagement.xlsx_IndividualMessages_SECONDHALF_M",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_37488",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35360,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35360",
                        "name": "BH March 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_37489",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35361,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35361",
                        "name": "EDU March 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_37490",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35362,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35362",
                        "name": "EB March 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_37759",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35579,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35579",
                        "name": "1H April 2021 Vendor Data 2021-04-19 - EB - April - MM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_37760",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35580,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35580",
                        "name": "IndividualTextMessage_FirstHalf_April2021.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_38154",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35953,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35953",
                        "name": "2H April 2021 Vendor Data 2021-05-03 - EB - April - EOM Engagement.xlsx_Sheet1 (2)",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_38155",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35954,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35954",
                        "name": "GroupTextMessages_SecondHalf_April2021.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_38156",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 35955,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_35955",
                        "name": "IndividualMessages_SecondHalf_April2021.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_38302",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 36106,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_36106",
                        "name": "BH April 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_38303",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 36107,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_36107",
                        "name": "EDU April 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_38304",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 36108,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_36108",
                        "name": "EB April 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_38578",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 36384,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_36384",
                        "name": "1H May 2021 Vendor Data 2021-05-19 - EB - May - MM Engagement.xlsx_Sheet3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_38956",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 36753,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_36753",
                        "name": "2H May 2021 Vendor Data 2021-06-03 - EB - May - EOM Engagement.xlsx_Sheet2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_38957",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 36754,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_36754",
                        "name": "May2021IndividualClicks.xlsx_May2021IndividualClicks",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_39028",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 36797,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_36797",
                        "name": "EDU May 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_39029",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 36798,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_36798",
                        "name": "BH May 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_39030",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 36799,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_36799",
                        "name": "EB May 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_39177",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 36963,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_36963",
                        "name": "1H June 2021 Vendor Data 2021-06-16 - EB - June - MM Engagement.xlsx_Sheet3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_39178",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 36964,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_36964",
                        "name": "June2021-MM-INDIVIDUAL.xlsx_June2021-MM-INDIVIDUAL",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_39179",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 36965,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_36965",
                        "name": "JUNE2021 - FirstHalfJuneGroupTextClicks.xlsx_FirstHalfJuneGroupTextClicks",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_39816",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 37597,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_37597",
                        "name": "2H June 2021 Vendor Data 2021-07-06 - EB - June - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_39817",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 37598,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_37598",
                        "name": "2021-07-01 - 2ndhalf-Group June clicks.xlsx_Secondhalfjunegroupclicks",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_39818",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 37599,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_37599",
                        "name": "2021-07-01 - 2ndhalf-individualclicks.xlsx_Second halfjuneindividual click",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_39852",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 37627,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_37627",
                        "name": "BH June 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_39853",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 37628,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_37628",
                        "name": "EDU June 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_39854",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 37629,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_37629",
                        "name": "EB June 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_40113",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 37866,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_37866",
                        "name": "1H July 2021 Vendor Data 2021-07-16 - EB - July - MM Engagement.xlsx_Sheet3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_40115",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 37867,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_37867",
                        "name": "FirstHalfJulyGroup.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_40114",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 37868,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_37868",
                        "name": "FirstHalfJulyIndividual.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_40479",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 38217,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_38217",
                        "name": "2021-07-31 - Individual sent_messages_1628004708.xlsx_sent_messages_1628004708",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_40478",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 38218,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_38218",
                        "name": "2021-07-31 - Second half July Group Clicks.xlsx_Second half July Group Clicks",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_40480",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 38219,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_38219",
                        "name": "2H July 2021 Vendor Data 2021-07-31 - EB - July - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_40523",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 38262,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_38262",
                        "name": "BH July 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_40524",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 38263,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_38263",
                        "name": "EDU July 21",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_40525",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 38264,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_38264",
                        "name": "EB July 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_40895",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 38603,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_38603",
                        "name": "2021-08 - First half august clicks group.xlsx_First half august clicks group",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_40894",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 38604,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_38604",
                        "name": "2021-08 - Firsthalfaugustinvidualclicks.xlsx_Firsthalfaugustinvidualclicks",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_40896",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 38605,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_38605",
                        "name": "1H August 2021 Vendor Data 2021-08-16 - EB - August - MM Engagement.xlsx_Sheet2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_41404",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 39064,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_39064",
                        "name": "2H August 2021 Vendor Data 2021-09-06 - EB - August - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_41426",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 39077,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_39077",
                        "name": "SecondHalfAugust2021IndividualTexts.xlsx_SecondHalfAugust2021IndividualT",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_41536",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 39190,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_39190",
                        "name": "BH August 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_41537",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 39191,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_39191",
                        "name": "EDU August 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_41538",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 39192,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_39192",
                        "name": "EB August 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_41726",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 39325,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_39325",
                        "name": "1H September 2021 Vendor Data 2021-09-16 - EB - September - MM Engagement.xlsx_New",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_42314",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 39688,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_39688",
                        "name": "Participant Texting Data - Group - SECOND HALF - Sept 2021.xlsx_272348550_detailed_click_stats_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_42316",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 39690,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_39690",
                        "name": "2H September 2021 Vendor Data 2021-10-05 - EB - September - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_42317",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 39692,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_39692",
                        "name": "Prticipant Texting Data - Group FIRST HALF - Sept 2021.xlsx_270253199_detailed_click_stats_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_42329",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 39695,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_39695",
                        "name": "Sept2021IndividualTexts-fullmonth.xlsx_Sept2021IndividualTexts",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_42398",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 39743,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_39743",
                        "name": "BH September 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_42399",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 39744,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_39744",
                        "name": "EDU September 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_42400",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 39745,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_39745",
                        "name": "EB September 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_42713",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 40099,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_40099",
                        "name": "Oct 2021 - FIRST HALF - Individual Texting Data.xlsx_sent_messages_1634331531",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_42714",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 40100,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_40100",
                        "name": "1H October 2021 Vendor Data 2021-10-15 - EB - October - MM Engagement.xlsx_Sheet2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_43187",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 40456,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_40456",
                        "name": "2H October 2021 Vendor Data 2021-11-01 - EB - October - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_43188",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 40457,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_40457",
                        "name": "Oct 2021 - SECOND HALF - Individual Texting Data.xlsx_sent_messages_1635797330",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_43189",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 40458,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_40458",
                        "name": "Oct 2021 - SECOND HALF - Group Texting Data.xlsx_276035477_detailed_click_stats_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_43239",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 40505,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_40505",
                        "name": "BH October 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_43240",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 40506,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_40506",
                        "name": "EDU October 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_43241",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 40507,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_40507",
                        "name": "EB October 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_43709",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 40897,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_40897",
                        "name": "2H November 2021 Vendor Data 2021-12-01 - EB - November - EOM Engagement.xlsx_NEW",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_43710",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 40898,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_40898",
                        "name": "2021-NOV-SECOND HALF - Group Text Data.xlsx_2021-NOV-SECOND HALF - Group Te",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_43711",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 40899,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_40899",
                        "name": "2021-NOV-SECOND HALF - Individual Texting Report.xlsx_2021-NOV-SECOND HALF - Individu",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_43712",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 40900,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_40900",
                        "name": "2021 - NOV - FIRST HALF - Individual Texting Report.xlsx_2021 - NOV - FIRST HALF - Indiv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_43945",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41109,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41109",
                        "name": "BH 11-2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_43946",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41110,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41110",
                        "name": "EDU 11-2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_43947",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41111,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41111",
                        "name": "EB 11-2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_44225",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41332,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41332",
                        "name": "2H December 2021 Vendor Data 2021-01-01 - EB - December - EOM Engagement.xlsx_NEW1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_44226",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41333,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41333",
                        "name": "Copy of 2021 - DEC - FIRST HALF - Group Texting Report.xlsx_2021 - DEC - FIRST HALF - Group",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_44227",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41334,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41334",
                        "name": "Copy of 2021 - DEC - FIRST HALF - Individual Texting Report.xlsx_2021 - DEC - FIRST HALF - Indiv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_44228",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41335,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41335",
                        "name": "Copy of 2021 - DEC - Second Half - Individual Texting Report.xlsx_2021 - DEC - Second Half - Indi",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_44248",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41351,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41351",
                        "name": "BH December 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_44249",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41352,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41352",
                        "name": "EB December 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_44250",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41353,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41353",
                        "name": "EDU December 2021",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_45033",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41964,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41964",
                        "name": "2H January 2021 Vendor Data 2021-02-01 - EB - January- EOM Engagement.xlsx_NEW",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_45034",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41967,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41967",
                        "name": "2022 - JAN - FIRST HALF - Group Texting Report.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_45035",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41968,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41968",
                        "name": "2022 - JAN - SECOND HALF - Individual Texting Report.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_45036",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 41969,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_41969",
                        "name": "2022 - JAN - FIRST HALF - Individual Texting Report.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_45249",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 42121,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_42121",
                        "name": "BH 2022 Jan",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_45250",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 42122,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_42122",
                        "name": "EDU 2022 Jan",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_45251",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 42124,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_42124",
                        "name": "EB JAn 2022 - 2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_46025",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 42866,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_42866",
                        "name": "2H February 2022 Vendor Data - EB - February - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_46026",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 42868,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_42868",
                        "name": "2022-Feb-Full Report-Individual Texts (002).xlsx_2022-Feb-Full Report-Individual",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_46032",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 42870,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_42870",
                        "name": "2022-02-01-Feb Webinars-Group Text.xlsx_2022-02-01-Feb Webinars-Group T",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_46031",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 42871,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_42871",
                        "name": "2022-02-10-DEI Resources Group Text.xlsx_2022-02-10-DEI Resources Group ",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_46028",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 42872,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_42872",
                        "name": "2022-02-15-DEI Resources Send 2 - Group Text.xlsx_2022-02-15-DEI Resources Send 2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_46029",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 42873,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_42873",
                        "name": "2022-02-24-Feb 28th Webinar Reminder - Group Text.xlsx_2022-02-24-Feb 28th Webinar Rem",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_46030",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 42874,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_42874",
                        "name": "2022-02-15-Feb 16th Webinar Reminder - Group Text.xlsx_2022-02-15-Feb 16th Webinar Rem",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_46259",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 43078,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_43078",
                        "name": "BH February 2022",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_46260",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 43079,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_43079",
                        "name": "EDU February 2022",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_46261",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 43080,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_43080",
                        "name": "EB February 2022",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_47086",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 43792,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_43792",
                        "name": "2H March 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_47087",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 43793,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_43793",
                        "name": "2022-March-First Half-Individual Texting Report.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_47088",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 43794,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_43794",
                        "name": "2022-March-First Half-Group Text.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_47090",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 43795,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_43795",
                        "name": "2022-03-16_March Second Half_Group Text 1.xlsx_292961500_detailed_click_stats_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_47089",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 43796,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_43796",
                        "name": "2022-03-22_March Second Half_Group Text 2.xlsx_293683422_detailed_click_stats_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_47091",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 43797,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_43797",
                        "name": "2022-03-22_March Second Half_Group Text 3.xlsx_293683085_detailed_click_stats_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_47092",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 43798,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_43798",
                        "name": "2022_March Second Half_Individual Texts.xlsx_sent_messages_1649217345",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_47093",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 43802,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_43802",
                        "name": "2022-03-30-March Second Half_Group Text 4.xlsx_294777018_detailed_click_stats_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48074",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 44650,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_44650",
                        "name": "2H April 2022 Vendor Data - EB - EOM Engagement - 4-26.xlsx_Sheet2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48075",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 44651,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_44651",
                        "name": "2022-April-FIRST HALF-Group Text.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48076",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 44652,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_44652",
                        "name": "2022-April-FIRST HALF-Individual Texts.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48120",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 44689,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_44689",
                        "name": "2022-04-20_Group Text_Amazon Engagement Push.xlsx_2022-04-20_Amazon Engagement Pu",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48121",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 44690,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_44690",
                        "name": "2022-April-SECOND HALF-Individual Texting Report.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48357",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 44892,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_44892",
                        "name": "BH March 22",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48358",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 44893,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_44893",
                        "name": "EB March 22",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48359",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 44894,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_44894",
                        "name": "EDU March 22",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48360",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 44895,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_44895",
                        "name": "BH April 22",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48361",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 44896,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_44896",
                        "name": "EB April 22",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48362",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 44897,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_44897",
                        "name": "EDU April 22",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48843",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45268,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45268",
                        "name": "2H May 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48845",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45269,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45269",
                        "name": "2022_May_FIRST HALF_Individual Texting Report.xlsx_2022_May_FIRST HALF_Individual ",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48844",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45270,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45270",
                        "name": "2022-May-Second Half-Individual Text Report.xlsx_2022-May-Second Half-Individual",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48846",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45271,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45271",
                        "name": "2022-05-26-WM Engagement Push-Group Text.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48847",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45272,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45272",
                        "name": "2022-05-17-Migration Wave 1 Follow Up- Group Text.xlsx_2022-05-17-Benefits-Users-Migra",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48848",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45273,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45273",
                        "name": "2022_May_FIRST HALF_Group Texting Report_Mental Health Awareness.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_48849",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45274,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45274",
                        "name": "2022_May_FIRST HALF_Group Texting Report_Wave 1 Migration.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_49079",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45392,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45392",
                        "name": "BH May 2022",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_49080",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45393,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45393",
                        "name": "EDU May 2022",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_49081",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45394,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45394",
                        "name": "EB May 2022",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_49723",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45900,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45900",
                        "name": "2H June 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_49729",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45904,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45904",
                        "name": "2022_June_First Half_Group Text_June Employee Wellbeing Webinar Reminder.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_49733",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45905,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45905",
                        "name": "2022_June_First Half_Group Text_June Employee Wellbeing 1.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_49734",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45906,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45906",
                        "name": "2022_June_First Half_Group Text_June Employee Wellbeing 2.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_49735",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45907,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45907",
                        "name": "2022_June_First Half_Group Text_Migration Wave 2.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_49730",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45908,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45908",
                        "name": "June 2022_Second Half_Group Text .xlsx_305107451_detailed_click_stats_",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_49731",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45909,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45909",
                        "name": "Copy of June 2022_Second Half_Individual Texts.xlsx_sent_messages_1657203461",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_49732",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 45910,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_45910",
                        "name": "2022_June_First Half_Individual Texting Report.xlsx_2022_June_First Half_Individual",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_49876",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 46044,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_46044",
                        "name": "whil_members_20220705.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_50123",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 46277,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_46277",
                        "name": "BH June 2022",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_50124",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 46278,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_46278",
                        "name": "EDU June 2022",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_50125",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 46279,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_46279",
                        "name": "EB June 2022",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_50341",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 46461,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_46461",
                        "name": "2H July 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_50342",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 46463,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_46463",
                        "name": "2022 July-First Half-7.11 Group Text.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_50343",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 46464,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_46464",
                        "name": "2022 July-First Half-7.7 Group Text.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_50344",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 46465,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_46465",
                        "name": "2022 July-First Half-Individual Text Report.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_50356",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 46471,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_46471",
                        "name": "Copy of 2022-July-Second Half-Individual Texts.xlsx_2022-July-Second Half-Individua",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_50357",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 46472,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_46472",
                        "name": "2022-July-Second Half-Group Text-7.25 Migration.xlsx_2022-July-Second Half-Group Tex",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_52142",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 48213,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_48213",
                        "name": "BH July 2022",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_52144",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 48215,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_48215",
                        "name": "EB July 2022",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_52147",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 48218,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_48218",
                        "name": "EDU July 2022",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_56649",
            "name": "WHIL_ONLY",
            "type": "dataview",
            "properties": {
                "datasource_id": 50230,
                "no_of_tasks": 16,
                "inbound_connections": [
                    {
                        "id": "dataset_50230",
                        "name": "MembersV2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_50679",
                        "name": "Whil_Rethink_Duplicates_ForReview",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_56650",
                        "name": "test",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_56650",
                        "name": "test",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_56650",
                        "name": "test",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_54320",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 50230,
                "no_of_tasks": 16,
                "inbound_connections": [
                    {
                        "id": "dataset_50230",
                        "name": "MembersV2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_50679",
                        "name": "Whil_Rethink_Duplicates_ForReview",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataset_52162",
                        "name": "MembersV2 Export View",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_54643",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 50533,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_50533",
                        "name": "2H August 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_54649",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 50539,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_50539",
                        "name": "August 2022_Second Half_Group Text.xlsx_August 2022_Second Half_Group T",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_54650",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 50540,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_50540",
                        "name": "Copy of August 2022_Second Half_Individual Texts.xlsx_August 2022_Second Half_Individ",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_54652",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 50541,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_50541",
                        "name": "2022-Aug-First Half Group Text Report-8.4.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_54655",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 50542,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_50542",
                        "name": "2022-Aug-First Half Group Text Report-8.5.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_54654",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 50543,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_50543",
                        "name": "2022-Aug-First Half Group Text Report-8.9.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_54653",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 50544,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_50544",
                        "name": "2022-Aug-First Half Group Text Report-8.10.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_54651",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 50545,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_50545",
                        "name": "2022-Aug-First Half-Individual Texting Report.xlsx_2022-Aug-First Half-Individual ",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_54819",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 50679,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_50679",
                        "name": "Whil_Rethink_Duplicates_ForReview",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_55112",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 50940,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_50940",
                        "name": "Whil Client Data Source 07-July 2022",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_55121",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 50949,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_50949",
                        "name": "Whil Company Account Additions 07-July 2022.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_56384",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 52162,
                "no_of_tasks": 3,
                "inbound_connections": [
                    {
                        "id": "dataset_52162",
                        "name": "MembersV2 Export View",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_65897",
            "name": "EB_Member",
            "type": "dataview",
            "properties": {
                "datasource_id": 52162,
                "no_of_tasks": 4,
                "inbound_connections": [
                    {
                        "id": "dataset_52162",
                        "name": "MembersV2 Export View",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_64487",
                        "name": "FT",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "mssql_12351",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_58225",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 53980,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_53980",
                        "name": "2H September 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_58241",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 53991,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_53991",
                        "name": "2022-09-12-Group Text.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_58236",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 53992,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_53992",
                        "name": "2022-09-14-Group Text.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_58237",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 53993,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_53993",
                        "name": "2022-09-21-Group Text Report.xlsx_2022-09-21-Group Text Report",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_58238",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 53994,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_53994",
                        "name": "2022-09-26-Group Text Report.xlsx_2022-09-26-Group Text Report",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_58239",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 53995,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_53995",
                        "name": "2022-Sept-Second Half-Individual Text Report.xlsx_Individual Texts",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_58240",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 53996,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_53996",
                        "name": "2022-Sept-First Half-Individual Text Report.xlsx_2022-Sept-First Half-Individual",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_60824",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 56491,
                "no_of_tasks": 1,
                "inbound_connections": [
                    {
                        "id": "dataset_56491",
                        "name": "RC Asset Product Code Mapping 2022-10-19.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_67252",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_68968",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_60905",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 56574,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_56574",
                        "name": "RC Platform and Migration Reference.xlsx_Platform and Migration",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_91803",
                        "name": "main_temp",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_61419",
            "name": "FT",
            "type": "dataview",
            "properties": {
                "datasource_id": 56885,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_56885",
                        "name": "fact_training_csv.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_66981",
            "name": "View 2",
            "type": "dataview",
            "properties": {
                "datasource_id": 56885,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_56885",
                        "name": "fact_training_csv.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_61259",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 56885,
                "no_of_tasks": 2,
                "inbound_connections": [
                    {
                        "id": "dataset_56885",
                        "name": "fact_training_csv.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_61797",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 57408,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_57408",
                        "name": "2H October 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_61802",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 57410,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_57410",
                        "name": "Oct 2022-Group Text-10.4.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_61801",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 57411,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_57411",
                        "name": "Oct 2022-Group Text-10.10.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_61800",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 57412,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_57412",
                        "name": "Oct 2022-Group Text-10.12.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_61798",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 57413,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_57413",
                        "name": "Oct 2022-Group Text-10.24.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_61799",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 57414,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_57414",
                        "name": "Oct 2022 - Group Text - Executive Function Launch - 10.27.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_61803",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 57415,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_57415",
                        "name": "Oct 2022 - Individual Texts sw.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_65914",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 61435,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_61435",
                        "name": "2H November 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_65916",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 61436,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_61436",
                        "name": "2022-NOV-First Half-Group Text.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_65915",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 61437,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_61437",
                        "name": "2022-NOV_Second Half-Group Texting Report.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_65917",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 61438,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_61438",
                        "name": "2022-NOV-Second Half-Individual Text Report SW.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_65918",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 61439,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_61439",
                        "name": "2022-NOV-First Half-Individual Texting Report SW.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_66434",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 61933,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_61933",
                        "name": "Child Profile_old",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_66622",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62084,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_62084",
                        "name": "Areas_of_Concern_old",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_66623",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62085,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_62085",
                        "name": "Diagnosis_old",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_227071",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62249,
                "no_of_tasks": 47,
                "inbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67145",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_172866",
                        "name": "MemberYearCaseRate",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataset_166863",
                        "name": "EsteeLauderCaseRate",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataset_164848",
                        "name": "AccentureOnly",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataset_68906",
                        "name": "Case Rate Activity",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "mssql_41280",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_203606",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 62249,
                "no_of_tasks": 47,
                "inbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67145",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_166863",
                        "name": "EsteeLauderCaseRate",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataset_164848",
                        "name": "AccentureOnly",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataset_172866",
                        "name": "MemberYearCaseRate",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataset_68906",
                        "name": "Case Rate Activity",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "bigquery_40073",
                        "name": "bigquery",
                        "type": "bigquery",
                        "connection_type": "primary"
                    },
                    {
                        "id": "mssql_40070",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_66853",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62263,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_62263",
                        "name": "2022-Dec-First Half-Individual Text Report sw.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_66852",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62264,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_62264",
                        "name": "2022-Dec-Second Half-Individual Text Report sw.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_66854",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62265,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_62265",
                        "name": "2022-Dec-First Half-Group Text Report.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_66855",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62266,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_62266",
                        "name": "rc_diagnosis_20230103.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_66856",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62268,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_62268",
                        "name": "2H December 2022 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_66858",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62270,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_62270",
                        "name": "2H December 2022 Vendor Data - EB - EOM Engagement2.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_67190",
            "name": "Account_Child_Count",
            "type": "dataview",
            "properties": {
                "datasource_id": 62346,
                "no_of_tasks": 5,
                "inbound_connections": [
                    {
                        "id": "dataset_62346",
                        "name": "Child_Profile_V3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66949",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_131171",
            "name": "View 2",
            "type": "dataview",
            "properties": {
                "datasource_id": 62346,
                "no_of_tasks": 2,
                "inbound_connections": [
                    {
                        "id": "dataset_62346",
                        "name": "Child_Profile_V3",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_66949",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_131039",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62346,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_62346",
                        "name": "Child_Profile_V3",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_66949",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_67249",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 62346,
                "no_of_tasks": 26,
                "inbound_connections": [
                    {
                        "id": "dataset_62346",
                        "name": "Child_Profile_V3",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_66949",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_162666",
                        "name": "EmployeesOnly",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "bigquery_37144",
                        "name": "bigquery",
                        "type": "bigquery",
                        "connection_type": "primary"
                    },
                    {
                        "id": "mssql_12879",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67301",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_105741",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_168006",
            "name": "Austism",
            "type": "dataview",
            "properties": {
                "datasource_id": 62347,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_62347",
                        "name": "Diagnosis_V3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_160232",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_160683",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_206658",
                        "name": "Optumclients_Confidence",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_168142",
            "name": "LessNoDiagnosis",
            "type": "dataview",
            "properties": {
                "datasource_id": 62347,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_62347",
                        "name": "Diagnosis_V3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_160232",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_160683",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_206658",
                        "name": "Optumclients_Confidence",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_67283",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 62347,
                "no_of_tasks": 7,
                "inbound_connections": [
                    {
                        "id": "dataset_62347",
                        "name": "Diagnosis_V3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62657",
                        "name": "Child_Diagnosis_AreaOfConcern_Report",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_168010",
            "name": "ADHD",
            "type": "dataview",
            "properties": {
                "datasource_id": 62347,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_62347",
                        "name": "Diagnosis_V3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_160232",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_160683",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_206658",
                        "name": "Optumclients_Confidence",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_67300",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 62348,
                "no_of_tasks": 3,
                "inbound_connections": [
                    {
                        "id": "dataset_62348",
                        "name": "Areas_Of_Concern_V3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62657",
                        "name": "Child_Diagnosis_AreaOfConcern_Report",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_105741",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62348,
                "no_of_tasks": 4,
                "inbound_connections": [
                    {
                        "id": "dataset_62348",
                        "name": "Areas_Of_Concern_V3",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67249",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_66949",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 62351,
                "no_of_tasks": 5,
                "inbound_connections": [
                    {
                        "id": "dataset_62351",
                        "name": "CompanyV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67190",
                        "name": "Account_Child_Count",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67249",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_91803",
                        "name": "main_temp",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_131039",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_131171",
                        "name": "View 2",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_148859",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_162666",
                        "name": "EmployeesOnly",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_67181",
            "name": "View 2",
            "type": "dataview",
            "properties": {
                "datasource_id": 62351,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_62351",
                        "name": "CompanyV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_165214",
            "name": "Test",
            "type": "dataview",
            "properties": {
                "datasource_id": 62353,
                "no_of_tasks": 2,
                "inbound_connections": [
                    {
                        "id": "dataset_62353",
                        "name": "MembersV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_224839",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62353,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_62353",
                        "name": "MembersV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_67053",
            "name": "QA",
            "type": "dataview",
            "properties": {
                "datasource_id": 62353,
                "no_of_tasks": 4,
                "inbound_connections": [
                    {
                        "id": "dataset_62353",
                        "name": "MembersV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_162666",
            "name": "EmployeesOnly",
            "type": "dataview",
            "properties": {
                "datasource_id": 62353,
                "no_of_tasks": 42,
                "inbound_connections": [
                    {
                        "id": "dataset_62353",
                        "name": "MembersV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_66949",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_163046",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_67249",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_67015",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 62353,
                "no_of_tasks": 47,
                "inbound_connections": [
                    {
                        "id": "dataset_62353",
                        "name": "MembersV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_66949",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_163046",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_75379",
                        "name": "WhilMemberCreation",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "bigquery_37151",
                        "name": "bigquery",
                        "type": "bigquery",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataset_206916",
                        "name": "AccentureMembers 2",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "s3_20507",
                        "name": "s3",
                        "type": "s3",
                        "connection_type": "primary"
                    },
                    {
                        "id": "mssql_12690",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67102",
                        "name": "Phone Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67102",
                        "name": "Phone Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67102",
                        "name": "Phone Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67102",
                        "name": "Phone Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67103",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67103",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67103",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67103",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67103",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67108",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67108",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67108",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67108",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67108",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67109",
                        "name": "Phone Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67109",
                        "name": "Phone Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67109",
                        "name": "Phone Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67109",
                        "name": "Phone Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67110",
                        "name": "Email Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67110",
                        "name": "Email Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67110",
                        "name": "Email Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67111",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67111",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67111",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67111",
                        "name": "Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67122",
                        "name": "Email Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67122",
                        "name": "Email Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67122",
                        "name": "Email Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67122",
                        "name": "Email Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67122",
                        "name": "Email Name Match V3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_71711",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_83065",
                        "name": "QA",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_83076",
                        "name": "QA",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_86343",
                        "name": "KenEmailMatchV3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_86343",
                        "name": "KenEmailMatchV3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_86343",
                        "name": "KenEmailMatchV3",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_90700",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_91913",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_105741",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_146058",
                        "name": "stress post test",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_153512",
                        "name": "Additional Lives Discussed",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_155454",
                        "name": "NDTopics",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_160195",
                        "name": "stress pre test",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_160222",
                        "name": "conf pre test",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_160225",
                        "name": "conf post test",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_160232",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_160541",
                        "name": "Completed - QA",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_160683",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_165400",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_170912",
                        "name": "PreBehavReg",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_172608",
                        "name": "PreNeuroKnow",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_172610",
                        "name": "PreOrg",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_172611",
                        "name": "PrePlanMang",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_172612",
                        "name": "PreTimeMang",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_172866",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_175396",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_181273",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_181685",
                        "name": "PostBehavReg",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_181686",
                        "name": "PostNeuroKnow",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_181687",
                        "name": "PostOrg",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_181689",
                        "name": "PostPlanMang",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_181690",
                        "name": "PostTimeMang",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_183093",
                        "name": "WaitTimeByWeek",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_183099",
                        "name": "WaitTimeByMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_203606",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_206059",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_206658",
                        "name": "Optumclients_Confidence",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_218977",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_221307",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_227071",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_169701",
            "name": "Device QA",
            "type": "dataview",
            "properties": {
                "datasource_id": 62354,
                "no_of_tasks": 20,
                "inbound_connections": [
                    {
                        "id": "dataset_62354",
                        "name": "Login",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_155432",
            "name": "By Organization",
            "type": "dataview",
            "properties": {
                "datasource_id": 62354,
                "no_of_tasks": 19,
                "inbound_connections": [
                    {
                        "id": "dataset_62354",
                        "name": "Login",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_155441",
            "name": "By Organization Monthly",
            "type": "dataview",
            "properties": {
                "datasource_id": 62354,
                "no_of_tasks": 19,
                "inbound_connections": [
                    {
                        "id": "dataset_62354",
                        "name": "Login",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_66951",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 62354,
                "no_of_tasks": 5,
                "inbound_connections": [
                    {
                        "id": "dataset_62354",
                        "name": "Login",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_152990",
            "name": "By Platform/Device",
            "type": "dataview",
            "properties": {
                "datasource_id": 62354,
                "no_of_tasks": 19,
                "inbound_connections": [
                    {
                        "id": "dataset_62354",
                        "name": "Login",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_83065",
            "name": "QA",
            "type": "dataview",
            "properties": {
                "datasource_id": 62354,
                "no_of_tasks": 8,
                "inbound_connections": [
                    {
                        "id": "dataset_62354",
                        "name": "Login",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_66970",
            "name": "Coaching Scheduled - to Master",
            "type": "dataview",
            "properties": {
                "datasource_id": 62357,
                "no_of_tasks": 5,
                "inbound_connections": [
                    {
                        "id": "dataset_62357",
                        "name": "Coaching",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_66958",
            "name": "Coaching Completed - to Master",
            "type": "dataview",
            "properties": {
                "datasource_id": 62357,
                "no_of_tasks": 20,
                "inbound_connections": [
                    {
                        "id": "dataset_62357",
                        "name": "Coaching",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_145734",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_204721",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_153512",
            "name": "Additional Lives Discussed",
            "type": "dataview",
            "properties": {
                "datasource_id": 62357,
                "no_of_tasks": 15,
                "inbound_connections": [
                    {
                        "id": "dataset_62357",
                        "name": "Coaching",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_145734",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_83076",
            "name": "QA",
            "type": "dataview",
            "properties": {
                "datasource_id": 62357,
                "no_of_tasks": 4,
                "inbound_connections": [
                    {
                        "id": "dataset_62357",
                        "name": "Coaching",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_175396",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_160541",
            "name": "Completed - QA",
            "type": "dataview",
            "properties": {
                "datasource_id": 62357,
                "no_of_tasks": 11,
                "inbound_connections": [
                    {
                        "id": "dataset_62357",
                        "name": "Coaching",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_145734",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_140638",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62357,
                "no_of_tasks": 7,
                "inbound_connections": [
                    {
                        "id": "dataset_62357",
                        "name": "Coaching",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_155454",
            "name": "NDTopics",
            "type": "dataview",
            "properties": {
                "datasource_id": 62357,
                "no_of_tasks": 16,
                "inbound_connections": [
                    {
                        "id": "dataset_62357",
                        "name": "Coaching",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_145734",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "mssql_38013",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_66960",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 62359,
                "no_of_tasks": 7,
                "inbound_connections": [
                    {
                        "id": "dataset_62359",
                        "name": "Text",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_68689",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 62367,
                "no_of_tasks": 47,
                "inbound_connections": [
                    {
                        "id": "dataset_62367",
                        "name": "SF Account Data",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67119",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_68667",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67118",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_60905",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_73530",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_82183",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_82198",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_82802",
                        "name": "ActiveAssets",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_115004",
                        "name": "InactiveAssets",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_66949",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_163046",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "bigquery_37152",
                        "name": "bigquery",
                        "type": "bigquery",
                        "connection_type": "primary"
                    },
                    {
                        "id": "mssql_14689",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67249",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_83065",
                        "name": "QA",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_148859",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_162666",
                        "name": "EmployeesOnly",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_170919",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_91803",
            "name": "main_temp",
            "type": "dataview",
            "properties": {
                "datasource_id": 62367,
                "no_of_tasks": 31,
                "inbound_connections": [
                    {
                        "id": "dataset_62367",
                        "name": "SF Account Data",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67119",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_68667",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67118",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_60905",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_73530",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_82183",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_82198",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_82802",
                        "name": "ActiveAssets",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_66949",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_67252",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 62368,
                "no_of_tasks": 9,
                "inbound_connections": [
                    {
                        "id": "dataset_62368",
                        "name": "SF Asset Data",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_60824",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_63988",
                        "name": "SF Asset_Filtered",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataset_78022",
                        "name": "Solution Purchased",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataset_62492",
                        "name": "Asset_VP+ALC_V3",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataset_62491",
                        "name": "Asset_LaunchpadOnlyV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_140730",
            "name": "View 2",
            "type": "dataview",
            "properties": {
                "datasource_id": 62368,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_62368",
                        "name": "SF Asset Data",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_68968",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62368,
                "no_of_tasks": 3,
                "inbound_connections": [
                    {
                        "id": "dataset_62368",
                        "name": "SF Asset Data",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_60824",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_67119",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62491,
                "no_of_tasks": 1,
                "inbound_connections": [
                    {
                        "id": "dataset_62491",
                        "name": "Asset_LaunchpadOnlyV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_91803",
                        "name": "main_temp",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_142229",
            "name": "View 2",
            "type": "dataview",
            "properties": {
                "datasource_id": 62491,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_62491",
                        "name": "Asset_LaunchpadOnlyV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_67118",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62492,
                "no_of_tasks": 4,
                "inbound_connections": [
                    {
                        "id": "dataset_62492",
                        "name": "Asset_VP+ALC_V3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_91803",
                        "name": "main_temp",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_67145",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 62520,
                "no_of_tasks": 1,
                "inbound_connections": [
                    {
                        "id": "dataset_62520",
                        "name": "event_mapping.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_203606",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_227071",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_67301",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 62657,
                "no_of_tasks": 1,
                "inbound_connections": [
                    {
                        "id": "dataset_62657",
                        "name": "Child_Diagnosis_AreaOfConcern_Report",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67249",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "bigquery_37143",
                        "name": "bigquery",
                        "type": "bigquery",
                        "connection_type": "primary"
                    },
                    {
                        "id": "mssql_12878",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_68667",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 63988,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_63988",
                        "name": "SF Asset_Filtered",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_91803",
                        "name": "main_temp",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_82782",
            "name": "ForCompletedSessions",
            "type": "dataview",
            "properties": {
                "datasource_id": 66969,
                "no_of_tasks": 4,
                "inbound_connections": [
                    {
                        "id": "dataset_66969",
                        "name": "TrainingHistory",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_91913",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_71696",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 66969,
                "no_of_tasks": 9,
                "inbound_connections": [
                    {
                        "id": "dataset_66969",
                        "name": "TrainingHistory",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_71711",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 66986,
                "no_of_tasks": 9,
                "inbound_connections": [
                    {
                        "id": "dataset_66986",
                        "name": "UserActivityLog",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_73210",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 68496,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_68496",
                        "name": "2023-Jan-Second Half-Individual Texts.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_73209",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 68497,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_68497",
                        "name": "2023-Jan-Second Half-Group Text 3.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_73211",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 68498,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_68498",
                        "name": "2023-Jan-Second Half-Group Text 2.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_73212",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 68499,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_68499",
                        "name": "2023-Jan - Second Half - Group Text 1.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_73213",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 68503,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_68503",
                        "name": "2H January 2023 Vendor Data - EB - EOM Engagement2.xlsx_New",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_73530",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 68821,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_68821",
                        "name": "Launchpad List",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_91803",
                        "name": "main_temp",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_73615",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 68906,
                "no_of_tasks": 2,
                "inbound_connections": [
                    {
                        "id": "dataset_68906",
                        "name": "Case Rate Activity",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "mssql_18266",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_80145",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 75378,
                "no_of_tasks": 1,
                "inbound_connections": [
                    {
                        "id": "dataset_75378",
                        "name": "WhilUserCreations_TeamAdminID",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_80146",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_80146",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 75379,
                "no_of_tasks": 7,
                "inbound_connections": [
                    {
                        "id": "dataset_75379",
                        "name": "WhilMemberCreation",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_80145",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_80557",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 75786,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_75786",
                        "name": "2023-Feb-First Half-Individual Texting Report.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_80556",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 75787,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_75787",
                        "name": "2023-Feb-Second Half-Individual Texting Report.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_80558",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 75788,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_75788",
                        "name": "2023-Feb-First Half-Group Text.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_80559",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 75789,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_75789",
                        "name": "2H February 2023 Vendor Data - EB - EOM Engagement.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_81820",
            "name": "Ken QA",
            "type": "dataview",
            "properties": {
                "datasource_id": 75883,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_75883",
                        "name": "Members_new",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_82838",
            "name": "Ken QA2",
            "type": "dataview",
            "properties": {
                "datasource_id": 75883,
                "no_of_tasks": 3,
                "inbound_connections": [
                    {
                        "id": "dataset_75883",
                        "name": "Members_new",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_80654",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 75883,
                "no_of_tasks": 4,
                "inbound_connections": [
                    {
                        "id": "dataset_75883",
                        "name": "Members_new",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_81821",
            "name": "View 4",
            "type": "dataview",
            "properties": {
                "datasource_id": 75883,
                "no_of_tasks": 3,
                "inbound_connections": [
                    {
                        "id": "dataset_75883",
                        "name": "Members_new",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_82183",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 77400,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_77400",
                        "name": "Population Served Quantity Override List.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_91803",
                        "name": "main_temp",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_82198",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 77415,
                "no_of_tasks": 1,
                "inbound_connections": [
                    {
                        "id": "dataset_77415",
                        "name": "Case Rate List.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_91803",
                        "name": "main_temp",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_115004",
            "name": "InactiveAssets",
            "type": "dataview",
            "properties": {
                "datasource_id": 78022,
                "no_of_tasks": 10,
                "inbound_connections": [
                    {
                        "id": "dataset_78022",
                        "name": "Solution Purchased",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_82802",
            "name": "ActiveAssets",
            "type": "dataview",
            "properties": {
                "datasource_id": 78022,
                "no_of_tasks": 10,
                "inbound_connections": [
                    {
                        "id": "dataset_78022",
                        "name": "Solution Purchased",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_91803",
                        "name": "main_temp",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_85237",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 80435,
                "no_of_tasks": 1,
                "inbound_connections": [
                    {
                        "id": "dataset_80435",
                        "name": "DS1.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_85240",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 80439,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_80439",
                        "name": "DS1_ec.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_80435",
                        "name": "DS1.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_90700",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 85870,
                "no_of_tasks": 2,
                "inbound_connections": [
                    {
                        "id": "dataset_85870",
                        "name": "Completed_Series",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "mssql_28124",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    },
                    {
                        "id": "bigquery_37145",
                        "name": "bigquery",
                        "type": "bigquery",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_91913",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 87042,
                "no_of_tasks": 10,
                "inbound_connections": [
                    {
                        "id": "dataset_87042",
                        "name": "CompletedSessions",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_82782",
                        "name": "ForCompletedSessions",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_221307",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "mssql_28123",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    },
                    {
                        "id": "bigquery_37146",
                        "name": "bigquery",
                        "type": "bigquery",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_102084",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 97216,
                "no_of_tasks": 19,
                "inbound_connections": [
                    {
                        "id": "dataset_97216",
                        "name": "Content_Pulled",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_21276",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_183099",
            "name": "WaitTimeByMonth",
            "type": "dataview",
            "properties": {
                "datasource_id": 110084,
                "no_of_tasks": 10,
                "inbound_connections": [
                    {
                        "id": "dataset_110084",
                        "name": "AvgTimeToScheduleConsultation",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_183093",
            "name": "WaitTimeByWeek",
            "type": "dataview",
            "properties": {
                "datasource_id": 110084,
                "no_of_tasks": 12,
                "inbound_connections": [
                    {
                        "id": "dataset_110084",
                        "name": "AvgTimeToScheduleConsultation",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_165400",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 110084,
                "no_of_tasks": 10,
                "inbound_connections": [
                    {
                        "id": "dataset_110084",
                        "name": "AvgTimeToScheduleConsultation",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_116056",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 110981,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_110981",
                        "name": "Utilization page 2 copy",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_146058",
            "name": "stress post test",
            "type": "dataview",
            "properties": {
                "datasource_id": 122983,
                "no_of_tasks": 8,
                "inbound_connections": [
                    {
                        "id": "dataset_122983",
                        "name": "Parenting_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_154154",
                        "name": "Stress Master",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_160195",
                        "name": "stress pre test",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_160195",
            "name": "stress pre test",
            "type": "dataview",
            "properties": {
                "datasource_id": 122983,
                "no_of_tasks": 11,
                "inbound_connections": [
                    {
                        "id": "dataset_122983",
                        "name": "Parenting_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_146058",
                        "name": "stress post test",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_154154",
                        "name": "Stress Master",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_160225",
            "name": "conf post test",
            "type": "dataview",
            "properties": {
                "datasource_id": 122983,
                "no_of_tasks": 7,
                "inbound_connections": [
                    {
                        "id": "dataset_122983",
                        "name": "Parenting_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_154175",
                        "name": "Confidence Master",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_160222",
                        "name": "conf pre test",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_160222",
            "name": "conf pre test",
            "type": "dataview",
            "properties": {
                "datasource_id": 122983,
                "no_of_tasks": 11,
                "inbound_connections": [
                    {
                        "id": "dataset_122983",
                        "name": "Parenting_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_160225",
                        "name": "conf post test",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_154175",
                        "name": "Confidence Master",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_128794",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 122983,
                "no_of_tasks": 2,
                "inbound_connections": [
                    {
                        "id": "dataset_122983",
                        "name": "Parenting_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_221388",
            "name": "View 2",
            "type": "dataview",
            "properties": {
                "datasource_id": 122983,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_122983",
                        "name": "Parenting_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_135887",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 129481,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_129481",
                        "name": "SF_Accounts_viaAPI",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_130471",
                        "name": "SF_Accounts_viaAPI_Combined",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_135885",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 129483,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_129483",
                        "name": "SF_AssetsViaAPI_AG",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_129485",
                        "name": "SF_AssetsViaAPI_QZ",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_135888",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 129484,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_129484",
                        "name": "SF_AssetsviaAPI_HP",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_129485",
                        "name": "SF_AssetsViaAPI_QZ",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_135886",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 129485,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_129485",
                        "name": "SF_AssetsViaAPI_QZ",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_130469",
                        "name": "SF_Assets_viaAPI_Combined",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_136898",
            "name": "to_be_deleted_after_date_bug_is_resolved",
            "type": "dataview",
            "properties": {
                "datasource_id": 130469,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_130469",
                        "name": "SF_Assets_viaAPI_Combined",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "s3_37063",
                        "name": "s3",
                        "type": "s3",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_136768",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 130469,
                "no_of_tasks": 4,
                "inbound_connections": [
                    {
                        "id": "dataset_130469",
                        "name": "SF_Assets_viaAPI_Combined",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62368",
                        "name": "SF Asset Data",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_137216",
            "name": "to_be_deleted_after_date_bug_is_resolved",
            "type": "dataview",
            "properties": {
                "datasource_id": 130471,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_130471",
                        "name": "SF_Accounts_viaAPI_Combined",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "s3_37079",
                        "name": "s3",
                        "type": "s3",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_136770",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 130471,
                "no_of_tasks": 3,
                "inbound_connections": [
                    {
                        "id": "dataset_130471",
                        "name": "SF_Accounts_viaAPI_Combined",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62367",
                        "name": "SF Account Data",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_145172",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 138844,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_138844",
                        "name": "November Group Text 2 - 11.14.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_145173",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 138845,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_138845",
                        "name": "November Text 3 - 11.21.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_145171",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 138846,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_138846",
                        "name": "November Group Text 4 - 11.27.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_145174",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 138847,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_138847",
                        "name": "November Group Text 1 - 11.13.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_145176",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 138848,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_138848",
                        "name": "November Texting Reports - Individual.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_145175",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 138849,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_138849",
                        "name": "November Vendor Data.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_145734",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 139399,
                "no_of_tasks": 1,
                "inbound_connections": [
                    {
                        "id": "dataset_139399",
                        "name": "Keyval",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66958",
                        "name": "Coaching Completed - to Master",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_153512",
                        "name": "Additional Lives Discussed",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_155454",
                        "name": "NDTopics",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_160541",
                        "name": "Completed - QA",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_148859",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 142513,
                "no_of_tasks": 3,
                "inbound_connections": [
                    {
                        "id": "dataset_142513",
                        "name": "AccountAttributes",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_66949",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_162488",
            "name": "SoftBounce",
            "type": "dataview",
            "properties": {
                "datasource_id": 148158,
                "no_of_tasks": 9,
                "inbound_connections": [
                    {
                        "id": "dataset_148158",
                        "name": "brazemammoth",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_155843",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 148158,
                "no_of_tasks": 14,
                "inbound_connections": [
                    {
                        "id": "dataset_148158",
                        "name": "brazemammoth",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_154263",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 148158,
                "no_of_tasks": 9,
                "inbound_connections": [
                    {
                        "id": "dataset_148158",
                        "name": "brazemammoth",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_157236",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 151184,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_151184",
                        "name": "TaggedKeywords",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_196099",
            "name": "OptumClients Stress1",
            "type": "dataview",
            "properties": {
                "datasource_id": 154154,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_154154",
                        "name": "Stress Master",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_221412",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 154154,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_154154",
                        "name": "Stress Master",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_206290",
            "name": "OptumClients_Stress_view 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 154154,
                "no_of_tasks": 1,
                "inbound_connections": [
                    {
                        "id": "dataset_154154",
                        "name": "Stress Master",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_160683",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 154154,
                "no_of_tasks": 7,
                "inbound_connections": [
                    {
                        "id": "dataset_154154",
                        "name": "Stress Master",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_168006",
                        "name": "Austism",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_168010",
                        "name": "ADHD",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_168142",
                        "name": "LessNoDiagnosis",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_160232",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 154175,
                "no_of_tasks": 7,
                "inbound_connections": [
                    {
                        "id": "dataset_154175",
                        "name": "Confidence Master",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_168006",
                        "name": "Austism",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_168010",
                        "name": "ADHD",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_168142",
                        "name": "LessNoDiagnosis",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_206658",
            "name": "Optumclients_Confidence",
            "type": "dataview",
            "properties": {
                "datasource_id": 154175,
                "no_of_tasks": 7,
                "inbound_connections": [
                    {
                        "id": "dataset_154175",
                        "name": "Confidence Master",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_168006",
                        "name": "Austism",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_168010",
                        "name": "ADHD",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_168142",
                        "name": "LessNoDiagnosis",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_163046",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 157063,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_157063",
                        "name": "CountryToRegion Key.xlsx_Key",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_162666",
                        "name": "EmployeesOnly",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_168067",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 162210,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_162210",
                        "name": "UserFeedback",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_199915",
            "name": "FiscalMonth",
            "type": "dataview",
            "properties": {
                "datasource_id": 164848,
                "no_of_tasks": 51,
                "inbound_connections": [
                    {
                        "id": "dataset_164848",
                        "name": "AccentureOnly",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_199918",
            "name": "FiscalQuarter",
            "type": "dataview",
            "properties": {
                "datasource_id": 164848,
                "no_of_tasks": 29,
                "inbound_connections": [
                    {
                        "id": "dataset_164848",
                        "name": "AccentureOnly",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_199921",
            "name": "FiscalYear",
            "type": "dataview",
            "properties": {
                "datasource_id": 164848,
                "no_of_tasks": 17,
                "inbound_connections": [
                    {
                        "id": "dataset_164848",
                        "name": "AccentureOnly",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_199925",
            "name": "Cumulative",
            "type": "dataview",
            "properties": {
                "datasource_id": 164848,
                "no_of_tasks": 16,
                "inbound_connections": [
                    {
                        "id": "dataset_164848",
                        "name": "AccentureOnly",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_210710",
                        "name": "View 1",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_170776",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 164848,
                "no_of_tasks": 8,
                "inbound_connections": [
                    {
                        "id": "dataset_164848",
                        "name": "AccentureOnly",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_181687",
            "name": "PostOrg",
            "type": "dataview",
            "properties": {
                "datasource_id": 164982,
                "no_of_tasks": 5,
                "inbound_connections": [
                    {
                        "id": "dataset_164982",
                        "name": "Neurodiversity_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_176324",
                        "name": "Organization MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_172610",
                        "name": "PreOrg",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_181685",
            "name": "PostBehavReg",
            "type": "dataview",
            "properties": {
                "datasource_id": 164982,
                "no_of_tasks": 5,
                "inbound_connections": [
                    {
                        "id": "dataset_164982",
                        "name": "Neurodiversity_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_176321",
                        "name": "Emotional and Behav Reg MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_170912",
                        "name": "PreBehavReg",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_181690",
            "name": "PostTimeMang",
            "type": "dataview",
            "properties": {
                "datasource_id": 164982,
                "no_of_tasks": 5,
                "inbound_connections": [
                    {
                        "id": "dataset_164982",
                        "name": "Neurodiversity_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_176326",
                        "name": "Time Management MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_172612",
                        "name": "PreTimeMang",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_181686",
            "name": "PostNeuroKnow",
            "type": "dataview",
            "properties": {
                "datasource_id": 164982,
                "no_of_tasks": 5,
                "inbound_connections": [
                    {
                        "id": "dataset_164982",
                        "name": "Neurodiversity_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_176322",
                        "name": "Neurodiversity Knowledge MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_172608",
                        "name": "PreNeuroKnow",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_181689",
            "name": "PostPlanMang",
            "type": "dataview",
            "properties": {
                "datasource_id": 164982,
                "no_of_tasks": 5,
                "inbound_connections": [
                    {
                        "id": "dataset_164982",
                        "name": "Neurodiversity_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_176325",
                        "name": "Plan Management MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_172611",
                        "name": "PrePlanMang",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_170912",
            "name": "PreBehavReg",
            "type": "dataview",
            "properties": {
                "datasource_id": 164982,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_164982",
                        "name": "Neurodiversity_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_181685",
                        "name": "PostBehavReg",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_176321",
                        "name": "Emotional and Behav Reg MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_172610",
            "name": "PreOrg",
            "type": "dataview",
            "properties": {
                "datasource_id": 164982,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_164982",
                        "name": "Neurodiversity_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_181687",
                        "name": "PostOrg",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_176324",
                        "name": "Organization MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_172612",
            "name": "PreTimeMang",
            "type": "dataview",
            "properties": {
                "datasource_id": 164982,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_164982",
                        "name": "Neurodiversity_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_181690",
                        "name": "PostTimeMang",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_176326",
                        "name": "Time Management MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_172608",
            "name": "PreNeuroKnow",
            "type": "dataview",
            "properties": {
                "datasource_id": 164982,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_164982",
                        "name": "Neurodiversity_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_181686",
                        "name": "PostNeuroKnow",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_176322",
                        "name": "Neurodiversity Knowledge MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_172611",
            "name": "PrePlanMang",
            "type": "dataview",
            "properties": {
                "datasource_id": 164982,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_164982",
                        "name": "Neurodiversity_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_181689",
                        "name": "PostPlanMang",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_176325",
                        "name": "Plan Management MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_181472",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 164982,
                "no_of_tasks": 1,
                "inbound_connections": [
                    {
                        "id": "dataset_164982",
                        "name": "Neurodiversity_Assessment",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_170919",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 164989,
                "no_of_tasks": 1,
                "inbound_connections": [
                    {
                        "id": "dataset_164989",
                        "name": "Utilization_for_Mammoth",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_68689",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "mssql_38815",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_172745",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 166863,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_166863",
                        "name": "EsteeLauderCaseRate",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "mssql_40132",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_172866",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 166984,
                "no_of_tasks": 8,
                "inbound_connections": [
                    {
                        "id": "dataset_166984",
                        "name": "UserSearch",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "mssql_39800",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_182696",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 169559,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_169559",
                        "name": "DiscussionGroups_Registration",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_175390",
            "name": "RegistrationMain",
            "type": "dataview",
            "properties": {
                "datasource_id": 169559,
                "no_of_tasks": 9,
                "inbound_connections": [
                    {
                        "id": "dataset_169559",
                        "name": "DiscussionGroups_Registration",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_175396",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 169565,
                "no_of_tasks": 2,
                "inbound_connections": [
                    {
                        "id": "dataset_169565",
                        "name": "TherapistPortalBenefitReferral",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_83076",
                        "name": "QA",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_207346",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 172866,
                "no_of_tasks": 23,
                "inbound_connections": [
                    {
                        "id": "dataset_172866",
                        "name": "MemberYearCaseRate",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_178576",
            "name": "RD",
            "type": "dataview",
            "properties": {
                "datasource_id": 172866,
                "no_of_tasks": 14,
                "inbound_connections": [
                    {
                        "id": "dataset_172866",
                        "name": "MemberYearCaseRate",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_181273",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 175633,
                "no_of_tasks": 9,
                "inbound_connections": [
                    {
                        "id": "dataset_175633",
                        "name": "UserOnboadingSelections",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "mssql_39799",
                        "name": "mssql",
                        "type": "mssql",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_181309",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 175676,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_175676",
                        "name": "ABTest_Recommender",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_181909",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 176321,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_176321",
                        "name": "Emotional and Behav Reg MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_181910",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 176322,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_176322",
                        "name": "Neurodiversity Knowledge MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_181912",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 176324,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_176324",
                        "name": "Organization MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_181913",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 176325,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_176325",
                        "name": "Plan Management MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_181914",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 176326,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_176326",
                        "name": "Time Management MASTER",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_195367",
            "name": "View 2",
            "type": "dataview",
            "properties": {
                "datasource_id": 178780,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_178780",
                        "name": "DiscussionGroups_Attendance",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_184303",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 178780,
                "no_of_tasks": 9,
                "inbound_connections": [
                    {
                        "id": "dataset_178780",
                        "name": "DiscussionGroups_Attendance",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_185340",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 179849,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_179849",
                        "name": "July Vendor Data.xlsx_Sheet1 3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_185341",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 179850,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_179850",
                        "name": "July 2024 Individual Text.xlsx_sent_messages_62b7da17bc83000_c 2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_190757",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 185444,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_185444",
                        "name": "August 2024 Individual Texts.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_190761",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 185448,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_185448",
                        "name": "August Vendor Data.xlsx_Sheet1 3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_196361",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 191993,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_191993",
                        "name": "OptumClients Confidence",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_200225",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 196034,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_196034",
                        "name": "Member-June.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_75379",
                        "name": "WhilMemberCreation",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_200384",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 196182,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_196182",
                        "name": "membersv3_8th aug-Updated.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_75379",
                        "name": "WhilMemberCreation",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_201300",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 197130,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_197130",
                        "name": "Optum clients confidence master",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_204721",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 200630,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_200630",
                        "name": "Coaching EST Adjustment Reference 11-26-2024.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_66958",
                        "name": "Coaching Completed - to Master",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_206059",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 202108,
                "no_of_tasks": 2,
                "inbound_connections": [
                    {
                        "id": "dataset_202108",
                        "name": "Braze_ExternalID",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_210524",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 206679,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_206679",
                        "name": "2024-Jan-Individual Texts.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_210580",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 206762,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_206762",
                        "name": "April 2024 - Group Text1.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_210710",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 206916,
                "no_of_tasks": 62,
                "inbound_connections": [
                    {
                        "id": "dataset_206916",
                        "name": "AccentureMembers 2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199915",
                        "name": "FiscalMonth",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199918",
                        "name": "FiscalQuarter",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199921",
                        "name": "FiscalYear",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199921",
                        "name": "FiscalYear",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199921",
                        "name": "FiscalYear",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199921",
                        "name": "FiscalYear",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_199925",
                        "name": "Cumulative",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_216137",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 212332,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_212332",
                        "name": "January Vendor Data.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_218958",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 215215,
                "no_of_tasks": 5,
                "inbound_connections": [
                    {
                        "id": "dataset_215215",
                        "name": "Login - DO NOT REFRESH",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_218977",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 215222,
                "no_of_tasks": 9,
                "inbound_connections": [
                    {
                        "id": "dataset_215222",
                        "name": "UserActivityLog - DO NOT REFRESH",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_221298",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 217548,
                "no_of_tasks": 8,
                "inbound_connections": [
                    {
                        "id": "dataset_217548",
                        "name": "TrainingHistory - DO NOT REFRESH",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataset_62249",
                        "name": "MasterV3",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ]
            }
        },
        {
            "id": "dataview_221295",
            "name": "ForCompletedSessions",
            "type": "dataview",
            "properties": {
                "datasource_id": 217548,
                "no_of_tasks": 4,
                "inbound_connections": [
                    {
                        "id": "dataset_217548",
                        "name": "TrainingHistory - DO NOT REFRESH",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_221307",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_221307",
            "name": "Main",
            "type": "dataview",
            "properties": {
                "datasource_id": 217552,
                "no_of_tasks": 6,
                "inbound_connections": [
                    {
                        "id": "dataset_217552",
                        "name": "CompletedSessions  - DO NOT REFRESH",
                        "type": "dataset",
                        "connection_type": "primary"
                    },
                    {
                        "id": "dataview_67015",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    },
                    {
                        "id": "dataview_221295",
                        "name": "ForCompletedSessions",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ],
                "outbound_connections": [
                    {
                        "id": "dataview_91913",
                        "name": "Main",
                        "type": "dataview",
                        "connection_type": "secondary"
                    }
                ]
            }
        },
        {
            "id": "dataview_221538",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 217795,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_217795",
                        "name": "February Vendor Data.xlsx_Sheet1",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_221539",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 217796,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_217796",
                        "name": "February Individual Texts.csv",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        },
        {
            "id": "dataview_226916",
            "name": "View 1",
            "type": "dataview",
            "properties": {
                "datasource_id": 223373,
                "no_of_tasks": 0,
                "inbound_connections": [
                    {
                        "id": "dataset_223373",
                        "name": "March Vendor Data.xlsx_Sheet3 2",
                        "type": "dataset",
                        "connection_type": "primary"
                    }
                ],
                "outbound_connections": []
            }
        }
    ]
    };
    if(dataCopy && !dataCopy.title){
      graphData=dataCopy;
    }

    function buildEdgesFromData(data) {
      const edges = [];

      function processConnections(items) {
        items.forEach(item => {
          if (item.properties && item.properties.inbound_connections) {
            item.properties.inbound_connections.forEach(conn => {
              edges.push({
                source: conn.id,  // Parent node
                target: item.id,  // Current node
                type: conn.connection_type || "primary",
                properties: {
                  type: conn.connection_type || "primary"
                }
              });
            });
          }
        });
      }

      // Process both datasets and dataviews
      processConnections(data.datasets);
      processConnections(data.dataviews);

      return edges;
    }

  function buildNodesFromData(data) {
    const nodes = [];

    function processItems(items, type) {
        items.forEach(item => {
            nodes.push({
                id: item.id,
                name: item.name,
                type: type,  // "dataset" or "dataview"
                properties:item.properties,
            });
            if(item.properties.inbound_connections){
              let inbounds = item.properties.inbound_connections;
              inbounds.forEach(d => {
                if(d.type != "dataset" && d.type != "dataview"){
                  nodes.push({
                id: d.id,
                name: d.name,
                type: d.type,  // "dataset" or "dataview"
                customType:"DB",
                properties:{
                  icon:"elephant"
                },
            });
                }
              })
              
            }
        });
    }

    // Process both datasets and dataviews
    processItems(data.datasets, "dataset");
    processItems(data.dataviews, "dataview");

    return nodes;
}

      let savedTransform = d3.zoomIdentity;
      let clickedNumber = 1;
    //   let oldScreenX = 0;
    //   let oldScreenY = 0;
    //   let currentClickedId="";

// Example usage:
graphData.edgesAll = buildEdgesFromData(graphData);
// Example usage:
graphData.nodes = buildNodesFromData(graphData);

completeData(graphData);

    
    let maxWidthForDataSet = 170;
    let maxWidthForDataView = 80;
    let maxWidthForExpandedNode = 270;
    let blueColor =  "#3b82f6";
    let greenColor = "#a3c293";

    // Global variable to toggle between curved and rectangular links
    let useCurvedLinks = false;

    // Function to switch link styles
    function toggleLinkStyle() {
      useCurvedLinks = !useCurvedLinks;
      update(root); // Re-render the graph with the new style
    }

    // --- Build a Hierarchical Tree from the Network ---
    const nodesById = new Map();
    graphData.nodes.forEach(n => nodesById.set(n.id, n));

    // Build a mapping from a source id to its array of target ids.
    const childrenMap = {};
    graphData.edges.forEach(edge => {
      if (!childrenMap[edge.source]) {
        childrenMap[edge.source] = [];
      }
      childrenMap[edge.source].push(edge.target);
    });
   // function that make overlav
    function openOverlay(data) {
      isDrawerOpen.value = true;
      itemId.value = data.id;
      dataShowInDrawer.value = { ...data };
    }
    function closeOverlay(){
      isDrawerOpen.value = false;
    }

    // Recursively build a tree from a given node id.
    // function buildTree(nodeId) {
    //   const node = nodesById.get(nodeId);
    //   // Create a shallow copy of the node.
    //   const treeNode = Object.assign({}, node);
    //   if (childrenMap[nodeId]) {
    //     treeNode.children = childrenMap[nodeId].map(childId => buildTree(childId));
    //   }
    //   return treeNode;
    // }
    function completeData(graphData) {
      if (graphData.edgesAll) {
        graphData.edges = graphData.edgesAll.filter(link => link.properties.type === "primary");
        graphData.secondaryEdges = graphData.edgesAll.filter(link => link.properties.type === "secondary");
      }
      graphData.nodes.forEach(node => {
        if(node.type !== "dataset" && node.type !== "dataview"){
          node.customType="DB";
        }
        if (node.type === "dataset" && (!node.properties.batches || node.properties.batches.length === 0)) {
          node.properties.batches = [{ id: `batch_${node.id}`, name: "0 Batch", row_count: "0" }];
        }
      });
    }
    function buildHierarchyAndCrossEdges() {
      const nodeById = new Map();
      graphData.nodes.forEach(n => {
        nodeById.set(n.id, { ...n, parentId: null });
      });

      const childrenMap = {};
      // const crossEdges = [];

      // Build a primary tree by assigning the first parent we find,
      // and treat subsequent parents as crossEdges.
      graphData.edges.forEach(e => {
        const tgt = nodeById.get(e.target);
        const src = nodeById.get(e.source);
        if (tgt.parentId === null && (src.type != "dataview" || tgt.customType == "DB")) {
          // no parent yet => this becomes the primary parent
          tgt.parentId = e.source;
          if (!childrenMap[e.source]) childrenMap[e.source] = [];
          childrenMap[e.source].push(e.target);
        } else {
          // already has a parent => treat as crossEdge
          graphData.secondaryEdges.push(e);
        }
      });

      // Identify roots => nodes that have no parent
      const roots = [];
      nodeById.forEach(node => {
        if (node.parentId === null) {
          roots.push(node);
        }
      });

      // Build a tree function
      function buildTree(nodeId) {
        const n = nodeById.get(nodeId);
        // create a shallow copy
        const treeNode = { ...n };
        if (childrenMap[nodeId]) {
          treeNode.children = childrenMap[nodeId].map(childId => buildTree(childId));
        }
        return treeNode;
      }

      let treeData;
      if (roots.length > 1) {
        // multiple roots => create synthetic root
        treeData = {
          id: "synthetic_root",
          name: "Root",
          type: "root",
          children: roots.map(r => buildTree(r.id))
        };
      } else if (roots.length === 1) {
        treeData = buildTree(roots[0].id);
      } else {
        // no roots => fallback
        treeData = null;
      }
      return treeData ;
    }

    let datasetConnections = [];

const datasetIds = new Set();

// Build a mapping from view id to its parent dataset id.
// Assuming that each view’s datasource_id corresponds to the dataset id suffix.
const viewToDataset = {};
graphData.dataviews.forEach(view => {
  // Convert datasource_id (number) to a dataset id string (e.g., "dataset_954")
  viewToDataset[view.id] = `dataset_${view.properties.datasource_id}`;
});

// Process each dataview to generate dataset-to-dataset connections
graphData.dataviews.forEach(view => {
  // Map inbound connections to objects with id, actual, and connectionType
  const inboundDatasets = view.properties.inbound_connections
    .map(conn => {
      if (conn.type === "dataset") {
        return { id: conn.id, actual: conn.id, connectionType: conn.connection_type };
      } else if (conn.type === "dataview") {
        // Convert the view id to its parent dataset id and store original view id
        return { id: viewToDataset[conn.id], actual: conn.id, connectionType: conn.connection_type };
      }
      return null;
    })
    .filter(obj => obj !== null);

  // Map outbound connections similarly
  const outboundDatasets = view.properties.outbound_connections
    .map(conn => {
      if (conn.type === "dataset") {
        return { id: conn.id, actual: conn.id, connectionType: conn.connection_type };
      } else if (conn.type === "dataview") {
        return { id: viewToDataset[conn.id], actual: conn.id, connectionType: conn.connection_type };
      }
      return null;
    })
    .filter(obj => obj !== null);


  // For every inbound dataset, pair with every outbound dataset.
  inboundDatasets.forEach(inbound => {
    outboundDatasets.forEach(outbound => {
      // Only add if they are different.
      if (inbound.id !== outbound.id && inbound.connectionType == "primary") {// && inbound.connectionType == "primary"
        datasetConnections.push({
          source: inbound.id,
          target: outbound.id,
          actualSource: inbound.actual,
          actualTarget: outbound.actual,
          // For connectionType, here we take the inbound connection's type.
          // You could modify this if needed.
        //   connectionType: inbound.connectionType,
          connectionType: outbound.connectionType
        });
        // Also add the ids to our set of dataset ids.
        datasetIds.add(inbound.id);
        datasetIds.add(outbound.id);
      }
    });
  });
});

    const treeData  = buildHierarchyAndCrossEdges();
    const secondDegreeDataset = new Set();
    treeData.children.forEach((d)=>{
        if(d.type=="dataset"){
            secondDegreeDataset.add(d.id);
        }
    })

    const actualTreeData = JSON.parse(JSON.stringify(treeData));

    // Identify all root nodes (nodes that never appear as a target).
    const targets = new Set(graphData.edges.map(e => e.target));
    const roots = graphData.nodes.filter(n => !targets.has(n.id));

    // --- Set Up SVG and Tree Layout ---
    const margin = { top: 20, right: 140, bottom: 20, left: 30 };
    if(roots.length>1){
      margin.right = 20;
    }
    let transalteFrom_left=50;
    if(roots.length==1 && roots[0].type=="dataset"){//
      margin.left=120;
      transalteFrom_left=150;
    }
    let width,height;
    const nodeById = {};
      
    
    let i = 0;

    const InitializeSvg= ()=>{
      if (!tree.value) return;
      svg = d3
        .select(tree.value)
        .append('svg')
       

        svg.append("text")
        .attr("x", 20)  // Position the text
        .attr("y", 20)
        .attr("fill", "black")  // Text color
        .attr("font-size", "14px")
        .text("");//Zoom: Shift + Mouse Wheel | Pan: Shift + Click & Drag
        svg.append("g");
    }

    const updateDegreeCount =()=>{
    const datasetButtonContainer = d3.select(".datasetList");
      const datasetDivs = datasetButtonContainer.selectAll("div.dataset-item");
      datasetDivs.filter(data => secondDegreeDataset.has(data.id))
      .select(".dataset-name").text(d=> "(2)" + d.name);
    }
    
    const drawTree = () => {
      if (!tree.value) return;
     
      root = d3.hierarchy(treeData, d => d.children);

      const levelCounts = {}; // Object to store level-wise counts
      root.descendants().forEach(d => {
        nodeById[d.data.id] = d;

        const depth = d.depth; // Get the depth level of the node

        if (!levelCounts[depth]) {
          levelCounts[depth] = 0; // Initialize if not present
        }

        levelCounts[depth]++; // Increment count for the level
      });
     
        let windowWidth = window.innerWidth;
      const isLeftDrawerOpen = document.querySelector('.mm-drawer--open');
      let leftDrawerWidth = null;

      if (isLeftDrawerOpen !== null) {
        leftDrawerWidth = isLeftDrawerOpen.offsetWidth; // Get the width in pixels
      }

      let svgWidth = windowWidth - margin.right - margin.left - (isLeftDrawerOpen ? (leftDrawerWidth + 40) : 80);


      // width = 1000 - margin.right - margin.left,
      width = svgWidth,
        height = 500 - margin.top - margin.bottom;
   
      const maxValue = Math.max(...Object.values(levelCounts));
      if (maxValue > 5) {
        height = (maxValue * 100) - margin.top - margin.bottom;
        if (height < 500) {
          height = 500;
        }
      }


      // Remove any previous SVG.
      // d3.select(tree.value).select('svg').remove();
      svg = d3
        .select(tree.value).select("svg")
        .attr("width", width + margin.right + margin.left)
        .attr("height", height + margin.top + margin.bottom)
        .style("background-color", "rgb(241 239 239)")
        .style("border-radius", "12px")

         // If no dataset is selected, do nothing.
        if (selectedDatasetIds.size === 0) {
            d3.select(".actionButtons").style("visibility", "hidden")
            const grp = d3.select("svg").select("g");
            // remove all children of that <g>
            grp.selectAll("*").remove();
            return;
        } else {
            d3.select(".actionButtons").style("visibility", "visible")
        }

      // Append inner container group with initial transform.
      container = svg
        .select('g')
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      // root.x0 = height / 2;
      // root.y0 = 0;
      // Set up zoom behavior (active only when Shift key is pressed).
      const zoomBehavior = d3.zoom()
        .scaleExtent([0.5, 5])
        // .filter(event => event.shiftKey)
        .on('zoom', (event) => {
            container.attr('transform', event.transform);
            savedTransform = event.transform;
        });
       
        if(savedTransform.x==0 && savedTransform.y==0 && savedTransform.k==1){
            svg.call(zoomBehavior)
            .call(zoomBehavior.transform, d3.zoomIdentity.translate(transalteFrom_left, height / 2));
        }else{
            savedTransform.y = savedTransform.y + 55 * clickedNumber*savedTransform.k;
            svg.call(zoomBehavior)
            .call(zoomBehavior.transform,savedTransform);
        }

      // Append a foreignObject to contain styled buttons
      const buttonContainer = d3.select(".actionButtons");
      buttonContainer.style("left", () => isLeftDrawerOpen ? "27vw" : "5vw");
      buttonContainer.selectAll("button").remove();
  

      // Function to create a styled button
      const createButton = (text, callback) => {
        buttonContainer.append("button")
          .text(text)
          .style("padding", "4px 6px")
          .style("border", "none")

          .style("border-radius", "5px")
          .style("background", "#4CAF50")  // Green color
          .style("color", "white")
          .style("font-size", "12px")
          .style("cursor", "pointer")
          .style("transition", "background 0.3s")
          .on("mouseover", function () { d3.select(this).style("background", "#45a049"); })  // Darker on hover
          .on("mouseout", function () { d3.select(this).style("background", "#4CAF50"); })
          .on("click", callback);
      };

      // Add buttons
      createButton("Zoom In", () => svg.transition().call(zoomBehavior.scaleBy, 1.2));
      createButton("Zoom Out", () => svg.transition().call(zoomBehavior.scaleBy, 0.8));
      createButton("Reset Zoom", () => svg.transition().call(zoomBehavior.transform, d3.zoomIdentity.translate(transalteFrom_left, height / 2)));
      createButton("Toggle Link Style", () => toggleLinkStyle());
      processDatasetNodes(root);
      update(root);
    }

    document.body.addEventListener('click', (event) => {
      if (event.target.closest('.mm-button--button.mm-button--light.mm-button--primary.mm-button--medium.mm-button--with-icon.mm-button--only-icon')) {
        setTimeout(() => {
          drawTree();
        }, 50);
      }
    });

    function addDatasetActionList() {
      const datasetButtonContainer = d3.select(".datasetList");
      datasetButtonContainer.selectAll(".dataset-item").remove();

      const datasetDivs = datasetButtonContainer.selectAll("div.dataset-item")
        .data(graphData.datasets, d => d.id)
        .enter()
        .append("div")
        .attr("class", "dataset-item");


      datasetDivs.append("span")
        .attr("class", "dataset-name")
        .style("width","200px")
        .text(d => "(1)" + d.name);
        datasetDivs.append("span")
            .attr("class", "plus-button")
            .attr("dy", "0.25em")
            .text("+")
            .on("click", function (_, d) {
                if (d3.select(this).text() == "+") {
                    selectedDatasetIds.add(d.id);
                    // Update the plus button
                    d3.select(this).text("-");

                    // Apply green background to the clicked dataset's div
                    d3.select(this.parentNode).style("background-color", "lightgreen").style("border-radius", "5px");
                } else {
                    selectedDatasetIds.delete(d.id);
                    d3.select(this).text("+");
                    // Apply green background to the clicked dataset's div
                    d3.select(this.parentNode).style("background-color", null).style("border-radius", null);
                }

                function isSelectedDataset(node) {
                    // If the node is a dataset, check if its id is in the set.
                    if (node.type === "dataset") {
                        return selectedDatasetIds.has(node.id);
                    }
                    // Otherwise, if the node has children, check if any child (recursively) is a selected dataset.
                    if (node.children) {
                        return node.children.some(child => isSelectedDataset(child));
                    }
                    return false;
                }
                treeData.children = JSON.parse(JSON.stringify(actualTreeData.children));
                if (treeData.children) {
                    let filtered = treeData.children.filter(child => isSelectedDataset(child));
                    treeData.children = filtered;
                }


                drawTree();
                // update(d);
            });
    }

    function kFormatter(num) {
      if(!num){
        num=0;
      }
      if (num >= 1e6) return (num / 1e6).toFixed(1) + "M"; // Millions
      if (num >= 1e3) return (num / 1e3).toFixed(1) + "K"; // Thousands
      return num.toString();
    }
    
    function processDatasetNodes(node) {
  if (node.data.type === "dataset") {
    // Process outbound connections: store them in _outbounds
    if (node.data.properties && node.data.properties.outbound_connections) {
      node._outbounds = node.data.properties.outbound_connections.map(conn => ({
        data: conn,
        children: [] // initialize as empty; can be populated later on toggle if needed
      }));
      // If there are no existing children, set children to _outbounds by default.
      if (!node.children || node.children.length === 0) {
        node.children = node._outbounds;
      }
    }

    // Process inbound connections: store them in _inbounds
    if (node.data.properties && node.data.properties.inbound_connections) {
      node._inbounds = node.data.properties.inbound_connections.map(conn => ({
        data: conn,
        children: [] // initialize as empty; can be used later to reassign parent-child relationship
      }));
    }

    // Existing collapse logic for dataset nodes that have children (dataviews)
    if (node.children) {
      if (!node._expandedChildren) {
        node._expandedChildren = node.children.slice();
      }
      let collapsed = [];
      node.children.forEach(view => {
        if (view.data.type === "dataview" && view.children) {
          view.children.forEach(dest => {
            collapsed.push(dest);
          });
          node._collapsedChildren = collapsed;
          node._isCollapsed = node._collapsedChildren.length > 0;
          node.children = node._isCollapsed ? node._collapsedChildren : node._expandedChildren;
        } else if (view.data.type === "dataview" && view.children === undefined) {
          // Mark the node as collapsed.
          node._isCollapsed = true;
          // Store the one view in _children for later restoration.
          if (node.children) {
            view._children = node.children.slice();
          }
          // In collapsed state, clear the visible children.
          if (node.children && node.children[0].data.customType !== "DB") {
            node.children = null;
          }
        }
      });
    }
  }

  // Process children recursively
  if (node.children) {
    node.children.forEach(processDatasetNodes);
  }
  if (node._children) {
    node._children.forEach(processDatasetNodes);
  }
}



    // --- Toggle Function for Dataset Nodes ---
    function toggleDataset(d) {
      if (d.data.type === "dataset") {
        if (d._isCollapsed) {
          // Expand: restore original structure.
          d._expandedChildren.forEach(view => {
            if (view.children) {
              view.children.forEach(dest => {
                dest.parent = view;
              });
              d.children = d._expandedChildren;
            }
            else {
              if(d._children){
                d.children = d._children.slice();
              }else if(d.children){
                d.children=d.children.slice();
                // In collapsed state, clear the visible children.
              }else{
                d.children= d._expandedChildren.slice();
              }
              d._children = null;
            }
          });

          d._isCollapsed = false;
        } else {
          // Collapse: re-parent destination nodes to dataset.
          let collapsed = [];
          d._expandedChildren.forEach(view => {
            if (view.children && view.children.length > 0) {
              // If the view has children, add those whose id starts with "dest_" or "dataset_".
              view.children.forEach(child => {
                  collapsed.push(child);
              });
              // Reassign each candidate's parent pointer to the current dataset.
              collapsed.forEach(child => child.parent = d);
              if (collapsed.length > 0) {
                d._collapsedChildren = collapsed;
                d.children = d._collapsedChildren;
                d._isCollapsed = true;
              } else {
                // If no candidates found, leave the node expanded.
                d.children = d._expandedChildren;
                d._isCollapsed = false;
              }
            } else if (view.children == undefined) {
              // For views with no children (like in dataset_def and dataset_ghi), add the view itself.
              // Mark the node as collapsed.
              d._isCollapsed = true;
              // Store the one view in _children for later restoration.
              // d._children = d.children;
              // In collapsed state, clear the visible children.
              if(d.children && d.children[0].data.customType != "DB"){
              d.children = null;
            }
            }
          });

        }
      } else {
        if (d.children) {
          d._children = d.children;
          d.children = null;
        } else {
          d.children = d._children;
          d._children = null;
        }
      }
    }


    function truncateText(text, maxWidth, element) {
        let truncated = text;
        let textElement = element.append("tspan").text(text);
        if (textElement.node().getComputedTextLength() <= maxWidth+10) {
          textElement.remove(); // Remove test element
          return text; // Return original text if it fits
        }
        else {
  
        while (textElement.node().getComputedTextLength() > maxWidth && truncated.length > 0) {
          truncated = truncated.slice(0, -1);
          textElement.text(truncated + "...");
        }
  
        textElement.remove(); // Remove test element
        return truncated + "...";
      }
    }

      // --- Update Function to Render the Tree ---
      function update(source) {
          treemap = d3.tree().nodeSize([110, 200])
              .separation((a, b) => {

                  // If siblings, use one spacing; if not, use a larger spacing.
                  // Multiply by a factor that grows with depth.
                  if (a.data.type == "dataview") {
                      return 0.6;
                  }

                  if (a.data && a.data.type == "dataset" && a._isCollapsed == false && b.data && b.data.type == "dataset" && b._isCollapsed == false) {
                      const siblingCountA = a.children?.length
                      const siblingCountB = b.children?.length
                      let constMax = siblingCountA + siblingCountB;
                      constMax = Math.ceil(constMax / 2);
                      return 1 + constMax * 0.5;
                  }
                  if (a.data && a.data.type == "dataset" && a._isCollapsed == false) {
                      const siblingCount = a.children?.length;
                      return 1 + siblingCount * 0.3;
                  }

                  if (b.data && b.data.type == "dataset" && b._isCollapsed == false) {
                      const siblingCount = b.children?.length;
                      return 1 + siblingCount * 0.3;
                  }

                  return (a.parent == b.parent ? 1 : 2) / a.depth;
                  // return (a.data.type =="dataset" && b.data.type == "dataview" ? 0.5 : 1);
                  // return (a.parent === b.parent ? 1 : 2) * (1 + a.depth * 0.5);
              });

          // Recursive helper function to find and update a matching node.


          treeDataLayout = treemap(root);
        //   if (currentClickedId != "") {
        //       // 3) find the same node in the new layout
        //       const newAnchor = treeDataLayout
        //           .descendants()
        //           .find(d => d.data.id === currentClickedId);

        //       if (newAnchor) {
        //           // 4) compute how much it moved
        //           const dx = oldScreenX - newAnchor.x;
        //           const dy = oldScreenY - newAnchor.y;

        //           // 5) shift every node by that delta
        //           treeDataLayout.each(d => {
        //               d.x += dx;
        //               d.y += dy;
        //           });
        //       }
        //   }
          const allNodes = treeDataLayout.descendants();

          const allLinks = treeDataLayout.links();
          const OffsetX = 100;
          const OffsetX1 = 50;
          const OffsetY = 30;
          const OffsetY1 = 20;

          // Filter out the synthetic root from nodes and links.
          const nodes = allNodes.filter(d => d.data.type !== "root");
          const links = allLinks.filter(l => l.source.data.type !== "root");
          const commonDifference = nodes[0].y;
          // const depth_gap = 180;
          // nodes.forEach(d => { d.y = d.depth * depth_gap; });
          // Optionally, preserve fixed positions for nodes that have been dragged:



          // If the synthetic root exists, subtract its x coordinate from every node.
          if (root.data.type !== "root") {
              nodes.forEach(d => { d.y += 180 });
          }
          // If the root node is a dataset (and not a source), add an offset to every node’s depth.
          if (root.data.type === "root") {
              let depthOffset = root.height + 1; // or 3 or any desired maximum depth value
              let divider;
              root.children.forEach(d => {
                  // depthOffset = 2.5;
                  if (d.data.type == "dataset" || d.data.type == "dataview") {

                      d.y = commonDifference * depthOffset;

                      switch (depthOffset) {
                          case 5:
                              divider = 1.25;
                              break;
                          case 6:
                              divider = 1.2;
                              break;
                          case 7:
                              divider = 1.165;
                              break;
                          case 8:
                              divider = 1.14;
                              break;
                          default:
                              divider = 1.34;
                      }
                      if (d.data.children) {
                          let children = d._children || d.children || d._expandedChildren;
                          children.forEach(e => {
                              e.y = e.y + (commonDifference * depthOffset) / divider;

                          })
                          if (d._isCollapsed == false && d._collapsedChildren) {
                              let children = d._collapsedChildren
                              children.forEach(f => {
                                  f.y = f.y + (commonDifference * depthOffset) / divider;
                              })
                          }
                      }
                  }
              });
          }
          const datasetButtonContainer = d3.select(".datasetList");
          const datasetDivs = datasetButtonContainer.selectAll("div.dataset-item");

          const node = container.selectAll("g.node")
              .data(nodes, d => d.id || (d.id = ++i));
          // .data(nodes, d => `${d.data.id || (d.id = ++i)}-${d.children ? d.children.length : 0}`)

          // Enter new nodes.
          const nodeEnter = node.enter().append("g")
              .attr("class", "node")
              .attr("id", d => "dataset_node" + d.data.id)
              .style("visibility", (d) => d.data.type != "dataset" && d.data.type != "dataview" && !clickedDatasetIds.has(d.data.id) ? "hidden" : "visible")
              .attr("transform", () => "translate(" + source.y + "," + source.x + ")");


          // Conditionally append either a rect or image.
          nodeEnter.each(function (d) {
              if (d.data.type === "dataset" || d.data.type === "dataview") {
                  d3.select(this).append("rect")
                      .attr("width", d.data.type === "dataset" ? OffsetX * 2 : OffsetX1 * 2)
                      .attr("height", d.data.type === "dataset" ? OffsetY * 2 : OffsetY1 * 2)
                      .attr("x", d.data.type === "dataset" ? -OffsetX : -OffsetX1)
                      .attr("y", d.data.type === "dataset" ? -OffsetY : -OffsetY1)
                      .style("fill", "#fff");
              } else {
                  d3.select(this)
                      .append("rect")
                      .attr("width", 30)
                      .attr("height", 30)
                      .attr("x", -15)
                      .attr("y", -15)
                      .attr("rx", "5")
                      .style('fill', 'white')
                      .style('stroke', 'rgba(0,51,255,0.1)')
                      .style('stroke-width', 1);

                  d3.select(this).append('image')
                      .attr('href', function (d) {
                          if (d.data.type == "file_upload") {
                              return fileUploadIcon;
                          }
                          else return d.data.properties.icon == 'elephant' ? rootIcon : leafIcon;
                      })
                      .attr('width', 20)
                      .attr('height', 20)
                      .attr('x', -10)
                      .attr('y', -10);
              }

              if (d.data.type === "dataset") {


                  const { sourceEdges, targetEdges, sourceEdgesForeign, targetEdgesForeign } = getDatasetEdges(datasetConnections, d.data.id);
                  const { sourceEdges1, targetEdges1, sourceEdgesForeign1, targetEdgesForeign1 } = getDatasetEdgesForMouseover(datasetConnections, d.data.id);
                  // Highlight connected datasets
                  datasetDivs.filter(data => targetEdges.has(data.id))
                      .style("border", "2px solid green") // Add green border
                      .style("border-radius", "5px")
                      .select(".plus-button")
                      .style("display", "none");
                  datasetDivs.filter(data => targetEdgesForeign.has(data.id))
                      .style("border", "2px solid blue") // Add green border
                      .style("border-radius", "5px")
                      .select(".plus-button")
                      .style("display", "none");
                  datasetDivs.filter(data => sourceEdges.has(data.id))
                      .style("border", "2px solid green") // Add green border
                      .style("border-radius", "5px")
                      .select(".plus-button")
                      .style("display", "none");
                  datasetDivs.filter(data => sourceEdgesForeign.has(data.id))
                      .style("border", "2px solid blue") // Add green border
                      .style("border-radius", "5px")
                      .select(".plus-button")
                      .style("display", "none");


                  if (d.data && d.data.type == "dataset" && !clickedDatasetIds.has("left" + d.data.id) || d.parent && d.parent.data.customType) {

                      d3.select(this).selectAll("g.indicator-group.left").remove();
                      d3.select(this).selectAll("g.indicator-group.leftForeign").remove();
                      const leftIndicator = d3.select(this)
                          .append("g")
                          .attr("class", "indicator-group left")
                          .style("visibility", function () {
                              if (!d.parent?.data.customType && targetEdges.size == 0) {
                                  return "hidden";
                              }
                              else {
                                  return "visible";
                              }
                          })
                          .attr("transform", "translate(-105,0)");

                      leftIndicator.append("circle")
                          .attr("class", "indicator")
                          .attr("r", 8)
                          .style("cursor", "pointer")
                          .style("fill", greenColor)
                          .on("click", () => {

                              if (targetEdges.size >= 1) {
                                  clickedDatasetIds.add("leftMore" + d.data.id)
                                  clickedNumber=targetEdges.size;
                                  selectedDatasetIds = new Set([...selectedDatasetIds, ...targetEdges]);

                                  if (treeData.children) {
                                      let filtered = actualTreeData.children.filter(child => isSelectedDataset(child));
                                      // treeData.children = filtered;
                                      filtered.forEach(newChild => {
                                          const exists = treeData.children.some(existingChild => existingChild.id === newChild.id);
                                          if (!exists) {
                                              treeData.children.push(newChild);
                                          }
                                      });
                                  }
                                  const datasetButtonContainer = d3.select(".datasetList");
                                  const datasetDivs = datasetButtonContainer.selectAll("div.dataset-item");
                                  // Highlight connected datasets
                                  datasetDivs.filter(data => targetEdges.has(data.id))
                                      .style("border", "none") // Add green border
                                      .style("background-color", "lightgreen");
                                  d3.select(this).select("g.indicator-group.right").style("display", "none");
                                  drawTree();
                              } else {
                                  if (d.parent && d3.select("#link" + d?.parent.data.id).style("visibility") == "hidden") {
                                      d3.select(this).select("g.indicator-group.left").select("text").style("visibility", "hidden");
                                      // d3.select(this).select("g.indicator-group.left").select("circle").style("fill","none")
                                      clickedDatasetIds.add(d.parent.data.id);
                                      d3.select("#dataset_node" + d.parent.data.id).style("visibility", "visible");
                                      d3.select("#link-arrow" + d.parent.data.id).style("visibility", "visible");
                                      d3.select("#link-circles" + d.parent.data.id).style("visibility", "visible");
                                      d3.select("#link" + d.parent.data.id).style("visibility", "visible");
                                  } else {
                                      clickedDatasetIds.delete(d.parent.data.id);
                                      d3.select(this).select("g.indicator-group.left").select("text").style("visibility", "visible");
                                      d3.select(this).select("g.indicator-group.left").select("text").text(1);
                                      d3.select("#dataset_node" + d.parent.data.id).style("visibility", "hidden");
                                      d3.select("#link-arrow" + d.parent.data.id).style("visibility", "hidden");
                                      d3.select("#link-circles" + d.parent.data.id).style("visibility", "hidden");
                                      d3.select("#link" + d.parent.data.id).style("visibility", "hidden");
                                  }
                              }
                          });
                      leftIndicator.append("text")
                          .attr("class", "indicator-text")
                          .attr("x", 0)
                          .attr("y", 0)
                          .text(() => clickedDatasetIds.has("left" + d.data.id) ? 1 : targetEdges.size == 0 ? 1 : targetEdges.size);



                      const leftIndicatorForeign = d3.select(this)
                          .append("g")
                          .attr("class", "indicator-group leftForeign")
                          .style("visibility", function () {
                              if (targetEdgesForeign.size == 0) {
                                  return "hidden";
                              }
                              else {
                                  return "visible";
                              }
                          })
                          .attr("transform", "translate(105,20)");
                      leftIndicatorForeign.append("circle")
                          .attr("class", "indicator")
                          .attr("r", 8)
                          .style("cursor", "pointer")
                          .style("fill", blueColor)
                          .on("click", () => {
                            clickedNumber=targetEdgesForeign.size;
                              selectedDatasetIds = new Set([...selectedDatasetIds, ...targetEdgesForeign]);
                              clickedDatasetIds.add("leftForeign" + d.data.id)

                              // treeData.children= JSON.parse(JSON.stringify(actualTreeData.children));
                              if (treeData.children) {
                                  let filtered = actualTreeData.children.filter(child => isSelectedDataset(child));
                                  // treeData.children = filtered;
                                  filtered.forEach(newChild => {
                                      const exists = treeData.children.some(existingChild => existingChild.id === newChild.id);
                                      if (!exists) {
                                          treeData.children.push(newChild);
                                      }
                                  });
                              }

                              // Highlight connected datasets
                              datasetDivs.filter(data => targetEdgesForeign.has(data.id))
                                  .style("border", "none") // Add green border
                                  .style("background-color", "lightblue");



                              // showInboundAsParent = !showInboundAsParent;
                              drawTree();
                          });
                      leftIndicatorForeign.append("text")
                          .attr("class", "indicator-text")
                          .attr("x", 0)
                          .attr("y", 0)
                          .text(targetEdgesForeign.size);
                  }

                  if (sourceEdges1.size > 0) {
                      d3.select(this).append("circle")
                          .attr('class', 'ghostRightIndicator')
                          .attr("r", 3)
                          .attr("fill", "#a3c2937d")
                          .attr("transform", "translate(104,0)")
                          .attr('pointer-events', 'mouseover')
                          .on("mouseover", function (node, e) {
                              d3.select(this)
                                  .transition()
                                  .duration(200)
                                  .attr("r", 8);
                              overCircle(node, e, "rightIndicator");
                          })
                          .on("click", () => {
                              clickedDatasetIds.delete(d.data.id + "right")
                              clickedNumber=-sourceEdges1.size;
                              // selectedDatasetIds.delete([...sourceEdges1]);
                              for (const id of sourceEdges1) {
                                  selectedDatasetIds.delete(id);
                              }

                              if (treeData.children) {
                                  let filtered = actualTreeData.children.filter(child => isSelectedDataset(child));
                                  // treeData.children = filtered;
                                  treeData.children = treeData.children.filter(existingChild =>
                                      filtered.some(newChild => newChild.id === existingChild.id)
                                  );
                              }
                              const datasetButtonContainer = d3.select(".datasetList");
                              const datasetDivs = datasetButtonContainer.selectAll("div.dataset-item");
                              // Highlight connected datasets
                              datasetDivs.filter(data => sourceEdges1.has(data.id))
                                  .style("border", "2px solid green") // Add green border
                                  .style("background-color", null);
                              // d3.select(this).select("g.indicator-group.right").style("display", "none");
                              outCircle();
                              drawTree();
                              // updateTree();
                          })
                          .on("mouseout", function () {
                              d3.select(this)
                                  .transition()
                                  .duration(200)
                                  .attr("r", 3);
                              outCircle();
                          });
                  }
                  if (sourceEdgesForeign1.size > 0) {
                      d3.select(this).append("circle")
                          .attr('class', 'ghostRightIndicatorForeign')
                          .attr("r", 3)
                          .attr("fill", "#3b82f67d")
                          .attr("transform", "translate(104,-20)")
                          .attr('pointer-events', 'mouseover')
                          .on("mouseover", function (node, e) {
                              d3.select(this)
                                  .transition()
                                  .duration(200)
                                  .attr("r", 8);
                              overCircle(node, e, "rightIndicatorForeign");
                          })
                          .on("click", () => {
                              clickedDatasetIds.delete(d.data.id + "rightForeign")
                              clickedNumber=-sourceEdgesForeign1.size;
                              // selectedDatasetIds.delete([...sourceEdges1]);
                              for (const id of sourceEdgesForeign1) {
                                  selectedDatasetIds.delete(id);
                              }
                              if (treeData.children) {
                                  let filtered = actualTreeData.children.filter(child => isSelectedDataset(child));
                                  // treeData.children = filtered;
                                  treeData.children = treeData.children.filter(existingChild =>
                                      filtered.some(newChild => newChild.id === existingChild.id)
                                  );
                                  // filtered.forEach(newChild => {
                                  //     const exists = treeData.children.some(existingChild => existingChild.id === newChild.id);
                                  //     if (!exists) {
                                  //         treeData.children.push(newChild);
                                  //     }
                                  // });
                              }
                              const datasetButtonContainer = d3.select(".datasetList");
                              const datasetDivs = datasetButtonContainer.selectAll("div.dataset-item");
                              // Highlight connected datasets
                              datasetDivs.filter(data => sourceEdgesForeign1.has(data.id))
                                  .style("border", "2px solid blue") // Add green border
                                  .style("background-color", null);
                              // d3.select(this).select("g.indicator-group.right").style("display", "none");
                              outCircle();
                              drawTree();
                              // updateTree();
                          })
                          .on("mouseout", function () {
                              d3.select(this)
                                  .transition()
                                  .duration(200)
                                  .attr("r", 3);
                              outCircle();
                          });
                  }

                  if (targetEdgesForeign1.size > 0) {
                      d3.select(this).append("circle")
                          .attr('class', 'ghostLeftIndicatorForeign')
                          .attr("r", 3)
                          .attr("fill", "#3b82f67d")
                          .attr("transform", "translate(104,20)")
                          .attr('pointer-events', 'mouseover')
                          .on("mouseover", function (node, e) {
                              d3.select(this)
                                  .transition()
                                  .duration(200)
                                  .attr("r", 8);
                              overCircle(node, e, "leftIndicatorForeign");
                          })
                          .on("click", () => {
                              clickedDatasetIds.delete("leftForeign" + d.data.id)
                              clickedNumber=-targetEdgesForeign1.size;
                              // selectedDatasetIds.delete([...sourceEdges1]);
                              for (const id of targetEdgesForeign1) {
                                  selectedDatasetIds.delete(id);
                              }
                              if (treeData.children) {
                                  let filtered = actualTreeData.children.filter(child => isSelectedDataset(child));
                                  // treeData.children = filtered;
                                  treeData.children = treeData.children.filter(existingChild =>
                                      filtered.some(newChild => newChild.id === existingChild.id)
                                  );
                              }
                              const datasetButtonContainer = d3.select(".datasetList");
                              const datasetDivs = datasetButtonContainer.selectAll("div.dataset-item");
                              // Highlight connected datasets
                              datasetDivs.filter(data => targetEdgesForeign1.has(data.id))
                                  .style("border", "2px solid blue") // Add green border
                                  .style("background-color", null);
                              // d3.select(this).select("g.indicator-group.right").style("display", "none");
                              outCircle();
                              drawTree();
                              // updateTree();
                          })
                          .on("mouseout", function () {
                              d3.select(this)
                                  .transition()
                                  .duration(200)
                                  .attr("r", 3);
                              outCircle();
                          });
                  }
                  if (targetEdges1.size > 0) {
                      d3.select(this).append("circle")
                          .attr('class', 'ghostLeftIndicator')
                          .attr("r", 3)
                          .attr("fill", "#a3c2937d")
                          .attr("transform", "translate(-104,0)")
                          .attr('pointer-events', 'mouseover')
                          .on("mouseover", function (node, e) {
                              d3.select(this)
                                  .transition()
                                  .duration(200)
                                  .attr("r", 8);
                              overCircle(node, e, "leftIndicator");
                          })
                          .on("click", () => {
                              clickedDatasetIds.delete("left" + d.data.id)
                              clickedNumber=-targetEdges1.size;
                              // selectedDatasetIds.delete([...sourceEdges1]);
                              for (const id of targetEdges1) {
                                  selectedDatasetIds.delete(id);
                              }
                              if (treeData.children) {
                                  let filtered = actualTreeData.children.filter(child => isSelectedDataset(child));
                                  // treeData.children = filtered;
                                  treeData.children = treeData.children.filter(existingChild =>
                                      filtered.some(newChild => newChild.id === existingChild.id)
                                  );
                              }
                              const datasetButtonContainer = d3.select(".datasetList");
                              const datasetDivs = datasetButtonContainer.selectAll("div.dataset-item");
                              // Highlight connected datasets
                              datasetDivs.filter(data => targetEdges1.has(data.id))
                                  .style("border", "2px solid blue") // Add green border
                                  .style("background-color", null);
                              // d3.select(this).select("g.indicator-group.right").style("display", "none");
                              outCircle();
                              drawTree();
                              // updateTree();
                          })
                          .on("mouseout", function () {
                              d3.select(this)
                                  .transition()
                                  .duration(200)
                                  .attr("r", 3);
                              outCircle();
                          });
                  }



                  if (d.data && d.data.type == "dataset" && sourceEdges.size > 0 && !clickedDatasetIds.has(d.data.id + "right")) {
                      d3.select(this).selectAll("g.indicator-group.right").remove();
                      d3.select(this).selectAll("g.indicator-group.rightForeign").remove();

                      const rightIndicator = d3.select(this)
                          .append("g")
                          .attr("class", "indicator-group right")
                          .attr("transform", "translate(104,0)");

                      rightIndicator.append("circle")
                          .attr("class", "indicator")
                          .style("cursor", "pointer")
                          .style("fill", greenColor)
                          .attr("r", 8)
                          .attr("cy", 0)
                          .on("click", () => {
                            clickedNumber=sourceEdges.size;
                              // 1) get the node’s current screen coordinates
                              //    by applying the inverse of the current zoom transform
                            //   const transform = d3.zoomTransform(svg.node());
                            //    oldScreenX = transform.applyX(e.x);
                            //    oldScreenY = transform.applyY(e.y);
                            //    currentClickedId = d.data.id;
                              clickedDatasetIds.add(d.data.id + "right")
                              selectedDatasetIds = new Set([...selectedDatasetIds, ...sourceEdges]);
                              if (treeData.children) {
                                  let filtered = actualTreeData.children.filter(child => isSelectedDataset(child));
                                  // treeData.children = filtered;
                                  filtered.forEach(newChild => {
                                      const exists = treeData.children.some(existingChild => existingChild.id === newChild.id);
                                      if (!exists) {
                                          treeData.children.push(newChild);
                                      }
                                  });
                              }
                              const datasetButtonContainer = d3.select(".datasetList");
                              const datasetDivs = datasetButtonContainer.selectAll("div.dataset-item");
                              // Highlight connected datasets
                              datasetDivs.filter(data => sourceEdges.has(data.id))
                                  .style("border", "none") // Add green border
                                  .style("background-color", "lightgreen");
                              d3.select(this).select("g.indicator-group.right").style("display", "none");
                              drawTree();
                              // updateTree();
                          });
                      rightIndicator.append("text")
                          .attr("class", "indicator-text")
                          .attr("x", 0)
                          .attr("y", 0)
                          .text(sourceEdges.size);
                  }
                  if (d.data && d.data.type == "dataset" && sourceEdgesForeign.size > 0 && !clickedDatasetIds.has(d.data.id + "rightForeign")) {

                      const rightIndicatorForeign = d3.select(this)
                          .append("g")
                          .attr("class", "indicator-group rightForeign")
                          .attr("transform", "translate(104,-20)");

                      rightIndicatorForeign.append("circle")
                          .attr("class", "indicator")
                          .style("cursor", "pointer")
                          .style("fill", "rgb(47 91 170)")
                          .attr("r", 8)
                          .attr("cy", 0)
                          .on("click", () => {
                            clickedNumber=sourceEdgesForeign.size;
                              clickedDatasetIds.add(d.data.id + "rightForeign")
                              selectedDatasetIds = new Set([...selectedDatasetIds, ...sourceEdgesForeign]);
                              if (treeData.children) {
                                  let filtered = actualTreeData.children.filter(child => isSelectedDataset(child));
                                  // treeData.children = filtered;
                                  filtered.forEach(newChild => {
                                      const exists = treeData.children.some(existingChild => existingChild.id === newChild.id);
                                      if (!exists) {
                                          treeData.children.push(newChild);
                                      }
                                  });
                              }
                              const datasetButtonContainer = d3.select(".datasetList");
                              const datasetDivs = datasetButtonContainer.selectAll("div.dataset-item");
                              // Highlight connected datasets
                              datasetDivs.filter(data => sourceEdgesForeign.has(data.id))
                                  .style("border", "none") // Add green border
                                  .style("background-color", "lightblue");
                              d3.select(this).select("g.indicator-group.right").style("display", "none");
                              drawTree();
                              // updateTree();
                          });
                      rightIndicatorForeign.append("text")
                          .attr("class", "indicator-text")
                          .attr("x", 0)
                          .attr("y", 0)
                          .text(sourceEdgesForeign.size);
                  }
              }
          });
          function isSelectedDataset(node) {
              // If the node is a dataset, check if its id is in the set.
              if (node.type === "dataset") {
                  return selectedDatasetIds.has(node.id);
              }
              // Otherwise, if the node has children, check if any child (recursively) is a selected dataset.
              if (node.children) {
                  return node.children.some(child => isSelectedDataset(child));
              }
              return false;
          }
          nodeEnter.each(function (d) {
              if (d.data.type === "dataset") {
                  d3.select(this).append('image')
                      .attr('href', function () {
                          return expand;
                      })
                      .attr("id", (d) => "image_expand" + d.data.id)
                      .attr('width', 20)
                      .attr('height', 20)
                      .attr('x', 77)
                      .attr('y', -OffsetY + 3)
                      .attr("class", "dataset-expand-image")
                      .on("click", (event, d) => {
                          // Do nothing if node type is "dataview"
                          if (d._isCollapsed == true) {
                              d3.select("#image_expand" + d.data.id).style("visibility", "hidden");
                          }
                          if (d.data.type === "dataview" || d._isCollapsed == false || d.data.id.startsWith("src_")) return;
                          if (isDrawerOpen.value == false) {
                              setTimeout(() => {
                                  closeOverlay();
                              });
                          }
                          d3.select("#dataset_node" + d.data.id).select("g.indicator-group.left").attr("transform", "translate(-55,0)");
                          d3.select("#dataset_node" + d.data.id).select("g.indicator-group.leftForeign").attr("transform", "translate(264,+20)");
                          d3.select("#dataset_node" + d.data.id).select("g.indicator-group.right").attr("transform", "translate(264,0)");
                          d3.select("#dataset_node" + d.data.id).select("g.indicator-group.rightForeign").attr("transform", "translate(264,-20)");
                          d3.select("#dataset_node" + d.data.id).select(".ghostRightIndicatorForeign").attr("transform", "translate(264,-20)");
                          d3.select("#dataset_node" + d.data.id).select(".ghostLeftIndicatorForeign").attr("transform", "translate(264,20)");
                          
                          
                          d3.select("#dataset_node" + d.data.id).select(".ghostRightIndicator").attr("transform", "translate(264,0)");
                          
                          d3.select("#dataset_node" + d.data.id).select("tspan:nth-child(1)").each(function (v) {
                              let fullText = d.data.type === "dataset" && v._isCollapsed === true
                                  ? `${d.data.properties.batches.length || 0} Batch`
                                  : d.data.name;
                              // return truncateText(text, 200, d3.select(this));
                              let truncatedText = truncateText(fullText, maxWidthForDataView, d3.select(this));

                              d3.select(this).text(truncatedText); // Set the truncated text

                              d3.select(this)
                                  .append('title') // Append the title element
                                  .text(fullText);
                          })
                          d3.select("#dataset_node" + d.data.id).select("tspan:nth-child(2)").each(function (v) {
                              let fullText = d.data.type === "dataset" && v._isCollapsed === true
                                  ? `${kFormatter(d.data.properties.batches[0].row_count)} rows`
                                  : d.data.name;
                              // return truncateText(text, 200, d3.select(this));
                              let truncatedText = truncateText(fullText, maxWidthForDataView, d3.select(this));
                              d3.select(this).text(truncatedText); // Set the truncated text

                              d3.select(this)
                                  .append('title') // Append the title element
                                  .text(fullText);
                          })
                          toggleDataset(d);
                          update(d);
                      }).raise();
              }
          });

          const textSel = nodeEnter.append("text")
              //    .attr("dy", ".35em")
              .attr("x", d => (d.data.type === "dataset" || d.data.type === "dataview") ? 0 : 13)
              .attr("text-anchor", "middle")
              .style("visibility", d => (d.data.type === "dataset" || d.data.type === "dataview") ? "visible" : "hidden");
          //    .text(d => d.data.name);

          textSel
              .append('tspan')
              .attr('x', 0)
              .attr('dy', '-.25em')
              .each(function (d) {
                  let fullText = d.data.type === "dataset" && d._isCollapsed == false ? `${d.data.properties.batches.length || 0} Batch` : d.data.name;
                  // return truncateText(text, 200, d3.select(this));
                  let truncatedText;
                  if (d.data.type === "dataview") {
                      truncatedText = truncateText(fullText, maxWidthForDataView, d3.select(this));
                  }
                  if (d.data.type === "dataset") {
                      truncatedText = truncateText(fullText, maxWidthForDataSet, d3.select(this));
                  }
                  d3.select(this).text(truncatedText); // Set the truncated text

                  d3.select(this)
                      .append('title') // Append the title element
                      .text(fullText);
              });
          textSel
              .append('tspan')
              .attr('x', 0)
              .attr('dy', '1.5em')
              .each(function (d) {
                  if (d.data.type == 'dataset') {
                      let numberOfviews = d._expandedChildren.length || d._children.length;
                      const reducer = (acc, item) => acc + (item.data.properties.no_of_tasks || 0);
                      const total = d._expandedChildren.reduce(reducer, 0);
                      let fullText = `${d.data.properties.batches.length || 0} Batch (${kFormatter(d.data.properties.batches[0].row_count)} rows), ${numberOfviews} Views(${kFormatter(total)} tasks)`;
                      // return truncateText(text, 200, d3.select(this));
                      let truncatedText = truncateText(fullText, maxWidthForDataSet, d3.select(this));

                      d3.select(this).text(truncatedText); // Set the truncated text

                      d3.select(this)
                          .append('title') // Append the title element
                          .text(fullText);
                  }
                  if (d.data.type == 'dataview') {
                      let fullText = `${kFormatter(d.data.properties.no_of_tasks)} tasks`;
                      // return truncateText(text, 200, d3.select(this));
                      let truncatedText = truncateText(fullText, maxWidthForDataView, d3.select(this));

                      d3.select(this).text(truncatedText); // Set the truncated text

                      d3.select(this)
                          .append('title') // Append the title element
                          .text(fullText);
                  }
              });



          const nodeUpdate = nodeEnter.merge(node);
          nodeUpdate
              .attr("transform", d => "translate(" + d.y + "," + d.x + ")");

          // Update shapes based on type.
          nodeUpdate.selectAll("circle")
              .filter(d => !(d.data.type === "dataset" || d.data.type === "dataview"))
              .attr("r", 10)
              .style("fill", "#fff");

          nodeUpdate.selectAll("rect")
              .filter(d => (d.data.type === "dataset" || d.data.type === "dataview"))
              .attr("width", d => d.data.type === "dataset" && d._isCollapsed ? OffsetX * 2 : OffsetX1 * 2)
              .attr("height", d => d.data.type === "dataset" && d._isCollapsed ? OffsetY * 2 : OffsetY1 * 2)
              .attr("x", d => d.data.type === "dataset" && d._isCollapsed ? -OffsetX : -OffsetX1)
              .attr("y", d => d.data.type === "dataset" && d._isCollapsed ? -OffsetY : -OffsetY1)
              .attr("rx", "10")
              .style("fill", "#fff");

          const nodeExit = node.exit()
              .attr("transform", () => "translate(" + source.y + "," + source.x + ")")
              .remove();

          nodeExit.select("circle").attr("r", 1e-6);
          nodeExit.select("rect").attr("width", 1e-6).attr("height", 1e-6);
          nodeExit.select("text").style("fill-opacity", 1e-6);
          // const mergedLinks = graphData.edges.map((d, i) => ({
          //   ...links[i],
          //   ...d
          // }));
          // Helper: node is a rectangle (intermediate) if not root and has children/_children.
          const link = container.selectAll("path.link")
              .data(links, d => d.source.data.id + "-" + d.target.data.id);

          const linkEnter = link.enter().insert("path", "g")
              .attr("class", "link")
              .attr("id", (d) => "link" + d.source.data.id)
              .style("stroke", function (d) {
                  let e = graphData.edges.filter(edge => edge.target == d.target.data.id && edge.source == d.source.data.id)
                  if (e) {
                      return e[0].properties.type == "primary" ? greenColor : blueColor;
                  }
              })//d.data.properties.type=="primary"?"#b0d799":
              .style("fill", "none")
              .style("visibility", (d) => d.source.data.type != "dataset" && d.source.data.type != "dataview" ? "hidden" : "visible")
              .attr("d", () => {
                  const o = { x: source.x, y: source.y };
                  return diagonal(o, o);
              })
              .style("cursor", "pointer")
              .on("click", (event, d) => {
                  const edgeData = graphData.edges.find(edge =>
                      edge.target == d.target.data.id && edge.source == d.source.data.id
                  );
                  openOverlay(edgeData);
              });


          const linkUpdate = linkEnter.merge(link);
          linkUpdate
              .attr("d", d => diagonal(d.source, d.target));

          link.exit()
              .attr("d", () => {
                  const o = { x: source.x, y: source.y };
                  return diagonal(o, o);
              })
              .remove();
          const linkCircles = container.selectAll("g.link-circles")
              .data(links, d => d.source.data.id + "-" + d.target.data.id);

          // ENTER: Create groups for each link
          const linkCirclesEnter = linkCircles.enter().append("g")
              .attr("class", "link-circles")
              .attr("id", (d) => "link-circles" + d.source.data.id)
              .style("visibility", (d) => d.source.data.type != "dataset" && d.source.data.type != "dataview" ? "hidden" : "visible")


          // Append circles at source and target positions
          linkCirclesEnter.each(function () {
              const group = d3.select(this);

              // Circle at the source (where link attaches to the source node)
              group.append("circle")
                  .attr("class", "source-circle")
                  .attr("r", 3)
                  .attr("fill", function (d) {
                      let e = graphData.edges.filter(edge => edge.target == d.target.data.id && edge.source == d.source.data.id)
                      if (e) {
                          return e[0].properties.type == "primary" ? greenColor : blueColor;
                      }
                  })
                  .style("cursor", "pointer")
                  .on("click", (event, d) => {
                      const edgeData = graphData.edges.find(edge =>
                          edge.target == d.target.data.id && edge.source == d.source.data.id
                      );
                      openOverlay(edgeData);
                  });

              // Circle at the target (where link attaches to the target node)
              group.append("circle")
                  .attr("class", "target-circle")
                  .attr("r", 3)
                  .attr("fill", function (d) {
                      let e = graphData.edges.filter(edge => edge.target == d.target.data.id && edge.source == d.source.data.id)
                      if (e) {
                          return e[0].properties.type == "primary" ? greenColor : blueColor;
                      }
                  })
                  .style("cursor", "pointer")
                  .on("click", (event, d) => {
                      const edgeData = graphData.edges.find(edge =>
                          edge.target == d.target.data.id && edge.source == d.source.data.id
                      );
                      openOverlay(edgeData);
                  });
          });

          // UPDATE: Position the circles at the start and end of each link
          const linkCirclesUpdate = linkCirclesEnter.merge(linkCircles);

          linkCirclesUpdate
              .attr("transform", `translate(0, 0)`); // Keep group at (0,0) to prevent offsets

          linkCirclesUpdate
              .each(function (d) {
                  const group = d3.select(this);
                  if (d.source.data.type !== "datasource" && d.target.data.type !== "dataview") {
                      group.select(".source-circle")
                          .attr("cx", getCirclePosition(d.source, d.target).source.y)
                          .attr("cy", getCirclePosition(d.source, d.target).source.x)
                          .style("display", "block"); // Ensure it's visible

                      group.select(".target-circle")
                          .attr("cx", getCirclePosition(d.source, d.target).target.y)
                          .attr("cy", getCirclePosition(d.source, d.target).target.x)
                          .style("display", "block");
                  } else {
                      linkCirclesEnter.remove();
                  }
              }).raise();

          // EXIT: Remove old circles
          linkCircles.exit().remove();
          container.selectAll("g.indicator-group").raise();
          // Draw arrow markers.
          // ARROW MARKERS
          const arrowSel = container.selectAll(".link-arrow")
              .data(links, d => d.source.data.id + "-" + d.target.data.id);

          // ENTER: Create new arrow markers
          const arrowEnter = arrowSel.enter()
              .append("g")
              .attr("class", "link-arrow")
              .attr("id", (d) => "link-arrow" + d.source.data.id)
              .style("visibility", (d) => d.source.data.type != "dataset" && d.source.data.type != "dataview" ? "hidden" : "visible");



          // UPDATE: Merge new and existing elements
          const arrowUpdate = arrowEnter.merge(arrowSel);

          arrowUpdate.each(function (d) {
              const arrow = d3.select(this);
              arrow.attr("transform",
                  d => gettranslate(d.source, d.target));
              arrow.selectAll("circle").data([d]).enter()
                  .append("circle")
                  .attr("r", 10)
                  .attr("fill", "white")
                  .attr("stroke", function (d) {
                      let e = graphData.edges.filter(edge => edge.target == d.target.data.id && edge.source == d.source.data.id)
                      if (e) {
                          return e[0].properties.type == "primary" ? greenColor : blueColor;
                      }
                  })
                  .attr("stroke-width", 1.5);

              arrow.selectAll("text").data([d]).enter()
                  .append("text")
                  .attr("text-anchor", "middle")
                  .attr("dy", "0.25em")
                  .attr("font-size", "12px")
                  .style("stroke", function (d) {
                      let e = graphData.edges.filter(edge => edge.target == d.target.data.id && edge.source == d.source.data.id)
                      if (e) {
                          return e[0].properties.type == "primary" ? greenColor : blueColor;
                      }
                  })
                  .attr("stroke-width", "1px")
                  .attr("fill", "none")
                  .text("→")
                  .style("cursor", "pointer")
                  .on("click", (event, d) => {
                      const edgeData = graphData.edges.find(edge =>
                          edge.target == d.target.data.id && edge.source == d.source.data.id
                      );
                      openOverlay(edgeData);
                  });
          });

          // EXIT: Remove old arrows
          arrowSel.exit().remove();
          // filter the secondary data before Pass


          // 1. Build a flat array of allowed IDs based on selected datasets and their inbounds/outbounds.
          let flatSelectedIds = [];

          selectedDatasetIds.forEach(datasetId => {
              const node = nodeById[datasetId];
              if (node) {
                  // Add the dataset node itself.
                  flatSelectedIds.push(node.data.id);

                  // If the node has inbound connections, add their ids.
                  if (node._inbounds && Array.isArray(node._inbounds)) {
                      node._inbounds.forEach(inbound => {
                          if (inbound.data.id) {
                              flatSelectedIds.push(inbound.data.id);
                          }
                      });
                  }

                  // If the node has outbound connections, add their ids.
                  if (node._outbounds && Array.isArray(node._outbounds)) {
                      node._outbounds.forEach(outbound => {
                          if (outbound.data.id) {
                              flatSelectedIds.push(outbound.data.id);
                          }
                      });
                  }
              }
          });

          // Remove duplicate ids.
          flatSelectedIds = [...new Set(flatSelectedIds)];

          // 2. Filter the secondaryEdges array so that both the source and target
          //    are included in the flatSelectedIds.
          const dataForForeignLink1 = graphData.secondaryEdges.filter(e => {
              return flatSelectedIds.includes(e.source) && flatSelectedIds.includes(e.target);
          });


          // first filter data On the base selectedDatasetIds
          const dataForForeignLink2 = dataForForeignLink1.filter(e => {
              let sourceNode = nodeById[e.source];
              let targetNode = nodeById[e.target];
              if (sourceNode && targetNode && sourceNode.parent && targetNode.parent) {
                  if ((selectedDatasetIds.has(sourceNode.data.id) || selectedDatasetIds.has(sourceNode.parent.data.id)) && (selectedDatasetIds.has(targetNode.data.id) || selectedDatasetIds.has(targetNode.parent.data.id))) {
                      return true;
                  }
              }
          })

          const dataForForeignLink = dataForForeignLink2.filter(e => {
              let sourceNode = nodeById[e.source];
              let targetNode = nodeById[e.target];
              if (sourceNode && targetNode && sourceNode.parent && targetNode.parent) {
                  if (sourceNode.parent.data.id != targetNode.parent.data.id) {
                      return true;
                  }
                  else if (sourceNode.parent.data.id == targetNode.parent.data.id && sourceNode.parent._isCollapsed == false) {
                      return true;
                  }
              }

          })


          //   if (dataForForeignLink && dataForForeignLink.length > 0) {
          const crossLinks = container.selectAll("path.cross-link")
              .data(dataForForeignLink, d => d.source + "-" + d.target);

          crossLinks.enter()
              .append("path")
              .attr("class", "cross-link")
              .attr("stroke", function (d) {
                  if (d.properties) {
                      return d.properties.type == "secondary" ? blueColor : greenColor;
                  } else {
                      return blueColor;
                  }
              })
              .attr("stroke-width", 1)
              .attr("fill", "none")
              .merge(crossLinks)
              .attr("d", d => {
                  // Find source and target nodes from our lookup.
                  let sourceNode = nodeById[d.source];
                  let targetNode = nodeById[d.target];
                  if (!sourceNode || !targetNode) return null;

                  // if(sourceNode.y==undefined || sourceNode.parent._isCollapsed){
                  //   sourceNode=sourceNode.parent
                  // }
                  if (targetNode.y == undefined || targetNode.parent._isCollapsed) {
                      targetNode = targetNode.parent
                  }

                  let isSecondary = false;
                  if (d.properties && d.properties.type === "secondary") {
                      isSecondary = true;
                  }
                  else {
                      isSecondary = false;
                  }
                  return diagonal(sourceNode, targetNode, isSecondary)
              }).style("cursor", "pointer")
              .on("click", (event, d) => {
                  openOverlay(d);
              }).lower();

          crossLinks.exit().remove();


          // SELECT: Existing cross-link circles
          const crossLinkCircles = container.selectAll("g.cross-link-circles")
              .data(dataForForeignLink, d => d.source + "-" + d.target);

          // ENTER: Create groups for each cross-link
          const crossLinkCirclesEnter = crossLinkCircles.enter().append("g")
              .attr("class", "cross-link-circles");

          // Append circles at source and target positions
          crossLinkCirclesEnter.each(function () {
              const group = d3.select(this);

              // Circle at the source (where link attaches to the source node)
              group.append("circle")
                  .attr("class", "source-circle")
                  .attr("r", 3)
                  .attr("fill", function (d) {
                      if (d.properties) {
                          return d.properties.type == "secondary" ? "rgb(47 91 170)" : greenColor;
                      } else {
                          return blueColor;
                      }
                  }) // Set different color for cross-links if needed
                  .style("cursor", "pointer")
                  .on("click", (event, d) => {
                      openOverlay(d);
                  });

              // Circle at the target (where link attaches to the target node)
              group.append("circle")
                  .attr("class", "target-circle")
                  .attr("r", 3)
                  .attr("fill", function (d) {
                      if (d.properties) {
                          return d.properties.type == "secondary" ? blueColor : greenColor;
                      } else {
                          return blueColor;
                      }
                  }) // Set different color for cross-links if needed
                  .style("cursor", "pointer")
                  .on("click", (event, d) => {
                      openOverlay(d);
                  });
          });

          // UPDATE: Position the circles at the start and end of each cross-link
          const crossLinkCirclesUpdate = crossLinkCirclesEnter.merge(crossLinkCircles);

          crossLinkCirclesUpdate
              .attr("transform", `translate(0, 0)`); // Keep group at (0,0) to prevent offsets



          // Move circles to the correct positions using getCirclePosition()
          crossLinkCirclesUpdate.select(".source-circle")
              .attr("cx", d => {
                  let isSecondary = d.properties && d.properties.type == "secondary";
                  // Get the circle position
                  let position = getCirclePosition(nodeById[d.source], nodeById[d.target], isSecondary);
                  return position.source.y;  // Use the `y` value for the horizontal position (cx)
              })
              .attr("cy", d => {
                  let isSecondary = d.properties && d.properties.type == "secondary";
                  // Get the circle position
                  let position = getCirclePosition(nodeById[d.source], nodeById[d.target], isSecondary);
                  return position.source.x;  // Use the `x` value for the vertical position (cy)
              });

          crossLinkCirclesUpdate.select(".target-circle")
              .attr("cx", d => {
                  let isSecondary = d.properties && d.properties.type == "secondary";
                  // Get the circle position
                  let position = getCirclePosition(nodeById[d.source], nodeById[d.target], isSecondary);
                  return position.target.y;  // Use the `y` value for the horizontal position (cx)
              })
              .attr("cy", d => {
                  let isSecondary = d.properties && d.properties.type == "secondary";
                  // Get the circle position
                  let position = getCirclePosition(nodeById[d.source], nodeById[d.target], isSecondary);
                  return position.target.x;  // Use the `x` value for the vertical position (cy)
              });

          // EXIT: Remove old circles
          crossLinkCircles.exit().remove();

          // Draw arrow markers.
          // ARROW MARKERS
          const crossArrowSel = container.selectAll(".cross-link-arrow")
              .data(dataForForeignLink, d => d.source + "-" + d.target);

          // ENTER: Create new arrow markers
          const crossArrowEnter = crossArrowSel.enter()
              .append("g")
              .attr("class", "cross-link-arrow")



          // UPDATE: Merge new and existing elements
          const crossArrowUpdate = crossArrowEnter.merge(crossArrowSel);

          crossArrowUpdate.each(function (d) {
              const arrow = d3.select(this);
              arrow.attr("transform",
                  d => {
                      let sourceNode = nodeById[d.source];
                      let targetNode = nodeById[d.target];
                      if (!sourceNode || !targetNode) return null;
                      // if (sourceNode.y == undefined || sourceNode.parent._isCollapsed) {
                      //   sourceNode = sourceNode.parent
                      // }
                      if (targetNode.y == undefined || targetNode.parent._isCollapsed) {
                          targetNode = targetNode.parent
                      }

                      let isSecondary = false;
                      if (d.properties && d.properties.type == "secondary") {
                          isSecondary = true;
                      }
                      else {
                          isSecondary = false;
                      }
                      return gettranslate(sourceNode, targetNode, isSecondary)
                      //       const midX = (sourceNode.x + targetNode.x) / 2;
                      // const midY = (targetNode.y + sourceNode.y) / 2;
                      // const angle = Math.atan2(targetNode.x - sourceNode.x, targetNode.y - sourceNode.y) * 180 / Math.PI;
                      // return `translate(${midY},${midX}) rotate(${angle})`;
                  });
              arrow.selectAll("circle").data([d]).enter()
                  .append("circle")
                  .attr("r", 10)
                  .attr("fill", "white")
                  .attr("stroke", function (d) {
                      if (d.properties) {
                          return d.properties.type == "secondary" ? blueColor : greenColor;
                      } else {
                          return blueColor;
                      }
                  })
                  .attr("stroke-width", 1.5);

              arrow.selectAll("text").data([d]).enter()
                  .append("text")
                  .attr("text-anchor", "middle")
                  .attr("dy", "0.25em")
                  .attr("font-size", "12px")
                  .style("stroke", function (d) {
                      if (d.properties) {
                          return d.properties.type == "secondary" ? blueColor : greenColor;
                      } else {
                          return blueColor;
                      }
                  })
                  .attr("stroke-width", "1px")
                  .attr("fill", "none")
                  .text("→")
                  .style("cursor", "pointer")
                  .on("click", (event, d) => {
                      openOverlay(d);
                  });
          });

          // EXIT: Remove old arrows
          crossArrowSel.exit().remove();
          //   }


          // ---- Bounding Box for Expanded Dataset Nodes ----
          // For each expanded dataset (not collapsed), draw a dashed rect around it and its dataview children.
          // Create groups for each expanded dataset (not collapsed)
          const expandedDatasets = nodes.filter(d => d.data.type === "dataset" && !d._isCollapsed);

          const datasetGroups = container.selectAll("g.dataset-bound-group")
              .data(expandedDatasets, d => d.id);

          // Enter selection: create a group containing a rect and a text element.
          const datasetGroupsEnter = datasetGroups.enter()
              .append("g")
              .attr("id", (d) => d.data.id)
              .attr("class", "dataset-bound-group");

          datasetGroupsEnter.append("rect")
              .attr("class", "dataset-bound")
              .attr("rx", 25)
              .attr("ry", 25)
              .style("fill", "white")
              .style("stroke", "rgba(0,51,255,0.4)")
              .style("stroke-width", 1);

          datasetGroupsEnter.append("text")
              .attr("class", "dataset-bound-text")
              .attr("text-anchor", "middle")
              .attr("dominant-baseline", "middle")
              // .text(d => d.data.name);
              .each(function (d) {
                  let fullText = d.data.name;
                  let truncatedText = truncateText(fullText, maxWidthForExpandedNode, d3.select(this));
                  d3.select(this).text(truncatedText);
                  d3.select(this)
                      .append('title') // Append the title element
                      .text(fullText);
              });

          datasetGroupsEnter.append('image')
              .attr('href', function () {
                  return collapse;
              })
              .attr("id", (d) => "image_collapsed" + d.data.id)
              .attr('width', 20)
              .attr('height', 20)
              .attr("class", "dataset-bound-image")
              .on("click", (event, d) => {
                  // Do nothing if node type is "dataview"
                  if (d.data.type === "dataview" || d.data.id.startsWith("src_")) return;
                  d3.select("#image_expand" + d.data.id).style("visibility", "visible");
                  const nodeSelection = d3.select("#dataset_node" + d.data.id);

                  nodeSelection.select("g.indicator-group.right").attr("transform", "translate(104,0)");
                  nodeSelection.select("g.indicator-group.rightForeign").attr("transform", "translate(104,-20)");
                  nodeSelection.select(".ghostRightIndicatorForeign").attr("transform", "translate(104,-20)");
                  nodeSelection.select(".ghostLeftIndicatorForeign").attr("transform", "translate(104,20)");
                  nodeSelection.select("g.indicator-group.left").attr("transform", "translate(-105,0)");
                  nodeSelection.select("g.indicator-group.leftForeign").attr("transform", "translate(104,20)");
                  nodeSelection.select(".ghostRightIndicator").attr("transform", "translate(104,0)");
                  nodeSelection.select("tspan:nth-child(1)").each(function (v) {
                      // return d.data.type === "dataset" && v._isCollapsed === true
                      //   ? d.data.properties.batches[0].name|| "1 Batch"
                      //   : d.data.name;
                      let fullText = d.data.type === "dataset" && v._isCollapsed === true
                          ? `${d.data.properties.batches.length} Batch` || "1 Batch"
                          : d.data.name;
                      let truncatedText = truncateText(fullText, maxWidthForDataSet, d3.select(this));

                      d3.select(this).text(truncatedText); // Set the truncated text

                      d3.select(this)
                          .append('title') // Append the title element
                          .text(fullText);
                  })
                  nodeSelection.select("tspan:nth-child(2)").each(function (v) {
                      let numberOfviews = v._expandedChildren.length || v._children.length;
                      const reducer = (acc, item) => acc + (item.data.properties.no_of_tasks || 0);
                      const total = v._expandedChildren.reduce(reducer, 0);
                      // return d.data.type === "dataset" && d._isCollapsed === false
                      //   ? `${v.data.properties.batches[0].name|| "1 Batch"} (${v.data.properties.batches[0].row_count}), ${numberOfviews} views(${total} tasks)`
                      //   : d.data.name;
                      let fullText = d.data.type === "dataset" && d._isCollapsed === false
                          ? `${v.data.properties.batches.length || 0} Batch (${kFormatter(v.data.properties.batches[0].row_count)} rows), ${numberOfviews} views(${kFormatter(total)} tasks)`
                          : d.data.name;
                      let truncatedText = truncateText(fullText, maxWidthForDataSet, d3.select(this));

                      d3.select(this).text(truncatedText); // Set the truncated text

                      d3.select(this)
                          .append('title') // Append the title element
                          .text(fullText);
                  })
                  toggleDataset(d);
                  update(d);
              })


          // Merge enter and update selections.
          const datasetGroupsMerge = datasetGroupsEnter.merge(datasetGroups);
          // Update each group’s rect dimensions and center the text.
          datasetGroupsMerge.each(function (d) {
              let xs = [];
              let ys = [];
              // Offsets for dataset node (increase as needed)
              xs.push(d.y - 70, d.y + 70);
              ys.push(d.x - 60, d.x + 50);
              // Offsets for each dataview child (if any)
              if (d.children) {
                  d.children.forEach(child => {
                      if (child.data.type === "dataview") {
                          xs.push(child.y - 60, child.y + 60);
                          ys.push(child.x - 55, child.x + 45);
                      }
                  });
              }
              const minX = Math.min(...xs);
              const maxX = Math.max(...xs);
              const minY = Math.min(...ys);
              const maxY = Math.max(...ys);

              // Update the rectangle.
              d3.select(this).select("rect.dataset-bound")
                  .attr("x", minX)
                  .attr("y", minY)
                  .attr("width", maxX - minX)
                  .attr("height", maxY - minY);

              // Center the text in the bounding box.
              d3.select(this).select("text.dataset-bound-text")
                  .attr("x", minX + (maxX - minX) / 2)
                  .attr("y", minY + 12).raise();

              d3.select(this).select("image.dataset-bound-image")
                  .attr("x", maxX - 30)
                  .attr("y", minY + 7).raise();
          });

          datasetGroups.exit().remove();

          // Lower the dataset bounding groups behind other elements.
          container.selectAll("g.link-circles").lower();
          container.selectAll("g.cross-link-circles").lower();
          container.selectAll("g.indicator-group").raise();
          container.selectAll("g.dataset-bound-group").lower();

          // nodes.forEach(d => {
          //   d.x0 = d.x;
          //   d.y0 = d.y;
          // });



      }


      var overCircle = function (d, e, indicator) {

          console.log(d);
          const { sourceEdges1, targetEdges1, sourceEdgesForeign1, targetEdgesForeign1 } = getDatasetEdgesForMouseover(datasetConnections, e.data.id)
          switch (indicator) {
              case "leftIndicatorForeign":
                  d3.selectAll(".node").filter(data => !targetEdgesForeign1.has(data.data.id)).style("opacity", "0.1")
                  break;

              case "leftIndicator":
                  d3.selectAll(".node").filter(data => !targetEdges1.has(data.data.id)).style("opacity", "0.1")
                  break;


              case "rightIndicatorForeign":
                  d3.selectAll(".node").filter(data => !sourceEdgesForeign1.has(data.data.id)).style("opacity", "0.1")
                  break;


              case "rightIndicator":
                  d3.selectAll(".node").filter(data => !sourceEdges1.has(data.data.id)).style("opacity", "0.1")
                  break;


              default:
                  break;
          }
          d3.selectAll("path.cross-link").style("opacity", "0.1")
          d3.selectAll("path.link").style("opacity", "0.1")
          d3.selectAll("#dataset_node" + e.data.id).style("opacity", "1");


      };
      var outCircle = function () {
          d3.selectAll(".node").style("opacity", "1")
          d3.selectAll("path.cross-link").style("opacity", "1")
          d3.selectAll("path.link").style("opacity", "1")
      };
      function getDatasetEdges(edges, datasetId) {
          const sourceEdges = new Set();
          const sourceEdgesForeign = new Set();
          const targetEdges = new Set();
          const targetEdgesForeign = new Set();

          edges.forEach(edge => {
              if (edge.source === datasetId && !selectedDatasetIds.has(edge.target) && edge.connectionType == "primary") {
                  // When the dataset is the source, we store the target node.
                  sourceEdges.add(edge.target);
              }
              if (edge.source === datasetId && !selectedDatasetIds.has(edge.target) && edge.connectionType == "secondary") {
                  // When the dataset is the source, we store the target node.
                  sourceEdgesForeign.add(edge.target);
              }
              if (edge.target === datasetId && !selectedDatasetIds.has(edge.source) && edge.connectionType == "primary") {
                  // When the dataset is the target, we store the source node.
                  targetEdges.add(edge.source);
              }
              if (edge.target === datasetId && !selectedDatasetIds.has(edge.source) && edge.connectionType == "secondary") {
                  // When the dataset is the target, we store the source node.
                  targetEdgesForeign.add(edge.source);
              }
          });

          return { sourceEdges, targetEdges, sourceEdgesForeign, targetEdgesForeign };
      }


      // get edges for mouseover

      function getDatasetEdgesForMouseover(edges, datasetId) {
          const sourceEdges1 = new Set();
          const sourceEdgesForeign1 = new Set();
          const targetEdges1 = new Set();
          const targetEdgesForeign1 = new Set();

          edges.forEach(edge => {
              if (edge.source === datasetId && edge.connectionType == "primary") {
                  // When the dataset is the source, we store the target node.
                  sourceEdges1.add(edge.target);
              }
              if (edge.source === datasetId && edge.connectionType == "secondary") {
                  // When the dataset is the source, we store the target node.
                  sourceEdgesForeign1.add(edge.target);
              }
              if (edge.target === datasetId && edge.connectionType == "primary") {
                  // When the dataset is the target, we store the source node.
                  targetEdges1.add(edge.source);
              }
              if (edge.target === datasetId && edge.connectionType == "secondary") {
                  // When the dataset is the target, we store the source node.
                  targetEdgesForeign1.add(edge.source);
              }
          });

          return { sourceEdges1, targetEdges1, sourceEdgesForeign1, targetEdgesForeign1 };
      }

      function getCirclePosition(source, target, isSecondary) {
          if (source.parent && source.parent._isCollapsed && source._isCollapsed == null) {
              source = source.parent;
          }
          if ((target.data && (target.data.type === "dataset" || target.data.type === "dataview")) &&
              target.parent && target.parent._isCollapsed && target._isCollapsed == null) {
              target = target.parent;
          }

          let sourceY = source.y;
          let targetY = target.y;
          let targetX = target.x;

          // Adjust positions for both source and target based on node types
          // if (sourceY > targetY) {
          //   if (source.data && source.data.type == "dataset") {
          //     sourceY = source.y - 100;
          //   }
          //   if (target.data && target.data.type == "dataset") {
          //     targetY = target.y + 100;
          //   }
          //   if (source.data && source.data.type == "dataview" || source.data && source.data.type == "dataset" && source._isCollapsed == false) {
          //     sourceY = source.y - 50;
          //   }
          //   if (target.data && target.data.type == "dataview" || target.data && target.data.type == "dataset" && target._isCollapsed == false) {
          //     targetY = target.y + 50;
          //   }
          //   if (target.data.type !== "dataview" && target.data.type !== "dataset") {
          //     targetY = target.y + 15;
          //   }
          //   if (source.data.type !== "dataview" && source.data.type !== "dataset") {
          //     sourceY = source.y - 15;
          //   }
          // } else {
          if (source.data && source.data.type == "dataset") {
              sourceY = source.y + 100;
          }
          if (target.data && target.data.type == "dataset") {
              targetY = target.y - 100;
          }
          if (isSecondary && target.data && target.data.type == "dataset") {
              targetY = target.y + 100;
          }

          if (source.data && source.data.type == "dataview" || source.data && source.data.type == "dataset" && source._isCollapsed == false) {
              sourceY = source.y + 50;
          }
          if (target.data && target.data.type == "dataview" || target.data && target.data.type == "dataset" && target._isCollapsed == false) {
              targetY = target.y - 50;
          }
          if (isSecondary && target.data && target.data.type == "dataview" || target.data && target.data.type == "dataset" && target._isCollapsed == false) {
              targetY = target.y + 50;
          }
          if (target.data.type !== "dataview" && target.data.type !== "dataset") {
              targetY = target.y - 15;
          }
          if (source.data.type !== "dataview" && source.data.type !== "dataset") {
              sourceY = source.y + 15;
          }

          //   if (isSecondary && target.data && target.data.type == "dataview") {
          //     //   targetY = target.y + 50;
          //     targetY = target.y;
          //       if (source.x > target.x) {
          //           targetX = target.x + 20 + 3;
          //       } else {
          //           targetX = target.x - 20 - 3;
          //       }
          //   }
          // }

          if (isSecondary) {
              return {
                  source: { x: source.x - 15, y: sourceY + 3 },
                  target: { x: targetX + 15, y: targetY }
              };
          } else {
              return {
                  source: { x: source.x, y: sourceY + 3 },
                  target: { x: target.x, y: targetY - 3 }
              };
          }
          //   return {
          //     source: { x: source.x, y: sourceY },
          //     target: { x: target.x, y: targetY }
          //   };
      }

      function diagonal(s, d, isSecondary) {
          // Fallback to parent if collapsed
          if (s.parent && s.parent._isCollapsed && s._isCollapsed == null) {
              s = s.parent;
          }

          let sourceY = s.y;
          let targetY = d.y;
          let targetX = d.x;

          // Adjust for dataset nodes
          if (s.data && s.data.type === "dataset") {
              sourceY = s.y + 100;
          }
          if (d.data && d.data.type === "dataset") {
              targetY = d.y - 100;
          }
          if (isSecondary && d.data && d.data.type === "dataset") {
              targetY = d.y + 100;
          }

          // Adjust for expanded dataview or dataset
          if ((s.data && s.data.type === "dataview") || (s.data && s.data.type === "dataset" && s._isCollapsed === false)) {
              sourceY = s.y + 50;
          }
          if ((d.data && d.data.type === "dataview") || (d.data && d.data.type === "dataset" && d._isCollapsed === false)) {
              targetY = d.y - 50;
          }
          if (isSecondary && (d.data && d.data.type === "dataview") || (d.data && d.data.type === "dataset" && d._isCollapsed === false)) {
              targetY = d.y + 50;
          }

          

          // Calculate middle Y for straight links
          const midY = Math.max(sourceY, targetY) +  70;

          // Curved vs polyline vs straight secondary link
          if (useCurvedLinks && isSecondary) {
              return `M ${sourceY} ${s.x - 15}
            C ${(sourceY + targetY) / 2} ${s.x - 15},
              ${(sourceY + targetY) / 2} ${targetX + 15},
              ${targetY} ${targetX + 15}`;
          } else if (useCurvedLinks && !isSecondary) {
              return `M ${sourceY} ${s.x}
            C ${(sourceY + targetY) / 2} ${s.x},
              ${(sourceY + targetY) / 2} ${d.x},
              ${targetY} ${d.x}`;
          } else if (isSecondary) {
              return `M${sourceY},${s.x - 15} 
            L${midY},${s.x - 15} 
            L${midY},${targetX + 15} 
            L${targetY},${targetX + 15}`;
          } else {
              return `M${sourceY},${s.x} 
            L${(sourceY + targetY) / 2},${s.x} 
            L${(sourceY + targetY) / 2},${d.x} 
            L${targetY},${d.x}`;
          }
      }

      function gettranslate(s, d, isSecondary) {
          // Fallback to parent if collapsed
          if (s.parent && s.parent._isCollapsed && s._isCollapsed == null) {
              s = s.parent;
          }

          let sourceY = s.y;
          let targetY = d.y;
          let targetX = d.x;

          // Adjust for dataset nodes
          if (s.data && s.data.type === "dataset") {
              sourceY = s.y + 100;
          }
          if (d.data && d.data.type === "dataset") {
              targetY = d.y - 100;
          }
          if (isSecondary && d.data && d.data.type === "dataset") {
              targetY = d.y + 100;
          }

          // Adjust for expanded dataview or dataset
          if ((s.data && s.data.type === "dataview") || (s.data && s.data.type === "dataset" && s._isCollapsed === false)) {
              sourceY = s.y + 50;
          }
          if ((d.data && d.data.type === "dataview") || (d.data && d.data.type === "dataset" && d._isCollapsed === false)) {
              targetY = d.y - 50;
          }
          if (isSecondary && (d.data && d.data.type === "dataview") || (d.data && d.data.type === "dataset" && d._isCollapsed === false)) {
              targetY = d.y + 50;
          }

          // Compute midpoint and rotation angle
          let midX, midY, angle;
          if (useCurvedLinks && isSecondary) {
              midX = ((s.x + 15) + targetX) / 2;
              midY = (sourceY + targetY) / 2;
              angle = Math.atan2(targetX - (s.x + 15), targetY - sourceY) * 180 / Math.PI;
          } else if (useCurvedLinks && !isSecondary) {
              midX = (s.x + d.x) / 2;
              midY = (sourceY + targetY) / 2;
              angle = Math.atan2(d.x - s.x, targetY - sourceY) * 180 / Math.PI;
          } else if (isSecondary) {
              midX = ((s.x + 15) + targetX) / 2;
              midY = Math.max(sourceY, targetY) +  70;
              angle = Math.atan2(targetX - (s.x + 15), targetY - sourceY) * 180 / Math.PI;
          } else {
              midX = (s.x + d.x) / 2;
              midY = (sourceY + targetY) / 2;
              angle = Math.atan2(d.x - s.x, targetY - sourceY) * 180 / Math.PI;
          }

          if (!useCurvedLinks) {
              if (angle && angle > 0 && angle < 180) {
                  angle = 90;
              } else if (angle == 180) {
                  angle = 180;
              }
              else if (angle == 0) {
                  angle = 0;
              }
              else {
                  angle = 270;
              }
          }

          return `translate(${midY},${midX}) rotate(${angle})`;
      }


    onMounted(() => {
      InitializeSvg();
      addDatasetActionList();
      drawTree();
      updateDegreeCount();
    });

    return { 
      tree,
      openOverlay,
      itemId,
      isDrawerOpen,
      closeOverlay,
      dataShowInDrawer,
     };
  }
});
</script>

<style>
  .node circle,
    .node rect {
      stroke: #a4c2e0;
      stroke-width: 1px;
    }

    .node text {
      font: 12px sans-serif;
    }

    .link {
      fill: none;
      stroke-width: 1px;
    }

    .para{
  font-size: 15px !important;
  display: flex;
  gap: 10%;
    }

.card {
  border-bottom: 1.4px solid #605f5f;
  display: none;
}

.infoPanel {
  width: 23vw;
  height: 100vh;
  border-left: 1.4px solid #605f5f;

}

.closeBtn {
  position: absolute;
  right: 0;
}

.heading {
  font-weight: 550;
  width: 40px;
}
.customWidth{
  max-width: 80%;
  font-size: 15px !important;
  word-wrap: break-word;
}
.datasetList{
  position: fixed;
  top: 14vh;
  right: 5vw;
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 250px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 5px;
  border-radius: 8px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  /* text-align: center; */
  height: 80vh;
  overflow-y: auto;

}

.actionButtons{
  position: fixed;
  top: 43vh;
  left: 27vw;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 80px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 5px;
  border-radius: 8px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2)
}
.dataset-item {
      margin: 4px 0;
    }
    
    .plus-button {
  color: green;
  cursor: pointer;
  font-weight: bold;
  margin-right: 5px;
  user-select: none;
  opacity: 0; /* Hidden by default */
  float: right;
  transition: opacity 0.3s ease-in-out, color 0.3s ease-in-out;
  padding: 0px 5px; /* Adds space around the plus sign */
  border: 1px solid green; /* Border around the button */
  border-radius: 50px; /* Rounded corners */
}
.dataset-item:hover .plus-button{
  opacity: 1;
}

    .indicator-text {
      font: 10px sans-serif;
      fill: #fff;
      text-anchor: middle;
      dominant-baseline: central;
      pointer-events: none;
    }

</style>
